export const jp = {
    app: {
      home: 'ホーム',
      playerScout: "選手の検索",
      playerComparison: "選手の比較",
      playerRecruitment: '選手募集',
      collections: "コレクション",
      favoritePlayers: 'お気に入りの選手',
      teamAnalytics: 'チームの分析',
      gameAnalysis: '試合の分析',
      seasonStats: 'シーズン',
      leagueTable: '順位表',
      scoresAndFixtures: '結果',
      notifications: '通知',
      administration: '管理',
      inbox: "受信箱",
      teamStats: "チームスタッツ",
      blog:"ブログ",
      leagues:"リーグ",
      squadBuilder: "チーム作成者",
      playerAlerts:"検索の通知",
      searchAlerts:"検索アラート",
      videoUploadTool:"動画アップロードツール",
      videoPlaylists: "Playlists",
      uploadedGames:"試合映像",
      favoriteTeams:"Favorite Teams"
    },
    playerRecruitment: {
      title: "選手シート",
      subtitle: "選手の特徴や統計情報を詳しく見ることができます",
      league: "リーグ",
      selectedSeason: "シーズン選択",
      year: "年",
      radar: "レーダーチャート",
      positions: "ポジション",
      numberOfPlayers: "選手数",
      template: "テンプレート",
      compareWith: "〜と比較",
      previousPerformance: "前回までの成績",
      xGames: "{0} 試合",
      average: "平均",
      leagueAverage: "リーグ平均",
      selectSeason: "シーズンを選択",
      positionsPlayed: "プレーしたポジション",
      minMax: "最低と最高",
      top5Leagues: "5大リーグ",
      infoMessage: "最小値と最大値を有効にするためにシーズンを1つだけ選択してください。",
      infoMessage2: "どちらも同じシーズンを選択してください。",
      dataPer90MinText: "90分間のデータ",
      adjustToPossessionText: "ポゼッション調整",
      text: "テキスト",
      lollipop: "横棒グラフ",
      polar: 'ポーラーチャート',
      radarTemplates: {
        Goalkeeper: "ゴールキーパー",
        GoalkeeperCustom1: "ゴールキーパー カスタム 1",
        GoalkeeperCustom2: "ゴールキーパー カスタム 2",
        GoalkeeperCustom3: "ゴールキーパー カスタム 3",
        GoalkeeperCustom4: "ゴールキーパー カスタム 4",
        GoalkeeperCustom5: "ゴールキーパー カスタム 5",
        GoalkeeperCustom6: "ゴールキーパー カスタム 6",
        Defender: "ディフェンス",
        DefenderCustom1: "ディフェンス カスタム 1",
        DefenderCustom2: "ディフェンス カスタム 2",
        DefenderCustom3: "ディフェンス カスタム 3",
        DefenderCustom4: "ディフェンス カスタム 4",
        DefenderCustom5: "ディフェンス カスタム 5",
        DefenderCustom6: "ディフェンス カスタム 6",
        FullBack: "サイドバック",
        FullBackCustom1: "サイドバック カスタム 1",
        FullBackCustom2: "サイドバック カスタム 2",
        FullBackCustom3: "サイドバック カスタム 3",
        FullBackCustom4: "サイドバック カスタム 4",
        FullBackCustom5: "サイドバック カスタム 5",
        FullBackCustom6: "サイドバック カスタム 6",
        FullBackPredictive: "サイドバック",
        Midfielder: "ミッドフィールダー",
        MidfielderCustom1: "ミッドフィールダー カスタム 1",
        MidfielderCustom2: "ミッドフィールダー カスタム 2",
        MidfielderCustom3: "ミッドフィールダー カスタム 3",
        MidfielderCustom4: "ミッドフィールダー カスタム 4",
        MidfielderCustom5: "ミッドフィールダー カスタム 5",
        MidfielderCustom6: "ミッドフィールダー カスタム 6",
        MidfielderPredictive: "ミッドフィルダー",
        MidfielderDefensive: "守備的ミッドフィールダー",
        MidfielderOffensive: "攻撃的ミッドフィールダー",
        'AttackingMidfielder': 'トップ下',
        MidfielderWing: "インサイドハーフ",
        Winger: "ウインガー",
        WingerCustom1: "ウインガー カスタム 1",
        WingerCustom2: "ウインガー カスタム 2",
        WingerCustom3: "ウインガー カスタム 3",
        WingerCustom4: "ウインガー カスタム 4",
        WingerCustom5: "ウインガー カスタム 5",
        WingerCustom6: "ウインガー カスタム 6",
        WingerOffensive: "攻撃的ウインガー",
        Forward: "フォワード",
        ForwardCustom1: "フォワード カスタム 1",
        ForwardCustom2: "フォワード カスタム 2",
        ForwardCustom3: "フォワード カスタム 3",
        ForwardCustom4: "フォワード カスタム 4",
        ForwardCustom5: "フォワード カスタム 5",
        ForwardCustom6: "フォワード カスタム 6",
        ForwardPredictive: "フォワード",
        WingBack: "ウイングバック",
        WingBackCustom1: "ウイングバック カスタム 1",
        WingBackCustom2: "ウイングバック カスタム 2",
        WingBackCustom3: "ウイングバック カスタム 3",
        WingBackCustom4: "ウイングバック カスタム 4",
        WingBackCustom5: "ウイングバック カスタム 5",
        WingBackCustom6: "ウイングバック カスタム 6",
        WingBackMedia: "ウイングバック (SocialMedia)",
        FullBackMedia: "サイドバック (SocialMedia)",
        MidfielderMedia: "ミッドフィールダー (SocialMedia)",
        WingerMedia: "ウインガー (SocialMedia)",
        ForwardMedia: "フォワード(SocialMedia)",
        PhysicalWingBack: "フィジカルが強いウイングバック",
        PhysicalForward: "フィジカルが強いフォワード",
        PhysicalWinger: "フィジカルが強いウインガー",
        PhysicalMidfielder: "フィジカルが強いミッドフィールダー",
        PhysicalFullBack: "フィジカルが強いサイドバック",
        PhysicalDefender: "フィジカルが強いデフェンス",
        PhysicalWingBackLMO: "フィジカルが強いウイングバック",
        PhysicalForwardLMO: "フィジカルが強いフォワード",
        PhysicalWingerLMO: "フィジカルが強いウインガー",
        PhysicalMidfielderLMO: "フィジカルが強いミッドフィールダー",
        PhysicalFullBackLMO: "フィジカルが強いサイドバック",
        PhysicalDefenderLMO: "フィジカルが強いデフェンス",
      },
      radarTemplatesWomen: {
        Goalkeeper: "ゴールキーパー",
        Defender: "ディフェンス",
        FullBack: "サイドバック",
        FullBackPredictive: "サイドバック",
        Midfielder: "ミッドフィールダー",
        MidfielderPredictive: "ミッドフィールダー",
        MidfielderDefensive: "守備的ミッドフィールダー",
        MidfielderOffensive: "攻撃的ミッドフィールダー",
        'AttackingMidfielder': 'トップ下',
        MidfielderWing: "インサイドハーフ",
        Winger: "ウインガー",
        WingerOffensive: "攻撃的ウインガー",
        Forward: "フォワード",
        ForwardPredictive: "フォワード",
        WingBack: "ウイングバック",
        WingBackMedia: "ウイングバック (SocialMedia)",
        FullBackMedia: "サイドバック (SocialMedia)",
        MidfielderMedia: "ミッドフィールダー (SocialMedia)",
        WingerMedia: "ウインガー (SocialMedia)",
        ForwardMedia: "フォワード (SocialMedia)",
        PhysicalWingBack: "フィジカルが強いウイングバック",
        PhysicalForward: "フィジカルが強いフォワード",
        PhysicalWinger: "フィジカルが強いウインガー",
        PhysicalMidfielder: "フィジカルが強いミッドフィールダー",
        PhysicalFullBack: "フィジカルが強いサイドバック",
        PhysicalDefender: "フィジカルが強いデフェンス",
        PhysicalWingBackLMO: "フィジカルが強いウイングバック",
        PhysicalForwardLMO: "フィジカルが強いフォワード",
        PhysicalWingerLMO: "フィジカルが強いウインガー",
        PhysicalMidfielderLMO: "フィジカルが強いミッドフィールダー",
        PhysicalFullBackLMO: "フィジカルが強いサイドバック",
        PhysicalDefenderLMO: "フィジカルが強いデフェンス",
      },
      radarDescription: {
        basicStatistics: {
          title: "基本統計",
          minutes: "時間",
          goals: "ゴール",
          assists: "アシスト",
          redCards: "レッドカード",
          yellowCards: "イエローカード",
          games: "試合",
          goalsReceived: "PKを除く被ゴール数",
          xGFaced: "被ゴール期待値"
        },
        //Inside, Ids of Profiles
        profiles: {
          //GoalKeeperBallPlaying
          3: {
            1: "ショートパスとロングパスを正確に蹴れる足元の技術のあるゴールキーパー。",
            2: "ショートパスとロングパスの成功率が高い。足元の技術に優れ、ビルドアップできるゴールキーパー",
            3: "パスの成功率の高い、足元に技術のあるゴールキーパー。",
            4: "自陣から相手のフィールドまでパスで目立つゴールキーパー。",
            5: "パスに優れ、足元のボール扱いが正確なゴールキーパー。",
            6: "長短のパスの成功率の高く、足元の技術に優れ、ビルドアップに参加できるゴールキーパー。",
            7: "ショートパスとロングパスの両方で高い成功率を持ち、足元の技術に優れたゴールキーパー。",
          },
          //DefenderBallWinning
          5: {
            1: "一対一でうまく立ち回り、タックルやインターセプトの回数が多いのが特徴のディフェンダー。",
            2: "タックル、デュエルに強く、相手の動きの予測に優れたセンターバック。",
            3: "デュエルに強く、多くのボール奪取をすることが可能なセンターバック。",
            4: "守備レベルが高い選手。 タックルとインターセプトで大量のボールを奪える。",
            5: "タックルが非常に強く一対一で目立つ。多くのインターセプトを生み出すディフェンダー。",
            6: "タックルの精度と頻度が高く、相手の試合を読んでカットするのが得意。 ゲームあたりのボール奪取数が多いセンターバック。",
            7: "タックルでの有効性と頻度、および優れた予測力によって、高レベルでのボール奪取が特徴のディフェンダー。",
          },
          //DefenderBallPlaying
          6: {
            1: "試合を読む力とチャンスを生み出すことに大きく貢献するディフェンダー",
          },
          //FullBackMix
          7: {
            1: "攻撃（xG の構築に大きく貢献）と守備（多くのボール奪取）の間でバランスの取れたパフォーマンスを持つ選手。",
          },
          //FullBackDefensive
          8: {
            1: "タックルとインターセプトの両方での高いボール奪取数、1対1での堅実なディフェンス。",
          },
          //FullBackOffensive
          9: {
            1: "守備面では苦労するが、攻撃面では危険なアクションを生み出し貢献度が高いプレーヤー。",
          },
          //MidfielderBoxToBox
          10: {
            1: "多くのピッチをカバーしボールを回収できるだけでなく、チームの xG 構築に大きく貢献できるプレーヤー。",
          },
          //MidfielderBallWinning
          11: {
            1: "攻撃での影響力は少ないが、高い守備能力とパスの有効性が高いミッドフィールダー。",
          },
          //MidfielderHolding
          12: {
            1: "多数のインターセプトとタックルを行い、空中戦に強く、チャンスも演出する。多大な影響力を持つ完成されたミッドフィールダー。",
          },
          //WingerClassic
          15: {
            1: "シュートよりもアシストを期待される、1対1のスキルと優れたレベルのクロスを備えたウィンガー。",
          },
          //WingerWide
          16: {
            1: "多くのスルーパスを提供しボール前に進めチャンスを生み出す。外よりも中央でのポゼッションに影響を与えるプレーヤー。",
          },
          //WingerInside
          17: {
            1: "優れたドリブルスキルを持ち、アウトサイドからインに切り込み、キーパス (xA) よりも多くのシュート (xG) を生み出すサッカー選手。",
          },
          //ForwardPressing
          18: {
            1: "前線からのプレッシャーによりそれがインターセプトに繋がるため、ボールが無くても評価が高いフォワード。",
          },
          //ForwardMobile
          22: {
            1: "スルーパスを受けたり外に開いたりし、よく動いて得点チャンスを生み出すフォワード。 ゲームごとの合計タッチ数では、ボックス外のタッチの割合が高い。",
          },
        },
        description: "記述",
        //Words
        conjuction: " と ",
        //Just for stats starts with I (i.e -> Interceptions)
        conjuction2: " と ",
        over: "の上に",
        under: "の下に",
        respectively: "それぞれ",
        //Categories and quintiles description
        Defending1: {
          1: "彼の守備のパフォーマンスは、5大リーグで最低レベルです。",
        },
        Defending2: {
          1: "彼のパフォーマンスは平均を下回っているため、守備では良い役割を果たしていない。",
        },
        Defending3: {
          1: "彼のレベルは平均より少しover_under_average。防御面では良い役割を果たしています。",
        },
        Defending4: {
          1: "守備面では平均以上のパフォーマンスを備え優れた仕事をする。",
        },
        Defending5: {
          1: "守備的タスクに優れ、5大リーグの　los player_positionsで80%より上のパフォーマンス。",
        },
        Saving1: {
          1: "パフォーマンスが非常に低く、ボールを止めるのに多くの困難を伴うゴールキーパー。",
        },
        Saving2: {
          1: "彼のレベルは平均以下なので、彼はゴールキーパーとして良い役割を果たしていない。",
        },
        Saving3: {
          1: "彼は平均よりわずかに over_under_average であり、metric_name を改善する必要があります。ゴールキーパーとしてのパフォーマンスは許容範囲内です。",
        },
        Saving4: {
          1: "5大リーグの平均を上回る優れたレベルのゴールキーパーで、特に metric_name で際立っています。",
        },
        Saving5: {
          1: "彼は非常に完成度の高い選手であり、ヨーロッパの5大リーグのゴールキーパーと比較して、彼のすべての指標は上位20%以内に位置しています。",
        },
        Passing1: {
          1: "ボールの扱いに置いて、彼は最低レベルです。",
        },
        Passing2: {
          1: "パスに関しては、彼のパフォーマンスは平均を下回っています。",
        },
        Passing3: {
          1: "彼のパスのレベルは許容範囲で、平均よりわずかに over_under_averageです。",
        },
        Passing4: {
          1: "この面で非常に優れたレベルのパサーで、平均をはるかに上回っています。",
        },
        Passing5: {
          1: "ほとんどのプレーヤーよりも高いパフォーマンスで効果的なパスをします。",
        },
        Aerial1: {
          1: "空中戦では非常に弱いプレーヤーであり、この点で彼のポジションでは最悪のプレーヤーです。",
        },
        Aerial2: {
          1: "空中戦に関しては、この選手の成績は悪く平均以下です。",
        },
        Aerial3: {
          1: "空中戦で許容できるレベル、平均より少し over_under_averageです。",
        },
        Aerial4: {
          1: "空中戦で優れたパフォーマンスを発揮し、この面で高い効果を発揮します",
        },
        Aerial5: {
          1: "空中戦での彼の指標はトップクラスです",
        },
        Shooting1: {
          1: "シュート精度の統計結果は非常に悪く、この面においては最底の選手です。",
        },
        Shooting2: {
          1: "シュートのレベルはとても改善の余地あり、平均を下回っています。",
        },
        Shooting3: {
          1: "攻撃的なタスクで許容できるパフォーマンス、平均よりわずかに over_under_average。",
        },
        Shooting4: {
          1: "彼はこの分野で非常に優れた能力を発揮し、60%のプレイヤーより上のパフォーマンスを達成しています。",
        },
        Shooting5: {
          1: "攻撃的なタスクでの優れたスキルと素晴らしいパフォーマンスで、この点では彼を最高の選手です。",
        },
        Association1: {
          1: "＊彼のボールキープに関するパフォーマンスは非常に低く、5大リーグの中で最悪の部類に入ります。",
        },
        Association2: {
          1: "彼はこの点で平均的なパフォーマンスを下回っているため、ボールキープに置いて改善することがたくさんあります",
        },
        Association3: {
          1: "ボールキープがうまく、平均よりわずかに over_under_averageです。",
        },
        Association4: {
          1: "ボールキープが抜群で、素晴らしいレベルです。",
        },
        Association5: {
          1: "足元でのボールキープする技術は並外れている、この点で最高クラスの選手です。",
        },
        BallHandling1: {
          1: "＊5大リーグの選手の中でボール扱いは最低レベルです。",
        },
        BallHandling2: {
          1: "ボール扱いに関しては、彼のレベルは平均以下です。",
        },
        BallHandling3: {
          1: "ボール扱いは許容レベル、平均よりわずかに over_under_average",
        },
        BallHandling4: {
          1: "ボール扱いのレベルが高く、この点では最高に近い数字です。",
        },
        BallHandling5: {
          1: "5大リーグの中でもトップクラスのボールを扱う能力です。",
        },
        Crosses1: {
          1: "ボールをペナルティーエリア内にクロスするパフォーマンスのレベルは低く、 彼の指標は最底クラスです。",
        },
        Crosses2: {
          1: "クロスで危険を生み出すパフォーマンスは平均以下です。",
        },
        Crosses3: {
          1: "ペナルティーエリアにクロスを送る精度は許容できるレベルですが、改善の余地があり。平均より少し over_under_average です。",
        },
        Crosses4: {
          1: "ボールをクロスすることに関しては、平均よりもはるかに優れた統計結果です。",
        },
        Crosses5: {
          1: "クロス上げることに関しては最高のプレーヤーです。具体的には最も効果的な上位 20% に入ります。",
        },
        Carries1: {
          1: "ボールを運ぶという点で最底の数値。下位20%の選手です。",
        },
        Carries2: {
          1: "ボールをキープし運ぶ点に置いて彼のパフォーマンスは、同ポジションの選手の平均からはほど遠いです。",
        },
        Carries3: {
          1: "ボール運ぶことに関しては、平均に近いパフォーマンス。わずかにover_under_average",
        },
        Carries4: {
          1: "非常に優れた数値でボール運びを備えた注目すべきプレーヤーです。",
        },
        Carries5: {
          1: "ボールを運ぶのに非常に才能のあるプレーヤー。ドリブルのカテゴリーの指標で高いパフォーマンスを発揮します。",
        },
        Turnovers1: {
          1: "そのパフォーマンスは非常に否定的であり、危険を助長する大量のボールロストがあります。この指標で最底の部類です。",
        },
        Turnovers2: {
          1: "彼は多くの危険なボールロストで対戦相手に利益をもたらします。多くを改善し、ロストを減らす必要があります。",
        },
        Turnovers3: {
          1: "このプレーヤーはボールロストに関して平均よりわずかに over_under_average であるため、パフォーマンスはまだ向上する必要があります。",
        },
        Turnovers4: {
          1: "ボールロストに関してのパフォーマンスは良い。60%の選手よりボールを失うことが少ないです。",
        },
        Turnovers5: {
          1: "彼がボールを失う少なさは注目に値します。これにより、彼はチームのポゼッションを維持する最高の選手の1人です。",
        },
        SequenceInvolvement1: {
          1: "ボールのキープに関しての数値は悪いです。シュートでアクションを終了することは滅多にありません。",
        },
        SequenceInvolvement2: {
          1: "最後のキープはかなり改善する余地があり。彼はシュートでほとんど終われず、平均をはるかに下回っています。",
        },
        SequenceInvolvement3: {
          1: "ゴール前での最後のキープ関しては許容できるレベル。平均をわずかに over_under_average であり、改善の可能性が非常に高い。",
        },
        SequenceInvolvement4: {
          1: "チームのポゼッションをシュートで終わらせる優れた能力、そのいくつかはゴールになる。このカテゴリーで素晴らしいパフォーマンスを発揮します。",
        },
        SequenceInvolvement5: {
          1: "チームのポゼッションを実現することに関しては最高の選手の一人であり、危険なシュートでそれらを仕上げます。",
        },
        Physical1:{
          1: "身体能力はトップ5リーグの選手と比べて最低レベル",
        },
        Physical2:{
          1: "身体能力に関しては平均以下",
        },
        Physical3:{
          1: "身体能力は平均をやや上回る、もしくは下回る",
        },
        Physical4:{
          1: "身体能力は高水準で、数値はベストに近い",
        },
        Physical5:{
          1: "卓越した身体能力を持ち、5大リーグで最高のレベルにある",
        }, 
        //Highlight metrics description
        OverMaxValue: {
          1: "over_max_metric_nameで極端なスキルを持ち、最大値を超えるパフォーマンス。 " +
            "その点でこの選手を5大リーグの上位 10% にランク付けする。",
        },
        OverAverageSeason: {
          1: "over_average_metric_name での彼のパフォーマンスに関して、彼はリーグ League_name の平均を上回っています。(over_average_metric_value frente a average_metric_value) ",
          2: "彼の数値をリーグ League_name の数値と比較すると、over_average_metric_name で、それらのパフォーマンスは平均を上回っています。(over_average_metric_value frente a average_metric_value) ",
        },
        UnderMinValue: {
          1: " under_min_metric_nameについては、5大リーグの中で最も低い percent_metric_name にランクされているため、パフォーマンスを大幅に改善する必要があります。",
        },
        Over70Percent: {
          1: "over_70_metric_name で際立っており、90分あたり con over_70_metric_value でした。",
          2: "over_70_metric_name で70％以上で、90分あたり over_70_metric_value でした。",
          3: "over_70_metric_name で目覚ましい仕事をしており、90分あたり over_70_metric_value でした。",
        },
        Under30Percent: {
          1: "90分あたり under_30_metric_value とパフォーマンスが低いため、 under_30_metric_name にもっと力を入れなければなりません。",
          2: "90分あたり under_30_metric_value で、パフォーマンスは期待を下回っているため、under_30_metric_name で大幅に改善する必要があります。",
          3: "under_30_metric_name に関しては、90分あたり under_30_metric_value por 90 minutos であり、彼はより良い数を得るためにもっと努力しなければなりません。",
        },
        OverAverageSeasonMoreThanOne: {
          1: "リーグ　league_name en　平均を上回るパフォーマンスは注目に値する。 ",
        },
        OverAverageStats: {
          1: " over_average_metric_name (平均 average_metric_value に対して over_average_metric_value)",
        },
        Over70PercentIndividualPressure: {
          1: "ボールを取り戻すときに非常に良いプレッシャーをかける。",
          2: "ボールを取り戻すために相手に高いプレッシャーをかける.",
        },
        Under30PercentIndividualPressure: {
          1: "ボールを奪うためにプレッシャーをさらに強めなければならない。",
          2: "相手にプレッシャーをかけるという点でより多くの努力をしなければならない。",
        },
      },
      himSelf:"彼自身",
      ownSeason: "自身のシーズン",
      minMaxTooltip:"検索の最小値と最大値を調整します。"
    },
    login: {
      login: 'ログイン',
      latestBlogPosts: '最新の投稿',
      signIn: 'サインイン',
      username: 'ユーザーネーム',
      password: 'パスワード',
      passwordForgotten: 'パスワードを忘れた',
      signUp: '登録する',
      enter: "入力",
      forceTitle: "使用中のアカウント",
      forceMessage: "アカウントは別のデバイスで使用されています。 このデバイスに切り替えますか?",
      forgotMyPassword: "パスワードを忘れた",
      firstLogin: "最初のアクセス",
      firstLoginMessage: "アプリケーションで表示する言語に加えて、セキュリティ上の理由から、最初のアクセス時に新しいパスワードを割り当てる必要があります。",
      firstLoginOverview: "ここでは、あなたのアカウント、あなたがアクセスできるリーグと商品の概要を説明します。",
      passwordConfirmation: "パスワードの確認",
      forgotPasswordMessage: "メールを書いてください。有効なアカウントである場合は、メールでパスワードを回復するための次の手順を受け取ります。",
      resetPassword: "パスワードをリセットする。",
      skipSettings: "設定をスキップする",
      contact: "連絡先",
      cookiesText: "このサイトは、Google のクッキーを使用してサービスを提供し、トラフィックを分析してサービスの品質を確保し、利用統計を作成し、不正行為を検出して対処します。",
      contactUs: "お問い合わせ",
      newsTitle: "新機能：新しいテンプレート！",
      newsText: "Radar、Stats、Seasonのテンプレートをアップデートし、より自由なカスタマイズと管理が可能になりました。テンプレートは作成・編集・整理でき、公開・非公開・監視付きのいずれかを選べます。さらに、統計とシーズンのテンプレートにより、ニーズに合わせたより正確な選択でワークフローを最適化できます。サイドバーのテンプレートセクションで新機能をチェック!"      
    },
    settings: {
      pageSubtitle: 'driblabの設定を編集する',
      language: '言語',
      availableLeagues: '利用可能なリーグ',
      availableProducts: '利用可能な製品',
      organization: "組織",
      changePassword:"パスワードの変更",
      seasonTemplates:"シーズンテンプレート",
      seasonTemplatesSubtitle:"シーズンテンプレートを作成します。その後、選手のパフォーマンスと選手の検索で選択できます。",
      templateName:"テンプレートネーム",
      selectTemplate:"編集するテンプレートを選択する",
      radarDefault:"欠点で検索",
      default: 'デフォルト',
      tabs: {
        options: "オプション",
        templates: "テンプレート",
        availableLeagues: "利用可能なリーグ",
        contactData: "連絡先情報 GBE"
      },
      contactData: {
        userDetails: "ユーザーデータ",
        firstName: "名前",
        lastName: "苗字",
        contactDetails: "連絡先情報",
        name: "名前",
        phone: "電話番号",
        mobile: "携帯電話番号",
        email: "Eメール",
        representativeDetails: "代表者情報",
      },
      currency: "通貨",
      fieldPreferences: "フィールド選択",
      visualizationsPreferences: "可視化選択",
      fieldColor:"フィールドの色",
      fieldColors:{
        green:"緑",
        blue:"青",
        white:"白",
        black:"黒",
        grey:"グレー"
      },
      defaultPlayerVisualization:"選手能力グラフの表示",
      appPreferences:"アプリケーション設定",
      darkMode:"ダークモード",
      showTour: "ガイドツアーを表示",
      customStats:"カスタマイズされた統計",
      radarTemplates: "検索のテンプレート",
      radarTemplatesSubtitle: "統計テンプレートを作成します。その後、選手のパフォーマンスと選手のランキングで選択できます。",
      radarCategories:{
        Custom1: "カスタム 1",
        Custom2: "カスタム 2",
        Custom3: "カスタム 3",
        Custom4: "カスタム 4",
        Custom5: "カスタム 5",
        Custom6: "カスタム 6",
        Physical: "フィジカル",
        CustomPhysical1: "カスタム フィジカル 1",
        CustomPhysical2: "カスタム フィジカル 2",
        CustomPhysical3: "カスタム フィジカル 3",
        CustomPhysical4: "カスタム フィジカル 4",
        CustomPhysical5: "カスタム フィジカル 5",
        CustomPhysical6: "カスタム フィジカル 6",
      },
      templateRemoveTitle:"検索を削除",
      templateRemoveMsg: "本当にこの検索を削除しますか?",
      templateEditTitle: "テンプレートの保存",
      templateEditMsg: "未保存のテンプレートがありますが、編集のために別のテンプレートを読み込む前に保存しますか？",
      category:"カテゴリー",
      playerRadar:"選手の検索",
      teamRadar:"チームの検索",
      statsAlert:"保存する統計を少なくとも 1 つ挿入してください。",
      recommended: "おすすめ",
      warning: "レーダーの数が上限に達しているポジションがあります。テンプレートを削除または編集してください。",
      fieldPositions: {
        default: "Driblab",
        fifa: "FIFA",
        spanish: "スペイン語",
        numeric: "数値"
      },
      showMediaMode: 'メディアモードの表示',
      statTemplates: "ゲーム統計テンプレート",
      statTemplatesSubtitle: "多数のメトリクスから選択し、独自のテンプレートを作成する。",
    },
    playerDetail: {
      passport: 'パスポート',
      secondPassport: '２つ目のパスポート',
      age: '年齢',
      dateOfBirth: '生年月日',
      height: '身長',
      weight: '体重',
      wage: '給料',
      history: '経歴',
      positions: 'ポジション',
      injuries: '怪我',
      transfers: '移籍',
      nationalTeam: '代表',
      addFavorite: "お気に入りに追加",
      removeFavorite: "お気に入りから除外",
      contractEnd: "契約終了",
      yearsOld: "歳",
      playerAvailability: "使用可能",
      playerUsage: "プレーした時間",
      usage: "利用法",
      addToCollection: "コレクションに追加",
      performance: "パフォーマンス",
      info: "情報",
      career: "キャリア",
      playerStyle: "プレースタイル",
      radar: "検索",
      finishingMap: "決定率",
      threatMap: "危険性",
      keyPassMap: "キーパス",
      beeswarm: "ランキング",
      allGames: "試合",
      eventsMap: "イベント",
      fullName: "フルネーム",
      academy: "アカデミー",
      name: "名前",
      lastName: "苗字",
      playerAvailabilityLong: "シーズンでの怪我や出場停止のない試合の割合",
      playerUsageLong: "出場時間",
      playerAvailability1: "怪我や出場停止のない試合",
      playerAvailability2: "今シーズンの試合数",
      playerUsage1: "出場時間",
      playerUsage2: "チーム総出場時間",
      notMinutesThisSeason: "今季は出場機会なし",
      seasonPlaceholder: "アクティブシーズンはありません",
      inactivePlayer: "非活動な選手",
      inactivePlayerMessage: "さらに詳しい情報が必要な場合は、レポートをリクエストできます。",
      goRequest:"申し込む。",
      warningMinutes: "注意！プレイ時間は450分未満です。分析結果は信憑性を欠く可能性があります。",
      warningSeasonGames: "5試合未満のシーズン、5大リーグの最小値と最大値。",
      warningStatsRemoved: '一部の統計データは、選択したシーズンでは利用できないため表示されていません。',
      warningBeeswarm: "選択したシーズンのデータがないため、プレイヤーは表示されません。",
      warningPlayersZeroValue: "{x}人の0の選手を表示しない ",
      onlyPlayersThatFit: "検索テンプレートに適合するプレイヤーのみ",
      gamesPlayedNotEnough: "試合数が不足しているため、オプションが無効になっています",
      gbe: "GBE",
      analysis:"分析",
      documents:"書類",
      rankDefensive:"守備",
      rankBallHandling:"ボールの動き",
      rankGoal:"ゴールへの貢献",
      rankXt:"危険性",
      rankIndex:"インデックス",
      visitHistory: "アクセス履歴",
      placer:"フィールド",
      touchesMap:"タッチマップ",
      heatMap:"ヒートマップ",
      ageProfile:"年齢グラフ",
      strongFoot:"利き足",
      player: '選手',
      outOf: '外',
      in: '中',
      careerTable: {
        nationalTeamCareer: "代表チームの経歴",
        nationalTeamCompetitions: "代表チームの大会"
      },
      physicalProgression:"Physical Progression",
      gpi: "グローバルプレイヤーインデックス",
      warningGPI: "過去30日間にELOリーグでプレーした選手のみ利用可能",
      diffGPI: "前回の試合からの変動",
      rankingInTheWorld: "世界で#{0}位",
      rankingInTheLeague: "{1}で#{0}位",
      max: "最大",
      gpiChart: "過去{0}試合のグローバル・プレーヤー・インデックスの値に基づくチャート"
    },
    finishingMap: {
      typesOfShot: "シュートの種類",
      shotStrategy: "戦略",
      areas: "エリア",
      bodyPart: "体の部分",
      more: "より多く",
      selectAll: "すべて選択",
      minutes: "時間",
      circles: "円",
      boxes: "ボックス",
      lines: "ライン",
      games: "試合",
      perShot: "シュートあたり",
      goal: "ゴール",
      missedShot: "枠外シュート",
      savedShot: "セーブしたシュート",
      shotOnPost: "バー、ポスト",
      missedChance: "逃したチャンス",
      openPlay: "インゲーム",
      regularPlay: "プレー中",
      fastBreak: "　カウンター中",
      individualPlay: "個人プレー中",
      setPiece: "セットプレー",
      fromCorner: "コーナーキックから",
      freeKick: "フリーキック",
      indirectFreeKick: "関節フリーキック",
      throwInSetPiece: "スローインから",
      inBox: 'ペナルティーエリア内',
      goalArea: 'ゴールエリア',
      boxLeft: 'ペナルティーエリア - 左側',
      boxCenter: 'ペナルティーエリア - 中央',
      boxRight: 'ペナルティーエリア - 右側',
      outOfBox: 'ペナルティーエリア外',
      outBoxDeepLeft: 'ペナルティーエリア外 - 左側深く',
      outBoxDeepRight: 'ペナルティーエリア外 - 右側深く',
      outBoxLeft: 'ペナルティーエリア外 - 左側',
      outBoxCentreLeft: 'ペナルティーエリア外 - 右側',
      outBoxCentre: 'ペナルティーエリア外 - 中央',
      outBoxCentreRight: 'ペナルティーエリア外 - 中央右側',
      outBoxRight: 'ペナルティーエリア外 - 右側',
      left35: '左 +35',
      centreLeft35: '中央左 +35',
      centre35: '中央 +35',
      centreRight35: '中央右 +35',
      right35: '右 +35',
      head: "ヘッド",
      rightFooted: "右足",
      leftFooted: "左足",
      otherBodyPart: "その他",
      chart: {
        shots: "シュート",
        xGPerShot: "シュートあたりの xG",
        exceptionTextPenaltyGoals: "* PK = 0.765 xG",
        exceptionTextGKPenaltyGoals: "* PK = 0.765 xGOT",
        exceptionTextOwnGoals: "* オウンゴールは数えません。",
        og: "オウンゴール",
        penaltiesExcluded: 'ペナルティゴールは除外',
        ownGoalsExcluded: 'オウンゴールを除く',
        sumOfxG: " xG の合計",
        exceptionShotsOutOfRange: "* 範囲外のシュートは表示されません"
      },
      inGoal: "枠内",
      outOfGoal: "枠外",
      highLeft: "左上",
      highCenter: "中央上",
      highRight: "右上",
      lowLeft: "左下",
      lowCenter: "中央下",
      lowRight: "右下",
      outHighLeft: "左上外れ",
      high: "中央上外れ",
      outHighRight: "右上外れ",
      closeHighLeft: "左上近く",
      closeHigh: "中央上近く",
      closeHighRight: "右上外れ",
      closeLeft: "左下近く",
      closeRight: "右下近く",
      finishingTable: "決定率表",
      onGoal: "枠内",
      distributionFilters: "配布フィルター",
      penalty: "ペナルティ",
      penaltyShootout: "PK戦",
      onlyPercentage: "パーセンテージを表示",
      showAll: "すべて表示"
    },
    keyPassMap: {
      chart: {
        keyPasses: "キーパス",
        xAPerPass: "パスあたりの xA ",
        xAOpenPlay: "インプレーの xA ",
        xASetPiece: "セットプレーの xA "
      }
    },
    beeswarm: {
      template: 'テンプレート',
      templates: {
        'Goalkeeper': 'ゴールキーパー',
        'Defender': 'ディフェンス',
        'Full-Back': 'サイドバック',
        'FullBack': 'サイドバック',
        'Wing-Back': 'ウイングバック',
        'WingBack': 'ウイングバック',
        'Midfielder': 'ミッドフィールダー',
        'AttackingMidfielder': 'トップ下',
        'Winger': 'ウイング',
        'Forward': 'ファワード',
        'Physical': 'フィジカル'
      },
      compareWith: "比較",
      highlightPlayersOf: "選手をマークする",
      highlightPlayers: "ハイライト選手",
      per90:"プレイ時間90分あたりのデータ",
      highlightTeams: "チームをハイライト",
      filterTeams: "チームをフィルター",
      warningZeros: "反転していないスタッツのみ対象"
    },
    collections: {
      newCollection: "新しいコレクション",
      editCollection: "コレクションを編集",
      name: "名前",
      visibility: "公開設定",
      privacity: {
        publicTitle: "公開タイトル",
        publicDescription: "あなたとあなたのクラブ全体に表示されます。",
        privateTitle: "プライベート",
        privateDescription: "あなたにのみ表示されます。",
      },
      addSuccess: "正常に追加されました。",
      createAddSuccess: "正常に作成および追加されました。",
      deleteSuccess: "正常に削除されました。",
      editSuccess: "正常に更新されました。",
      title: "選手のコレクション",
      publics: "公開",
      privates: "プライベート",
      supervised: "監修された",
      totalMarketValue: "総市場価値",
      avgMarketValue: "平均市場価値",
      avgAge: "平均年齢",
      searchBarPlaceholder: "コレクションに追加するプレーヤーを検索して選択します。",
      deleteCollection: "コレクションを削除。",
      deleteCollectionMessage: "コレクションが削除されます。 よろしいですか？",
      removePlayer: "選手を削除",
      removePlayerMessage: "選手が削除されます。 よろしいですか？",
      subtitle: "検索を整理する。",
      notExitingTemplate: 'テンプレートはまだない',
    },
    searchbar: {
      placeholder: "入力して検索 (例: `山田　太郎´)",
      players: "選手",
      teams: "チーム",
      games: "試合",
      leagues: "リーグ",
      explore: "さらに結果を調べる",
      placeholderNoResults: "テンプレートの結果はありません。",
      teamPlaceholder: "比較するチームを検索して選択する。",
    },
    favorites: {
      showOnly: "表示のみ",
      selfFavorites: "私のお気に入り",
      clubFavorites: "クラブのお気に入り",
      contractExpiration: "契約満了",
      groupBy: "のグループにまとめる。",
      noGrouped: "グループにしない",
      maxSelection: "最大",
      selectAtleastOne: "最低1つ選択してください。",
      comparePlayers: "選手を比較する。",
      selectedPlayers: "選択した",
      subtitle: "未来のスターを探し続ける",
      generateXlsx: "XLSX　作成",
      generating: "作成中．．．",
      subscribed: "Subscribed",
      subscribedTooltip:"Subscribe to recieve a mail when a game have been played"
    },
    expiration: {
      summer: "6月",
      winter: "12月"
    },
    positions: {
      goalkeepers: "ゴールキーパー",
      defenses: "ディフェンス",
      midfielders: "ミッドフィールダー",
      goalkeeper: "ゴールキーパー",
      defender: "ディフェンス",
      defenders: "ディフェンス",
      fullback: "サイドバック",
      fullbacks: "サイドバック",
      midfielder: "ミッドフィールダー",
      midfielders: "ミッドフィールダー",
      winger: "ウインガー",
      wingers: "ウインガー",
      forward: "フォワード",
      forwards: "フォワード",
      wingback: "ウイングバック",
      wingbacks: "ウイングバック",
      noposition: "ポジション無し"
    },
    charts: {
      seasonsCompareSelectLabel: "と比較",
      lastSeasonSelectText: "昨シーズン",
      lastAndCurrentSeasonSelectText: "昨シーズン + 今シーズン",
      currentSeasonSelectText: "今シーズン",
      last20gamesSelectText: "最近の20試合",
      last10gamesSelectText: "最近の10試合",
      npgVsXGTitle: "ペナルティ抜きのゴール VS xG",
      totalXGLabel: "合計 xG",
      xGLabel: "xG",
      totalNPGLabel: "ペナルティ抜きの合計ゴール",
      xGAgainstvsNPGAgainstTitle: "被 xG VS ペナルティ抜きの被ゴール",
      totalXGAgainstLabel: "合計被 xG ",
      xGAgainstLabel: "被 xG ",
      totalNPGAgainstLabel: "ペナルティ抜きの合計被ゴール数",
      xGvsxGAgainstTitle: "xG VS 被 xG ",
      pointsVsXPointsTitle: "獲得ポイント VS ポイント期待値",
      xTTitle: "試合のコントロール",
      totalXPoints: "合計ポイント期待値",
      totalPoints: "合計ポイント",
      requestedReports: "要求されたレポート",
      playersScouted: "目を通した選手",
      performanceVSAverageChart: "パフォーマンス VS 平均",
      perPositions: "ポジションで",
      perLeagues: "リーグで",
      perMonths: "月で",
      perClients: "顧客で",
      ofPreposition: "の",
      idJChartTitle: "ゲームイニシアチブ",
      idJChartLabel: "IdJ 指数",
      vJOChartTitle: "オフェンシブゲームのボリューム",
      vJOChartLabel: "VJO 指数",
      preJOChartTitle: "オフェンシブゲームの精度",
      preJOChartLabel: "PreJO 指数",
      proJOChartTitle: "オフェンシブゲームの進展",
      proJOChartLabel: "ProJO 指数",
      chart: "チャート",
      table: "テーブル"
    },
    table: {
      history: {
        season: 'シーズン',
        team: 'チーム',
        position: 'ポジション',
        side: 'サイド',
        games: '試合',
        minutes: '分',
        goals: 'NPG (G)',
        assists: 'A',
        yellowCards: 'YC',
        redCards: 'RC',
        gameLost: 'GM',
        gamesMissed: "欠場試合"
      },
      injury: {
        season: 'シーズン',
        team: 'チーム',
        injury: '怪我',
        dateFrom: '開始日',
        dateTo: '終了日',
        daysLost: '失った日数',
        gamesLost: '負けた試合',
        allInjuries: 'すべての怪我'
      },
      transfers: {
        season: 'シーズン',
        date: '日付',
        teamFrom: '前のチーム',
        teamTo: '次のチーム',
        marketValue: '市場価格',
        fee: 'コスト',
        type: 'タイプ'
      },
      caps: {
        team: 'チーム',
        debut: 'デビュー',
        games: '試合',
        goals: 'ゴール',
        coachDuringDebut: 'デビュー時の監督',
        debutAge: 'デビュー年齢',
      },
      roster: {
        country: 'パリ',
        player: '選手',
        positions: 'ポジション',
        minutes: '分',
        games: '試合',
        goals: 'ゴール',
        assists: 'アシスト',
        cards: 'カード',
        gamesExplicit: 'プレーした試合',
      },
      league: {
        title: "リーグシート",
        subtitle: "リーグのランキングと統計をさらに詳しく見る",
        team: 'チーム',
        games: '行った試合',
        gamesExplicit: 'プレーした試合',
        gamesRanking: '試合数',
        gamesRankingExplicit: 'プレーした試合',
        points: 'Pts',
        pointsExplicit: 'ポイント',
        expectedPoints: 'xP',
        expectedPointsExplicit: 'ポイント期待値',
        goalsScored: 'ペナルティ抜きのゴール',
        goalsScoredExplicit: 'ペナルティ抜きのゴール',
        xG: 'xG',
        xGExplicit: 'ゴール期待値',
        goalsAgainst: 'ペナルティ抜きの被ゴール',
        goalsAgainstExplicit: '被ゴール',
        xGAgainst: '被 xG ',
        xGAgainstExplicit: '被ゴール期待値',
        xGAgainstDiff: '被 xG Dif.',
        xGAgainstDiffExplicit: '被ゴール期待値の差',
        form: 'フォーム',
        sos:"SoS",
        sosExplicit:"スケジュールの問題",
        sosHfa: "SoS HFA",
        sosHfaExplicit:"ホームアドバンテージ",
        difficultyAboveAvg:"平均以上の難易度",
        differentGames: "* プレーした試合の数が異なる",
        berth: "レーティング"
      },
      usersOfClient: {
        userName: '名前',
        userRole: 'ユーザー',
        devRole: '開発者',
        adminRole: '管理者',
        servicesRole: 'サービス',
        xgRole: 'xG',
        radarRole: 'レーダー',
        beeswarmRole: 'Ranking',
        elevenRole: 'Elevens',
        similarityRole: 'Similarity',
        gameAnalysisRole: '試合分析',
        clientStatsRole: 'クライアント統計',
        created: '作成日',
        type: "タイプ",
        logins: "アクセス",
        lastLogin: "最終アクセス",
        trialDate: "締め切り"
      },
      clientLeagues: {
        league: 'リーグ',
        area: 'エリア',
        tier: 'レベル',
        seasons: 'シーズン',
        currentMatchDay: '節',
        regular: 'レギュラー',
        youthLeague: '下部組織',
        clientActive: 'アクティブ',
        visibleLeagues: "可視化できるリーグ"
      },
      connections: {
        title: '最も一般的な組み合わせ',
        playerFrom: 'パサー',
        playerTo: 'パス受け手',
        passes: 'パス',
        passesTooltip: '成功したパスの合計',
        passesFinalThird: "ファイナルサードでのパス",
        passesFinalThirdTooltip: "相手ペナルティーエリア付近でのパス"
      },
      playerPassMapData: {
        title: 'パスの統計',
        player: '選手',
        passes: 'パス',
        passesPct: '% パス',
        xA: 'xA',
        xG: 'xG',
        xT: 'xT',
        playerTooltip: '選手の名前',
        passesTooltip: 'パスの合計数',
        passesPctTooltip: '成功したパスの割合',
        xATooltip: 'アシスト期待値',
        xGTooltip: 'ゴール期待値',
        xTTooltip: '予想される危険'
      },
      playerAllGames: {
        gameDate: '日付',
        game: '試合',
        Team: 'チーム',
        positionsPlayed: 'ポジション',
        minsPlayed: '分',
        gameActions: 'アクション',
        gameDateTooltip: '試合日程',
        gameTooltip: '試合',
        positionsPlayedTooltip: 'プレーしたポジション',
        minsPlayedTooltip: 'プレーした時間',
        gameActionsTooltip: 'ゴール、アシスト、カード',
        from: "から",
        to: "に",
        goalText: "でのゴール",
        assistText: "でのアシスト",
        penaltyText: "でのPK",
        ownGoalText: "でのオウンゴール",
        yellowCardText: "でのイエローカード",
        secondYellowCardText: "での2枚目のイエローカード",
        redCardText: "でのレッドカード",
        substitutionIN: "に入る",
        substitutionOUT: "に出る",
        suspendedText: "出場停止"
      },
      gameFlow: {
        phase: "局面 ",
        mins: "時間",
        team: "チーム",
        period: "期間",
        possession: "Pos",
        possessionTooltip: "ポゼッション",
        xT: "xT",
        xTTooltip: "脅威期待値",
        pft: "PUT",
        pftTooltip: "相手ペナルティーエリア付近でのパス",
        xG: "xG",
        xGTooltip: "ゴール期待値"
      },
    },
    game: {
      title: "ゲームシート",
      subtitle: "ゲームの特徴や統計についてさらに深く掘り下げる",
      header: {
        gameDetails: '詳細',
        gameStats: '統計',
        gameFinishingMap: ' xG マップ',
        gameKeyPassMap: ' xA マップ',
        gamePassMap: 'パスマップ',
        gameThreat: '危険マップ',
        gameFlow: '試合のコントロール',
        gameAnalysis: "分析",
        possessions: "ポゼッション",
        bench: "ベンチ"
      },
      passMap: {
        team: 'チーム',
        minutes: '時間:',
        select: '選択',
        all: '全て',
        attacking: '攻撃',
        defending: '守備',
        forwards: '前へ',
        backwards: '後ろへ',
        sideways: 'サイドへ',
        longBall: 'ロングパス',
        successfullPasses: '成功したパス',
        homeTeam: 'ホーム',
        awayTeam: 'アウェイ',
        passingMatrix: 'パスのマトリックス'
      },
      stats: {
        summary: "Summary",
        attacking: 'Attacking',
        defending: 'Defending',
        contribution: "Contribution",
        possession: "ポゼッション",
        expectedPoints: "ポイント期待値",
        directness: "縦性",
        ppda: "PPDA",
        xg: "xG",
        xG: "xG",
        xGSetPiece: "xG セットプレー",
        xA: "xA",
        xASetPiece: "xA xG セットプレー",
        xT: "xT",
        xTSetPiece: "xT xG セットプレー",
        touchesInOppBox: "相手ペナルティーエリアでのタッチ",
        passesFinalThird: "相手ペナルティーエリア付近でのパス",
        interceptions: "インターセプト",
        recoveries: "ボールの奪取",
        recoveriesOppHalf: "敵陣地でのボールの奪取",
        tackles: "タックル",
        tacklesWasDribbled: "タックル / 突破された",
        fouls: "ファール",
        yellowCards: "イエローカード",
        redCards: "レッドカード",
        passes: "パス",
        passing: "パス率",
        crosses: "クロス",
        crossing: "クロス率",
        shots: "シュート",
        shotsOnTarget: "枠内シュート",
        ppdaExplicit: "守備アクションあたりのパス数",
        xgExplicit: "ゴール期待値",
        xp: "xP",
        seasonAvg: "大会平均",
        winChance: "勝つ可能性",
        postGameWinChance: "試合後の勝利確率",
        winChanceTooltip: "作ったのと与えた xG に基づく。",
        drawChance: "引き分け",
        xgAgainst: "被 xG ",
        averagePossession: "平均ポゼッション",
        averageShots : "平均シュート",
        averagexG: "平均ゴール期待値",
        fieldTilt: "Field Tilt",
        fieldTiltExplicit: "Field Tilt"
      },
      detail: {
        halfTime: "ハーフタイム",
        overTime: "延長",
        showStats: "統計を表示",
        hideStats: "統計を隠す",
        bench: "ベンチ",
        showShotOptions: "シュートオプションを表示",
        hideShotOptions: "シュートオプションを隠す",
        showPassOptions: "パスオプションを表示",
        hidePassOptions: "パスオプションを隠す",
        endGame: "試合終了",
        penalties: "PK"
      },
      timeline: {
        events: {
          goal: "ゴール",
          goal_ownGoal: "オウンゴール",
          goal_penalty: "PKゴール",
          card: "カード",
          card_yellowCard: "イエローカード",
          card_secondYellowCard: "2枚目のイエローカード",
          card_redCard: "レッドカード",
          formationChange: "フォーメーションチェンジ",
          substitution: "交代",
          saveShot: "シュートセーブ",
          saveShot_penalty: "PKセーブ",
          missedShot: "シュートミス",
          missedShot_penalty: "PKミス",
          shotOnPost: "シュート、バーポスト直撃",
          shotOnPost_penalty: "PK、バーポスト直撃"
        }
      },
      gameFlow: {
        goalOf: "のゴール ",
        redCardTo: "へレッドカード ",
        missedPenalty: "PKミス "
      },
      gameThreat: {
        typeOfPlay: 'アクションの種類',
        regularPlay: '試合中',
        setPiece: 'セットプレー',
        setPiecePlay: 'セットプレー',
        throwInSetPiecePlay: 'スローインプレー',
        throwInPlay: 'スローインプレー',
        gkThrow: 'ゴールキーパーの投げ',
        gkKick: 'ゴールキーパーキック',
        kickOff: 'キックオフ',
        actionEnding: '最後のアクション',
        pass: 'パス',
        shot: 'シュート',
        foul: 'ファール',
        other: 'その他',
        threat: '脅威',
        legendSumOfXT: 'xT の合計',
        legendPass: 'パス',
        legendShot: 'シュート',
        legendCarryAndAction: 'ボールを運んでアクション',
        legendCarryAndPass: 'ボールを運んでパス',
        legendOnlyShowing: '· xT と個々のアクションのみを表示 > ',
        legendOnlyShowingPart1: 'アクションのみを表示',
        legendOnlyShowingPart2: '個々と xT > ',
        legendOnlyShowingSetPiece: '·セットプレーのみ表示 con xT > ',
        legendOnlyShowingOpenPlay: '· インプレーのアクションを表示するだけ con xT > ',
        legendPlays: 'アクション',
        legendPerPlay: 'アクションごと',
        legendCarry: 'ボールを運ぶ',
        penaltyPlay: 'PK',
        freeKickTakenPlay: "プリーキックプレー",
        cornerTakenPlay: "コーナーキックプレー",
        fromCornerPlay: "コーナーキックプレー",
        keeperThrowPlay: "ゴールキック",
        fastBreakPlay: "カウンター",
        indirectPlay: "間接フリーキック",
        minutes: "時間",
        games: "試合",
        xT: "xT",
        xTPer90: "90分間の xT'"
      },
      gameAnalysis: {
        next: "次",
        previous: "前",
        phaseLabel: "フェーズ",
        phasesLabel: "フェーズ",
        dot: ". ",
        comma: ", ",
        from: "から",
        to: "に",
        and: " と ",
        steps: {
          finishingMapFullGame: "終了マップ",
          keyPassMapFullGame: "キーパスマップ",
          gameFlow: "試合コントロール",
          finishingMapPerPhases: "終了マップ、フェーズ",
          keyPassMapPerPhases: "キーパスマップ、フェーズ",
          passMapPerPhases: "パスマップ、フェーズ",
        },
        step1: {
          table: {
            draw: "引き分け",
            win: "勝ち",
            lose: "負け",
            possession:	"ポゼッション",
            xP:	"ポイント期待値",
            directness:	"縦性",
            ppda:	"PPDA",
            xG:	"xG",
            xGOpenPlay:	"インプレーの xG ",
            xGSetPiece:	"セットプレーの xG ",
            xA:	"xA",
            xAOpenPlay:	"インプレー xA ",
          },
          text: {
            firstParagraph: {
              1: "右側のマップは、home_team_name と away_team_name によって生まれるゴール期待値を示しています。 塗りつぶされた円は、ゴールで終わったシュートです。 円のサイズは、各シュートの xG によって異なります。",
            },
            lastParagraph: {
              1: "勝利の確率と予想されるポイント数は、シュートから計算されます (ゴールの確率を考慮しシュートを100,000回シミュレーション)。",
            },
            targetHighTeamXG: {
              1: "target_team_name, または rival_team_name は高いゴール期待値を生み出してる。",
            },
            targetHighTeamOpenPlayXG: {
              1: "target_team_name のチャンスのほとんどは流れの中から生まれています。",
            },
            targetHighTeamOpenPlayXGvsGameRival: {
              1: "しかし、インプレーからチャンスを作る方が良かった。",
            },
            targetHighTeamSetPieceXG: {
              1: "target_team_name のチャンスのほとんどはセットプレーから生まれています。",
            },
            targetHighTeamSetPieceXGvsGameRival: {
              1: "しかし、セットプレーからチャンスを作る方が良かった。",
            },
            targetHighTeamCornerXG: {
              1: "多くのチャンスはコーナーキックから生まれています。",
            },
            targetLowTeamGoalConversion: {
              1: "チャンスの実現は予想よりも低かったものの",
            },
            dot: {
              1: ". ",
            },
            targetHighTeamXGOPandSP: {
              1: "target_team_name は、インプレーとセットプレーの両方で大量のゴール期待値を生み出しました",
            },
            targetHighTeamGoalConversion: {
              1: "またこのようなゴールチャンスに変える高い能力を持っています。 ",
            },
            targetLowTeamGoalConversionZeroGoals: {
              1: "生み出されたチャンスをゴールに変えることができない。",
            },
            targetLowTeamGoalConversionScoringGoals: {
              1: "しかし、より多くのゴ​​ールを決めるチャンスを生み出しました。",
            },
            targetHighTeamXGvsGameRival: {
              1: "この対戦で、target_team_name は rival_team_name よりも多くのチャンスを生み出しました。",
            },
            targetLowTeamGoalConversionScoringGoals2: {
              1: "それともっと多くのゴールを決められたかもしれません。 ",
            },
            targetHighTeamXGZeroGoals: {
              1: "しかし、ゴールを決めるチャンスを生かすことができませんでした。 ",
            },
            targetHighTeamXGGoalDiff: {
              1: "試合後のシミュレーションによると、 team_winning_chance が勝つチャンスがあります。",
            },
            startTargetHighTeamOpenPlayXG: {
              1: "target_team_name のチャンスのほとんどは、インプレーによるものです。 ",
            },
            startTargetHighTeamSetPieceXG: {
              1: "target_team_name のチャンスのほとんどは、セットプレーによるものです。 ",
            },
            startTargetHighTeamCornerXG: {
              1: "ほとんどのチャンスはコーナーキックによって生み出されました。 ",
            },
            targetSimilarTeamXG: {
              1: "この試合中、ゴール期待値に関して、両チームは敵チームに対して同様の xG を生みだしました。",
            },
            targetSimilarTeamXGGoalDiff: {
              1: "しかし、target_team_name の方がこれらのチャンスをうまく終わらせました。",
            },
            targetLowTeamXGGoalDiff: {
              1: "結果に関係なく、target_team_name はゴール期待値に関して言えば、対戦相手に大きな危険をもたらしませんでした。",
            },
            targetLowTeamXGZeroGoalDiff: {
              1: "target_team_name は、ゴール期待値に関して言えば、対戦相手に試合に勝つための十分な危険をもたらしませんでした。",
            },
            rivalHighTeamXG: {
              1: "そして、riverrivate_team_name にあまりにも多くのチャンスをもたらすのを許しました。 ",
            },
            rivalHighTeamXGGoalDiff: {
              1: "試合後のシミュレーションに基づくと、target_team_name が team_winning_chance しか勝てない試合です。",
            },
            targetHighTeamOpenPlayXG: {
              1: "この試合では、target_team_name のチャンスのほとんどはインプレ-から生まれています。",
            },
            targetHighTeamOpenPlayXGvsGameRival: {
              1: "この対戦では、target_team_name のチャンスのほとんどはインプレーから生まれています。(rival_team_name とは違い)",
            },
            targetHighTeamSetPieceXG: {
              1: "この試合では、target_team_name のチャンスのほとんどはセットプレーから生まれました。",
            },
            targetHighTeamSetPieceXGvsGameRival: {
              1: "この対戦では、target_team_name のチャンスのほとんどはセットプレーから生まれています。 (rival_team_name とは違い)",
            },
            targetHighTeamCornerXG: {
              1: "この試合では、target_team_name のチャンスのほとんどはコーナーキックから生まれています。",
            },
            targetHighTeamGoalConversion2: {
              1: "ゴールに変わる係数が高い。",
            },
            targetLowTeamGoalConversionZeroGoals: {
              1: "生まれたいずれかのチャンスを決めることができません。",
            },
            targetLowTeamGoalConversion: {
              1: "しかし、ゴールに変わる係数は低い。",
            },
            winningChance: {
              1: "両方のチームのショット数と xG を考えると、 この試合は target_team_name が team_winning_chance 勝つべきでした。",
            },
            highPlayerXGManyShots: {
              1: "興味深いことに、player_name は shots_value シュートで xg_value xG を生みました。",
            },
            highPlayerXGMoreThanOneGoal: {
              1: "ゴールを決めるには xg_value xG が必要です。",
            },
            highPlayerXGOneGoal: {
              1: "ゴールを決めるため",
            },
            highPlayerXGAnyGoal: {
              1: "ゴールを決めることができませんでしたが。",
            },
            highPlayerXGNotManyShots: {
              1: "player_name が数回のシュートで xg_value xG を出したことは興味深いです。",
            },
            highManyPlayerXG: {
              1: "player_name と player_name2 がそれぞれ xg_value と xg_value2 <b>xG</b</b> を出したことに注目するのは興味深いです。 ",
            },
            highTeamXGPerShot: {
              1: "target_team_name のシュートの選択に関しては、xg_per_shot_value で1シュートあたりの平均 xG を記録し、得点の可能性に関して非常に優れていました。",
            },
            highTeamXGPerShotVSGameRival: {
              1: "target_team_name のシュートの選択は、rival_team_name よりもはるかに優れており、平均シュート1本あたり xg_per_shot_value xG でした。",
            },
            xGTimesNotAfter70xG: {
              1: "高い XG にもかかわらず、target_team_name は試合終盤にチャンスを生み出すのに苦労しました。",
            },
            xGTimesBefore25xG: {
              1: "target_team_name は、特に前後半の序盤に多くのチャンスを生み出しました。 ",
            },
            xGTimesAfter25xG: {
              1: "target_team_name は、特に前後半の終盤に多くのチャンスを生み出しました。 ",
            },
            xGTimesBefore25xGvsItself: {
              1: "target_team_name は、前半の早い時間帯でほとんどのチャンスを生み出しました。",
            },
            xGTimesAfter25xGvsItself: {
              1: "target_team_name は、前半の遅い時間帯でほとんどのチャンスを生み出しました。",
            },
            xGTimesBefore70xGvsItself: {
              1: "target_team_name は、後半の早い時間帯でほとんどのチャンスを生み出しました。",
            },
            xGTimesAfter70xGvsItself: {
              1: "target_team_name は、後半の遅い時間帯でほとんどのチャンスを生み出しました。",
            },
            xGTimesBefore25xG2: {
              1: "target_team_name は、 xg_value <b>xG</b> を生みだしチャンスとともに非常に力強くゲームを開始しました。",
            },
            xGTimesAfter25xG2: {
              1: "target_team_name は、 xg_value ゴール期待値を生み出し、チャンスとともに前半を終了しました。",
            },
            xGTimesBefore70xG: {
              1: "target_team_name は、 xg_value ゴール期待値を生み出し、チャンスとともに休憩から出ました。",
            },
            xGTimesAfter70xG: {
              1: "target_team_name は、 xg_value ゴール期待値を生み出し、チャンスとともに後半を終了しました。 ",
            },
            xGTimesAfter70xGOverOneDotTwo: {
              1: "target_team_name は、後半終盤に多くのチャンスを生み出しました。",
            },
            xGTimesBefore70xGOverOneDotTwo: {
              1: "target_team_name は、後半の早い時間帯に多くのチャンスを生み出しました。",
            },
            xGTimesAfter25xGOverOneDotTwo: {
              1: "target_team_name は、前半終盤に多くのチャンスを生み出しました。",
            },
            xGTimesBefore25xGOverOneDotTwo: {
              1: "target_team_name は、前半の早い時間帯に多くのチャンスを生み出しました。",
            },
            xGTimesFirstHalfXGSecondHalfXGRival: {
              1: "target_team_name は前半でほとんどのチャンスを生み出しましたが、rival_team_name は後半で同じことをしました。",
            },
            xGTimesSecondHalfXGFirstHalfXGRival: {
              1: "target_team_name は後半でほとんどのチャンスを生み出しましたが、rival_team_name は前半で同じことをしました。",
            },
            xGTimesFirstHalfXGFirstHalfXGRival: {
              1: "前半にゴール期待値のチャンスのほとんどが発生した試合。 ",
            },
            xGTimesSecondHalfXGSecondHalfXGRival: {
              1: "ゴール期待値の面で最もチャンスを作ったのは後半の試合だ。",
            },
            xGTimesFirstHalfXG: {
              1: "target_team_name は、前半にほとんどのチャンスを生み出すことができました。 ",
            },
            xGTimesSecondHalfXG: {
              1: "target_team_name は、後半にほとんどのチャンスを生み出すことができました。",
            },
            xGTimesFirstHalfXGRival: {
              1: "target_team_name は、ゴール期待値に関してみると前半にほとんどの危険を許容しました。",
            },
            xGTimesSecondHalfXGRival: {
              1: "target_team_name は、ゴール期待値に関してみると後半にほとんどの危険を許容しました。 ",
            },
            highInBoxXG: {
              1: "シュートマップを見ると、ほとんどの危険がペナルティーエリア内で発生したことがわかります。 ",
            },
            highOutOfBoxXG: {
              1: "シュートマップから、この試合で target_team_name がボックスの外から多くの危険を生み出したことがわかります。 ",
            },
            highInBoxXGRival: {
              1: "target_team_name によって与えられた危険のほとんどは、ペナルティーエリア内でのシュートによるものだったことを指摘しておきます。",
            },
            highInBoxXGRival2: {
              1: "また、target_team_name によって与えられた危険のほとんどが、ペナルティーエリア内でのシュートによるものだったことにも注目してください。 ",
            },
            highOutOfBoxXGRival: {
              1: "target_team_name はペナルティーエリア内の危険をうまく回避しました。",
            },
            highTeamChancesHighPPDARival: {
              1: "target_team_name からのプレッシャーがなく、守備アクションのために ppda_value パスを許したのは、 rival_team_name が多くのチャンスを作るための鍵の1つでした。",
            },
            lowPPDAWithGoalDiff: {
              1: "target_team_name 守備アクションのために ppda_value パスのみ許しました。これが勝利への鍵の1つになりました。",
            },
            lowPPDA: {
              1: "target_team_name は rival_team_name のプレーを妨げる素晴らしい仕事をし、守備アクションごとに平均 ppda_value のパスしか許しませんでした。",
            },
            highPossession: {
              1: "ポゼッション possession_value で、target_team_name はボールを支配してました。",
            },
            highPPDARival: {
              1: "ボールをスムーズに配分するのと同様に",
            },
            chancesCreated: {
              1: "これにより多数のオープンプレー(chances_value)の機会を持つことができました。",
            },
            chancesCreatedRival: {
              1: "ただし rival_team_name は多数のオープンプレー(chances_value)の機会を作ることできました。 ",
            },
            xGPerShotRival: {
              1: " rival_team_name は xg_per_shot_value <b>xG por tiro</b> で、より脅威になるチャンスを作ることができました。 ",
            },
            winGame: {
              1: "試合に勝つための重要な要素の1つです。",
            },
            notEnoughWinGame: {
              1: "試合に勝つには十分ではありません",
            },
            goalsFromErrorsFirstGoal: {
              1: "最初のゴールは、 player_error_name のエラーを player_name が生かしました。",
            },
            goalsFromErrorsFirstGoalFinalResult: {
              1: "最初で唯一のゴールは、player_error_name のエラーからで player_name が生かしました。",
            },
            lastPhaseOfGame: {
              1: "試合の終盤で。",
            },
            goalsFromErrorsFinalResultGoalToLead: {
              1: "決勝ゴールは player_error_name のミスが原因で、 player_name のゴールにつながりました。 ",
            },
            goalsFromErrorsFinalResultGoalToTie: {
              1: "試合を引き分けにしたゴールは player_error_name のミスが原因で、 player_name のゴールにつながりました。",
            },
            goalsFromErrorsGoalToTie: {
              1: " player_error_name のミスが起点となり、target_team_name の同点のチャンスにつながりました。",
            },
            goalsFromErrorsGoalToLead: {
              1: "target_team_name は player_error_name のミスをうまく利用してリードしました。",
            },
            xGChance: {
              1: " xg_value <b>xG</b>の確率で ",
            },
            rivalGoalsFromErrorsFinalResultGoalToLead: {
              1: "player_error_name のミスが原因での player_name のゴールが rival_team_name の決勝点になりました。",
            },
            rivalGoalsFromErrorsGoalToTie: {
              1: "player_error_name のミスが起点となり、 rival_team_name　の同点のチャンスにつながりました。",
            },
            rivalGoalsFromErrorsGoalToLead: {
              1: "rival_team_name は player_error_name のミスをうまく利用してリードしました。",
            },
            hugeChancesMissedOneScored: {
              1: "target_team_name は、試合中に生まれた唯一の大きなチャンスをマークしました。 ゴール期待値マップで xg_value の <b>xG</b> で表示される player_name のゴールです。",
            },
            hugeChancesMissedMoreThanOneScored: {
              1: "target_team_name は、試合中に生まれたすべてのビッグチャンスをものにしました。",
            },
            hugeChancesMissedZeroGoalsOneChance: {
              1: "player_name は <b>xG</b> は xg_value で、target_team_name の唯一の大きなゴールチャンスでした。 ",
            },
            hugeChancesMissedZeroGoalsMoreChances: {
              1: "target_team_name は、ゴールになる可能性が40%を超える chances_value のチャンスを決めきることができませんでした。 ",
            },
            oneHugeChancesBeforeFirstGameGoal: {
              1: "player_name は得点をリードするための、 xg_value <b>xG</b> の絶好の機会を得ました。",
            },
            moreThanOneHugeChancesBeforeFirstGameGoal: {
              1: "target_team_name は <b>xG</b> で chances_value チャンスがあり、スコアボードで優位に立つ可能性は40%以上ありました。",
            },
            moreThanOneBigChancesBeforeFirstGameGoal: {
              1: "target_team_name は <b>xG</b> は高く、スコアボードで優位に立つチャンスが chances_value ありました。",
            },
            shotOnPostBeforeFirstGameGoal: {
              1: "player_name は、ポストに当たった xg_value <b>xG</b> でリードするチャンスがありました。 ",
            },
            beforeEndOfGame: {
              1: "試合終了前に、",
            },
            oneHugeChancesAfterFirstGameGoal: {
              1: "player_name は xg_value <b>xG</b> で試合に勝つチャンスがありました。 ",
            },
            moreThanOneHugeChancesAfterFirstGameGoal: {
              1: "target_team_name には、3 ポイントを獲得するためのゴール確率が40%を超える chances_value のチャンスがありました。",
            },
            moreThanOneBigChancesAfterFirstGameGoal: {
              1: "target_team_name は <b>xG</b> が高く、試合に勝つチャンスが chances_value ありました。",
            },
            oneHugeChancesBeforeFirstGameGoalRival: {
              1: "player_name は xg_value <b>xG</b> でチームをリードさせる絶好のチャンスを楽しみました。 ",
            },
            moreThanOneHugeChancesBeforeFirstGameGoalRival: {
              1: "target_team_name は <b>xG</b> が <b>40%</b> を超えるチャンスが chances_value あり、試合でリードすることができました。 ",
            },
            moreThanOneBigChancesBeforeFirstGameGoalRival: {
              1: "target_team_name は高いxGで、 chances_value 回あり、リードのチャンスを楽しみました。",
            },
            shotOnPostBeforeFirstGameGoalRival: {
              1: "player_name は xg_value <b>xG</b> でチームをリードするチャンスを楽しみましたが、ポストに当たってしまいました。",
            },
            bigChancesMissedWhenLosingByOne: {
              1: "player_name は xg_value <b>xG</b>  で同点のチャンスがありましたが、運がありませんでした。",
            },
            moreThanOneBigChancesMissedWhenLosingByOne: {
              1: "target_team_name は、30%を超えるゴールの可能性で試合を引き分けるチャンスが chances_value ありました。 ",
            },
            shotOnPostWhenLosingByOne: {
              1: "player_name は xg_value <b>xG</b> から同点のチャンスを得ましたが、ポストに当たってしまいました。",
            },
          }
        },
        step2: {
          table: {
            draw: "引き分け",
            win: "勝利",
            possession:	"ポゼッション",
            xP:	"ポイント期待値",
            directness:	"縦性",
            ppda:	"PPDA",
            xA:	"xA",
            xAOpenPlay:	"インプレー xA ",
            xASetPiece:	"セットプレー xA ",
            chancesCreated: "作ったチャンス",
            shotsOnTarget: "枠内シュート",
          },
          text: {
            firstParagraph: {
              1: "この画像は、 <b>home_team_name</b> と <b>away_team_name</b> の <b>アシスト期待値</b> を示しています。",
            },
            xAPerKeyPass: {
              1: "キーパスごとの xA ",
            },
            keyPassesGeneratedFrom: {
              1: "キーパスを特に作ったのは",
            },
            highTeamXAvsXG: {
              1: " xAマップでわかるように、 target_team_name によって生まれるチャンスのほとんどは、個々のアクションではなく、コンビネーションプレーから発生します。",
            },
            openPlay: {
              1: "インプレー",
            },
            setPiece: {
              1: "セットプレーで",
            },
            cornerKicks: {
              1: "コーナーキックから",
            },
            combinationPlays: {
              1: "コンビネーションプレー",
            },
            dot: {
              1: ". ",
            },
            comma: {
              1: ", ",
            },
            averageTeamXAvsXG: {
              1: "この試合では、target_team_name コンビネーションプレーでチャンスを多く生み出しました。",
            },
            individualActions: {
              1: "個人のアクションのように",
            },
            dangerFromIndividualActions: {
              1: "この試合では、target_team_name によって作られるチャンスのほとんどは、個人のプレーに起因します。",
            },
            highTeamXAvsXGRival: {
              1: " xAマップで確認できるように、この試合 target_team_name が与えたチャンスはコンビネーションプレーから生じています。",
            },
            rivalStrongKeyPassesFrom: {
              1: " rival_team_name 生み出されたキーパスの数々で強さを見せた。 ",
            },
            manyPlayerKeyPasses: {
              1: "<b>player_name</b> が <b>key_passes pases clave</b> で<b>xa_value xA</b> 生み出したことは興味深いことです。",
            },
            playerAssists: {
              1: " assist</b> ごとに <b>xa_per_assist xA が必要です。",
            },
            giveAssist: {
              1: "アシストするために.",
            },
            noAssists: {
              1: "彼のパスはいずれもアシストにはなりませんでしたが。",
            },
            highXANotManyShots: {
              1: "<b>player_name</b> が数回のパスで <b>xa_value xA</b> を生みだしたことは興味深いことです。",
            },
            manyPlayersHighXA: {
              1: "<b>player_name</b> と <b>player_name2</b> がそれぞれ <b>xa_value</b> と <b>xa_value2 xA</b> を生みだしたことは興味深いことです。",
            },
            xATimes: {
              1: "target_team_name は前半でほとんどのチャンスを生み出しましたが、rival_team_name は後半で同じことをしました。",
            },
            firstHalf: {
              1: "前半",
            },
            secondHalf: {
              1: "後半",
            },
            left: {
              1: "左サイド",
            },
            center: {
              1: "中央 ",
            },
            right: {
              1: "右サイド",
            },
            xAFirstHalfFirstHalfRival: {
              1: "ゴール期待値に関して、ほとんどの危険が発生した期間は",
            },
            xAFirstHalf: {
              1: "target_team_name は彼らの危険のほとんどを起こしました ",
            },
            xATimesXARival: {
              1: "target_team_name ゴール期待値に関して、あまりにも多くの危険を与えました。 ",
            },
            xASides: {
              1: "target_team_name によって作られたチャンスのほとんどは、side_name (<b>xa_value xA</b>)から生まれました。",
            },
            xASidesRival: {
              1: "一方、 rival_team_name は side_name (<b>xa_value xA</b>)から多くを作りました。",
            },
            dangerCreationRival: {
              1: "rival_team_name のチャンスは、特に、 desde el side_name (<b>xa_value xA</b>)から発生します。",
            },
            speciallyEffective: {
              1: "target_team_name は特に効果的でした ",
            },
            xAPerChanceCreated: {
              1: "平均 <b>xa_value xA</b>",
            },
            speciallyEffectiveRival: {
              1: "rival_team_name は特に効果的でした ",
            },
          }
        },
        step3: {
          text: {
            chance: " チャンス",
            chances: " チャンス",
            goal: " ゴール",
            goals: " ゴール",
            home: "ホーム",
            away: "アウェイ",
            last: "最後",
            first: "最初",
            goalScorer: "ゴールスコアラー",
            goalScorers: "ゴールスコアラー",
            lastPhase: "試合の終盤で、",
            phase: {
              1: "試合のこの phase_position フェーズでは、",
              //2: "",
            },
            moreXT: {
              1: "<b style='color:more_color'>more_xt_team_name</b> は <b style='color:less_color'>less_xt_team_name</b> (<b style='color:less_color'>less_xt_team_value xT</b>) よりも多くの脅威 (<b style='color:more_color'>more_xt_team_value xT</b>) を起こしました。",
              //2: "",
            },
            sameTeamMoreMinutes: {
              1: "そして、相手よりも多くの時間脅威を発生させました。(<b style='color:more_color'>more_time_xt_minutes mins.</b> に対して <b style='color:less_color'>less_time_xt_minutes mins.</b>)",
              //2: "",
            },
            rivalTeamMoreMinutes: {
              1: "しかし、この試合で多くの時間脅威を発生させたのは反対のチームです。(<b style='color:more_color'>more_time_xt_minutes mins.</b> に対して <b style='color:less_color'>less_time_xt_minutes mins.</b> del rival)",
              //2: "",
            },
            maxXTValue: {
              1: "<b style='color:max_color'>max_xt_team_name</b> は <b style='color:max_color'>max_xt_team_minute'</b> に一番の脅威(<b style='color:max_color'>max_xt_team_value xT</b>)を引き起こしました。",
              //2: "",
            },
            maxXTValueRival:{
              1: "対して <b style='color:max_rival_color'>max_xt_rival_team_name</b> は <b style='color:max_rival_color'>max_xt_rival_team_minute'</b> に一番の脅威 (<b style='color:max_rival_color'>max_xt_rival_team_value xT</b>) を引き起こしました。",
            },
            bothTeamsScoreButDraw: {
              1: "この試合両チームとも相手チームのゴールキーパーをそれぞれ <b>number_of_goals_each_team</b> で打ち負かしました。ホームの得点者は <b style='color:#3366FF'>home_player_name_goals</b> でアウェイは <b>away_player_name_goals</b> です。",
              //2: "",
            },
            oneTeamTakesTheLead: {
              1: "ゴールに関しては <b style='color:replace_color'>goal_scored_team_name</b> が <b style='color:replace_color'>home_player_name_goals</b> が goal_scorer_word で <b style='color:replace_color'>difference_number_of_goals</b> 差で相手を負かしました。",
              //2: "",
            },
          }
        },
        step4: {
          table: {
            team: "チーム",
            period: "期間",
            possession:	"ポゼッション",
            ppda:	"PPDA",
            xGOpenPlay:	"xG インプレー",
            tooltip: {
              team: "チーム",
              period: "期間",
              possession:	"ポゼッション",
              ppda:	"守備アクションあたりのパス数",
              xGOpenPlay:	"xG インプレー",
            }
          },
          text: {
            clearly: "明らかに",
            very: "すごく ",
            haveGotText1: "それを達成しただけでなく",
            haveGotText2: "以上達成するべき",
            gaveUpPoss: "ポゼッションを放棄した。",
            lostPoss: "ボールのポゼッションを失った。",
            too: "また ",
            possession: {
              1: "試合のこの段階では、 <b style='color:team_color'>team_name</b> clearly_text ボールのポゼッションをコントロールしていました。",
            },
            equalPossession: {
              1: "試合のこの段階では、どちらのチームもボールを持っていて非常にバランスが取れていたため、相手を圧倒していませんでしたが、数字に注目すると <b style='color:team_color'>team_name</b> が <b style='color:team_color'>possession_value%</b> の支配率で対戦相手をわずかに上回っていました。",
            },
            lowPossessionHighPPDA: {
              1: "<b style='color:target_team_color'>target_team_name</b> はプレッシャーの悪さにより、守備のアクション時に <b style='color:rival_team_color'>rival_team_name</b> に <b style='color:target_team_color'>ppda_value 回のパスを与えました。</b>",
            },
            lowPossessionLowPPDA: {
              1: "しかし <b style='color:target_team_color'>target_team_name</b> は rival_team_name がボールを持っていたときにうまくプレスし、<b>ppda_value</b> の<b>PPDA</b> でした。",
            },
            highPossessionLowPPDA: {
              1: "と rival_team_name からの very_text 低度のプレッシャーのおかげでプレーできた。",
            },
            highPossessionHighPPDA: {
              1: " rival_team_name のプレッシャーの激しさは very_textalta でしたが",
            },
            highPossessionHighPFT: {
              1: "<b style='color:target_team_color'>target_team_name</b> は、ファイナルサード</b>で <b>pft_value</b> <b> 本のパスをし高いポゼッションを獲得しました。",
            },
            highPossessionMidLowPFT: {
              1: "高いプレッシャーにもかかわらず、ファイナルサード</b>で <b style='color:target_team_color'>target_team_name</b> have_got_text <b>pft_value</b> <b> 回パスとしました。",
            },
            lowPossessionHighPFT: {
              1: "このフェーズで <b style='color:target_team_color'>target_team_name</b> possession_text でしたが、ファイナルサード</b>で <b>pft_value</b> <b>回のパスを出すことができました。",
            },
            midPossessionHighPFT: {
              1: "このフェーズのポゼッションはかなり均等でしたが、 <b style='color:target_team_color'>target_team_name</b> がファイナルサード</b>で <b>pft_value</b> <b> 回のパスを作ることを妨げませんでした。",
            },
            highPFTHighTouchesIOB: {
              1: "<b style='color:target_team_color'>target_team_name</b> はファイナルサードでコントロールするだけでなく、対戦相手のペナルティーエリア内でも強い存在感を示しました。",
            },
            highPFTLowTouchesIOB: {
              1: "<b style='color:target_team_color'>target_team_name</b> はファイナルサードでボールをコントロールしましたが、多くのボールをペナルティーエリアに入れることはできませんでした。",
            },
            highPFTMidTouchesIOB: {
              1: "ファイナルサード</b>での<b>パスの数を考えると、<b style='color:target_team_color'>target_team_name</b> は相手ペナルティーエリアでより多くの危険を生み出す必要があります。",
            },
            lowPFTHighTouchesIOB: {
              1: " <b style='color:target_team_color'>target_team_name</b> はファイナルサードで多くのパスを完了できませんでしたが、何度も相手のペナルティーエリアに到達することができました。 ",
            },
            midPFTHighTouchesIOB: {
              1: "ファイナルサードで完了したパスの数を考えると、 <b style='color:target_team_color'>target_team_name</b> は何度も相手のペナルティーエリアに到達できました。",
            },
            maxDirectness: {
              1: "このフェーズでは <b style='color:max_dir_color'>target_team_name</b> が、<b>directness_value</b> の <b>縦性 </b> でより攻撃的にプレーしたことが際立ってます。 ",
            },
            maxXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> は試合の他のどのフェーズよりも多くの xG を生み出すことができました。 ",
            },
            highXGFifthQuintile: {
              1: " <b style='color:target_team_color'>target_team_name</b> は多くのゴール期待値を生み出すことに成功しました。",
            },
            highXG: {
              1: "多くのゴール期待値を出しました。",
            },
            highXGLowPossession: {
              1: " ボールをコントロールできなくても",
            },
            highXGLowShots: {
              1: "数回のシュートのみ、<b>シュートあたりのxG</b> が <b>xg_per_shot_value</b>",
            },
            highXGLowXGPerShot: {
              1: " シュートあたりの xG は too_text 低かったのですが ",
            },
            lowXGZeroXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> は対戦相手に危険をもたらすことができませんでした。",
            },
            lowXGMinXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> にとって、ゴール期待値を生み出すという点では不十分でした。",
            },
            lowXGFirstQuintileXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> は非常に少量のゴール期待値を作りました。",
            },
            lowXGSecondQuintileXG: {
              1: "<b style='color:target_team_color'>target_team_name</b> は十分な量のゴール期待値を作れませんでした。",
            },
            lowXGHighPossession: {
              1: "ボールはコントロールしていましたが ",
            },
            lowXGHighShots: {
              1: "何発もシュートしたにも関わらず",
            },
            lowXGHighPFT: {
              1: "ファイナルサード</b>で <b>pft_value</b> <b> パスを完了したにも関わらず",
            },
            midXGQuintileMinXG: {
              1: "xG の数字は悪くありませんでしたが、これはその側面で <b style='color:target_team_color'>target_team_name</b> の試合で最も弱い時間帯でした。",
            },
            midXGQuintileMaxXG: {
              1: "これは、 <b style='color:target_team_color'>target_team_name</b>  が最大の <b>xG (xg_value)</b> を作り出せたフェーズでした。",
            },
          }
        },
        step5: {
          table: {
            team: "チーム",
            period: "期間",
            possession:	"ポゼッション",
            directness:	"縦性",
            passesFinalThird:	"ファイナルサードでのパス",
            tooltip: {
              team: "チーム",
              period: "期間",
              possession:	"ポゼッション",
              directness:	"縦性",
              passesFinalThird:	"ファイナルサードでのパス",
            }
          },
          text: {
            last: "最後",
            goal: "ゴール",
            goals: "ゴール",
            chance: "チャンス",
            chances: "チャンス",
            first: "最初",
            homeTeam: "ホームチーム",
            awayTeam: "アウェイチーム",
            home: "ホーム",
            away: "アウェイ",
            clearly: "明らかに",
            slightly: "軽く",
            firstOrLastPhase: {
              1: "この試合のフェーズ phase_position で",
              2: "この試合のフェーズ phase_position に関して、",
            },
            phase: {
              1: "試合のこの区間の間",
              //2: "",
            },
            bothZeroGoalsScored: {
              1: "両チームともスコアボードを動かすことができません。",
            },
            equalGoalsScored: {
              1: "ゴールを決めている <b>number_goals</b>",
            },
            differentGoalsScored: {
              1: "ゴールを決めている",
            },
            equalPossesion: {
              1: "両方のチームが正確に <b>poss_value%</b> の時間ボールを持っていました。",
            },
            morePossesion: {
              1: "<b>more_poss_team_name</b> は、対戦相手(時間の<b>less_poss_team_value%</b>)よりも多くの時間 (時間の<b>more_poss_team_value%</b>)ボールを保持していました。",
            },
            equalDirectness: {
              1: "2つのチームが同じ縦性でゲームを進めた(それぞれ<b>directness_value</b>)",
            },
            //Same team with more possession and more directness than his rival
            moreDirectnessSameTeam: {
              1: "さらに、彼らは対戦相手よりも縦に早く、<b>less_dir_team_value</b> に対して、 <b>more_dir_team_value</b> の縦性を持つゲームを行っています。.",
            },
            //One team with more possession and one with more directness
            moreDirectnessDifferentTeam: {
              1: "しかし、<b>less_dir_team_value</b>　に対してより縦 (<b>more_dir_team_value</b>) にプレーしたのは home_away チームでした。",
            },
            equalChancesCreated: {
              1: "ホームチームとアウェイチームの両方で同じ数のチャンスが生まれました。具体的には <b>chances_created_value</b> チャンスです。",
            },
            moreChancesCreated: {
              1: "<b>less_cc_team_name</b> は、対戦相手に adverb_text 圧倒 (<b>more_cc_team_value 回のチャンス</b>)され、 <b>less_cc_team_value 回のチャンス</b> のみを作りました。",
            },
            equalXA: {
              1: "ホームチームとアウェイチームの両方で同じ数のチャンスが生まれました。アシスト期待値 </b> の <b>xa_value 反映されています。",
            },
            moreXA: {
              1: "home_away は対戦相手よりも <b>diff_xa_team_value アシスト期待値</b> (<b>less_xa_team_value</b> 対して <b>more_xa_team_value</b>) 多く生み出しました。",
            },
            xAOpenPlay: {
              1: "インプレーではそれぞれ <b>more_xa_op_value</b> と <b>less_xa_op_value</b> を生み出しています。",
            },
          }
        },
        step6: {
          text: {
            eachOne: "それぞれが",
            respectively: "それぞれ",
            with: " (と一緒に <b style='color:replace_color'>other_player_name</b>)",
            playerWas: "選手は",
            playerWere: "選手は",
            firstPhase: {
              1: "この試合の序盤で際立つ部分は ",
              2: "この試合の序盤について強調するところは",
            },
            otherPhase: {
              1: "<b style='color:replace_color'>min_from'</b> と el <b style='color:replace_color'>min_to'</b> の間に言及する必要があります。",
            },
            lastPhase: {
              1: "試合の終盤で言及することは ",
              2: "ゲームの終盤について、引用 ",
            },
            playerMaxSuccessfullPasses: {
              1: "<b style='color:replace_color'>player_name</b> は、チームで成功したパスの数が最も多く、特に <b style='color:replace_color'>successfull_passes_value 回のパス</b> ",
            },
            playerMaxTotalPasses: {
              1: "それはまたそうであったことを見ることでさらに価値を得ます。",
            },
            playerMaxTotalPasses2: {
              1: "with_text 最も多くのパスを試みた選手 (<b style='color:replace_color'>total_passes_value 回のパス</b>). ",
            },
            //Just one player with max successfull passes
            playerNotMaxTotalPasses: {
              1: "最も多くのパスを試みたわけではありませんでしたが (<b style='color:replace_color'>player_name</b> と <b style='color:replace_color'>total_passes_value 回のパス</b>). ",
            },
            //More than one player with max successfull passes
            playersMaxSuccessfullPassesTotalPasses: {
              1: "この期間中にそれぞれ <b style='color:replace_color'>total_passes_value 回のパス</b> を試みてます。 ",
            },
            playerMaxPctPasses: {
              1: "完了したパス</b>の <b style='color:replace_color'>% については、<b style='color:replace_color'>player_name</b> の <b style='color:replace_color'>max_pct_passes_value%</b>が高いことを強調してます。 ",
              2: "パスの成功率に関しては、パスの有効性が <b style='color:replace_color'>max_pct_passes_value%</b> の  <b style='color:replace_color'>player_name</b> に言及する必要があります。",
            },
            playerSumTotalXG: {
              1: "この間に、チームは合計 <b style='color:replace_color'>sum_xg_value xG</b> を作りました。 ",
              2: "この期間中、 <b style='color:replace_color'>team_name</b> は <b style='color:replace_color'>sum_xg_value</b>　の <b style='color:replace_color'>xG</b> を生み出しました。 ",
            },
            ZeroSumXG: {
              1: "チーム全体で合計 <b style='color:replace_color'>all_team_total_passes 回のパス</b> を作ったにもかかわらず、1つのチャンスを作ることができなかったため、無駄でした。 ",
              2: "この期間に行われた <b style='color:replace_color'>all_team_total_passes 回のパス</b> は一度もゴールチャンスを生み出せず、役に立たなかった。",
            },
            playerMaxXGMaxXADiffPlayer: {
              1: "<b style='color:replace_color'>player_xg_name</b> が <b style='color:replace_color'>xg_value xG</b> 、 <b style='color:replace_color'>player_xa_name</b> が <b style='color:replace_color'>xa_value xA</b> で、チャンス創出という点で最も優れた選手となっている。",
            },
            playerMaxXGMaxXASamePlayer: {
              1: "<b style='color:replace_color'>player_name</b> は <b style='color:replace_color'>xg_value xG</b> と <b style='color:replace_color'>xa_value xA</b> で、チームのチャンスの大部分を生み出した人物です。",
            },
            playersMaxXGMaxXA: {
              1: "とりわけキーパスでそれぞれ <b style='color:replace_color'>xa_value xA</b> の <b style='color:replace_color'>players_name</b> のおかげです。",
            },
            //Just one player with max xG
            playerMaxXGZeroXA: {
              1: "<b style='color:replace_color'>xg_value xG</b> の <b style='color:replace_color'>player_xg_name</b> はチャンスのすべてを握っていました。キーパスは受け取っていなく自分でチャンスを作り出す必要がありました。",
            },
            //More than one player with max xG
            playersMaxXGZeroXA: {
              1: "<b style='color:replace_color'>xg_value xG</b> の <b style='color:replace_color'>player_xg_name</b> はチャンスのすべてを握っていました。キーパスは受け取っていなく自分達でチャンスを作り出す必要がありました。",
            },
            oneMaxConnections: {
              1: "試合のこの部分で最も多くのパスを出したペアは <b style='color:replace_color'>couple_name</b> で、合計 <b style='color:replace_color'>connections_value 回のパス</b> を行いました。",
              2: "<b style='color:replace_color'>couple_name</b> によって形成されたコンビは、 <b style='color:replace_color'>connections_value</b> 回ボールを交換しました。",
              3: "<b style='color:replace_color'>couple_name</b> のコンビは、この試合のこのセクションで最も多くボールをパスしており、 <b style='color:replace_color'>connections_value</b> 回もパスを出しました。",
            },
            twoMaxConnections: {
              1: "<b style='color:replace_color'>couple_name</b> と <b style='color:replace_color'>couple_name2</b> のペアは、この期間で最も頻繁につながり、最大 <b style='color:replace_color'>connections_value</b> 回ボールをパスした。",
            },
            moreThanTwoMaxConnections: {
              1: "<b style='color:replace_color'>couple_name</b> などいくつかのペアが、最大 <b style='color:replace_color'>connections_value 回のパス</b> を行っています。",
            },
            oneMinConnections: {
              1: "逆に、二人の間で最もパスが少なかったのは <b style='color:replace_color'>couple_name</b> で、わずか <b style='color:replace_color'>connections_value 回のパス</b> しかありませんでした。",
              2: "その対極は、 <b style='color:replace_color'>couple_name</b> の二人組であり、わずか <b style='color:replace_color'>connections_value</b> 回のみのボールを交換でした。 ",
            },
            twoMinConnections: {
              1: "一方、 <b style='color:replace_color'>couple_name</b> と <b style='color:replace_color'>couple_name2</b> の間でのパス交換がほとんどありませんでした。 (<b style='color:replace_color'>connections_value 回のパス</b>)",
            },
            moreThanTwoMinConnections: {
              1: "十分につながっていない組み合わせがいくつかあるが、 <b style='color:replace_color'>couple_name</b> のデュオの例のように、パス数が <b style='color:replace_color'>connections_value 回</b> という組み合わせは平均より低いです。",
            },
          },
        },
      },
      gamePossessionMap: {
        of: "の",
        to: "へ",
        and: "と",
        endsWith: "終わるのは",
        time: "時間",
        touches: "タッチ",
        passes: "パス",
        threat: "脅威",
        xG: "xG",
        xT: "xT",
        minutes: "分",
        duration: "期間",
        endsGoal: "ゴールで終わる",
        endsInBox: "ペナルティーエリアで終わる",
        withShot: "シュート",
        withCross: "センタリング",
        possession: "ポゼッション",
        events: "イベント",
        filters: "フィルター",
        filtersWarning: "チャンスは、シュートなしのポゼッションにのみ適用されます。",
        sumWarning: "フィルターはシークエンス内のすべてのシュートのxG合計に適用されるため、1を超える場合があります",
        show: "見せる",
        sequenceNumbers: "シーケンス番号",
        jerseyNumbers: "背番号",
        pass: "パス",
        carryAndPass: "ボールを運んでパス",
        carryAndAction: "ボールを運んでアクション",
        carryAndShot: "ボールを運んでシュート",
        shotFailed: "失敗したシュート",
        goal: "ゴール",
        savedShot: "止められたシュート",
        missedShot: "失敗したシュート",
        shotOnPost: "ポスト、バーに当たったシュート",
        headerGoal: "ヘディングゴール",
        headerFailed: "外したヘディングシュート",
        failed: "外した"
      },
      report: {
        title: "Game Report",
        maps: "Maps",
        xGRace: "xG Race",
        lineups: "Lineups",
        button: "試合の完全なPDFレポートを作成する",
        mobileButton: "PDFレポート",
        most: "ほとんどの場合"
      }
    },
    general: {
      create: "作る",
      save: "保存する",
      cancel: "キャンセルする",
      delete: "消す",
      edit: "エディットする",
      go: "進む",
      formErrors: {
        required: "必須項目です",
        passwordMatch: "パスワードが一致しません",
        minLength: "最小文字数に達していません",
        maxLength: "最大長",
        emailValid: "有効なメールアドレスでなければなりません",
        youthAge: "年齢は10歳から23歳の間である必要があります",
        seasonYear: "年は2016年から2050年の間である必要があります",
      },
      confirmationTitle: "本気に良いですか？",
      confirmationMessage: "アクションを実行するかどうかを確認します",
      yes: "はい",
      no: "いいえ",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      search: "探す",
      clearFilters: "フィルターをクリアする",
      minimum: "最小",
      maximum: "最高",
      minimumPercent: "パーセンテージ (%) 最小",
      period: "期間",
      exclude: "除外する",
      team: "チーム",
      clear: "クリア",
      all: "全て",
      ground1: "全試合",
      ground2: "ホーム",
      ground3: "アウェイ",
      filter: "フィルター",
      noData: "結果が見つかりません",
      noDataGivenFilters: "選択したフィルターの結果は見つかりませんでした。",
      similarityNoData: "は類似性ツールに含まれない",
      similarityMinutesWarning: "450分未満のプレイのためデータがありません",
      close: "閉じる",
      load: "ロード",
      filters: "フィルター",
      players: "選手",
      teams: "チーム",
      compare: "比較する",
      seeMore: "もっと見る",
      seeLess: "隠す",
      request: "要求する",
      notes: "メモ",
      closeSession: "セッションを閉じる",
      settings: "各種設定",
      player: "選手",
      state: "状態",
      updated: "更新済",
      file: "ファイル",
      uploadFile: "ファイルをアップロードする",
      reports: "レポート",
      download: "ダウンロードする",
      new: "新しい",
      comparison: "比較",
      scout: "スカウト",
      favorites: "お気に入り",
      moreOptions: "より多くのオプション",
      lessOptions: "少ないオプション",
      today: "今日y",
      home: "ホーム",
      away: "アウェイ",
      until: "まで",
      firstHalf: "前半",
      secondHalf: "後半",
      firstPeriodOT: "延長前半",
      secondPeriodOT: "延長後半",
      postponed: "延期",
      stats: "スタッツ",
      yesterday: "昨日",
      today: "今日",
      last: "最後",
      startDate: "開始日",
      active: "活動中",
      playerLimit: "プレーヤー制限",
      type: "タイプ",
      successMessage: "オペレーションは正常に実行されました。",
      failMessage: "オペレーションは失敗しました。",
      by: "によって",
      checkYourInbox: "あなたのメールをチェックしてください。",
      faq: "書類",
      globalSearch: "グローバル検索",
      gamesLost:"負けた試合",
      outOf:"から",
      avgSeason:"シーズン平均",
      leftDays: "残り日数",
      notifyError:"エラーを報告する",
      notify:"報告する",
      comments:"コメント",
      searches:"検索",
      now:"今",
      twoHoursAgo:"2時間前",
      incomings:"到着",
      departures:"出発",
      transferLoans:"ローン",
      transfers:"移籍",
      movements:"移動",
      incomes:"収入",
      expenditures:"支出",
      action: "活動",
      target:"ターゲット",
      uses:"使用",
      users:"ユーザー",
      since:"から",
      mediaMode:"メディアモード",
      white:"白",
      enabled:"始動した",
      disabled:"機能を無効にした",
      left:"左",
      right:"右",
      both:"両方",
      'left-both': '左両方',
      'right-both': '右両方',
      'left foot': '左',
      'right foot': '右',
      files:"ファイル",
      confirm:"決定する",
      currentStep: "現在のステップ",
      phases: "フェーズ",
      entries:"受信",
      none:"なし",
      times: "回",
      darkMode:"ダークモード",
      client:"顧客",
      visits:"ビジター",
      lastVisit:"最後の訪問",
      strong: "強い",
      medium: "普通",
      weak:"弱い",
      goal:"ゴール",
      list:"リスト",
      map:"マップ",
      copiedToClipboard:"クリップボードにコピーしました。",
      division:"ディビジョン",
      many:"多くの",
      few:"少しの",
      median:"中間の",
      topRight: "上　右",
      topLeft: "上　左",
      bottomRight: "下　右",
      bottomLeft: "下　左",
      library: "図書館",
      mediaLibrary: "メディア図書館",
      for:"間",
      stat:"スタッツ",
      position:"ポジション",
      order:"命令",
      add:"追加",
      visualization: "表示",
      basic:"基本",
      selectAll: "すべて選ぶ",
      unselectAll: "全て選択を外す",
      distribution: "配給",
      end:"終了",
      accuracy: "正確さ",
      opponent: "相手",
      center: "センター",
      line: "ライン",
      live: "ライブ",
      unavailable: "利用不可",
      calendar: "カレンダー",
      activeLeague:"活動中リーグ (進行中)",
      similarity:"類似",
      emptyForSelectAll:"空のすべてを選択",
      size:"サイズ",
      selectPlayersRestriction:"1 人から {x} 人の選手を選択",
      group:"グループ",
      alerts:"通知",
      shortcuts:"ショートカット",
      share:"シェア",
      dataAvailable: "データは近日公開予定",
      someStatsAvailableSoon: "いくつかの統計がまもなく利用可能になります",
      monthGamesWarning: '今月の厳選ゲームは近日公開予定',
      metrics: "指標",
      competition:"Competition",
      code:"Code",
      alias:"Alias",
      never: "なし",
      unlimited: "無制限",
      user: "ユーザー",
      warning: "警告",
      requests: "リクエスト",
      contactSales: "営業部へのお問い合わせ",
      comingSoon: "もうすぐ",
      youth:"Youth",
      male:"Male",
      processing: "Processing",
      addNew: "新規追加",
      createdBy: "作成者",
      downloading: "Downloading",
      displayType: "プレゼンテーションタイプ",
      alreadyExists: 'すでに存在する',
      aggregation:"Aggregation",
      unavailableLeagues: 'あなたは、その選手がプレーしたどのリーグにもアクセスできません',
      meters:"Meters",
      quantity:"Quantity",
      allTime:"All Times",
      games:"Games",
      unit: "単位",
      categories: "カテゴリー",
      maintenanceWarning: "メンテナンス中",
      maintenanceMessage: "ただいま更新作業を行っています。現在行った変更は保存されません。ご理解ありがとうございます。",
    },
    playerScout: {
      dlabDatabase: "driblab データベース",
      league: "リーグ",
      top5: "トップ 5",
      topCountries: "国",
      tier: "レベル",
      division1: "1部",
      division2: "2部",
      division3: "3部",
      division4: "4部",
      division5: "5部",
      summary: "要約",
      offensive: "攻撃的",
      defensive: "守備的",
      gk: "GK",
      all: "全て",
      physical: "フィジカル",
      arrigo: "アリゴ",
      yearTooltip: "1年間のみ",
      expectedThreat: "脅威期待値",
      expectedThreatTooltip: "すべてのポゼッションに追加脅威",
      expectedThreatOP: "脅威期待値 OP",
      expectedThreatOPTooltip: "すべてのインプレーのポゼッションに追加脅威",
      expectedThreatInTeam: "チームでの脅威期待値　％",
      expectedThreatInTeamTooltip: "チームでの追加脅威の割合",
      ballProgression: "ボールの進行",
      ballProgressionTooltip: "10メートル以上の進行",
      deepProgression: "深さ",
      deepProgressionTooltip: "ピッチ最後の5分の1までのボールの進行",
      ballRetention: "ボールの保持　%",
      ballRetentionTooltip: "ボールを保持し、最終的にボールを失うことのなかった回数の割合",
      ballRetentionOppHalf: "ボールの保持　% CC",
      ballRetentionOppHalfExplicit: "ボールを保持し、相手のフィールド内で失われなかった回数の割合",
      finishing: "フィニッシュ",
      finishingTooltip: "ゴールで終わるシュートの割合",
      scoringContribution: "得点への貢献",
      scoringContributionTooltip: "アシスト + ゴール",
      xgPerShot: "シュート毎の xG",
      xgPerGoal: "ゴール毎の xG ",
      headerPerCross: "センタリングからのヘッド",
      completedCrosses: "成功したセンタリング",
      crossingPct: "センタリング %",
      crossingEfficiency: "センタリング有効性",
      crossingEfficiencyTooltip: "センタリングの有効性 (質と量を測る)",
      longBalls: "ロングパス",
      longPassing: "ロングパス %",
      dribblingPct: "ドリブル（抜く） %",
      throughBalls: "スペースにパス",
      oppBoxTouches: "相手ペナルティーエリアでタッチ",
      oppBoxTouchesTooltip: "相手エリアでタッチ",
      openPlayKeyPasses: "インプレーでのキーパス",
      openPlayKeyPassesTooltip: "インプレーでのシュートに繋がったパス",
      xGBuildup: "組み立て xG",
      xGBuildupTooltip: "選手が参加したシュートで終わった一連のプレーの xG (シュートとパスの xG を除く)",
      Assists: "アシスト",
      passPercentage: "パスの %",
      passPerLongBall: "ロングボール毎のパス",
      passPerLongBallExplicit: "各ロングボール毎のパス",
      nonPenaltyGoals: "PKを除くゴール",
      xG: "xG",
      xGExplicit: "ゴール期待値",
      shots: "シュート",
      xGShot: "シュート毎の xG ",
      xGChain: "xG 関与",
      xGChainTooltip: "選手が参加したシュートで終わった一連のプレーに関与した選手の xG",
      chancesCreated: "作ったチャンス",
      chances: "チャンス",
      dribbles: "ドリブル（抜く）",
      dribblesSuccessfull: "成功したドリブル（抜く）",
      touches: "相手ペナルティーエリアでタッチ数",
      xA: "xA",
      xAExplicit: "アシスト期待値",
      xAOpenPlay: "xA OP",
      xAOpenPlayExplicit: "インプレーでのアシスト期待値",
      passesOpponentBox: "相手ペナルティーエリアでのパス",
      passesOB: "相手ペナルティーエリアでのパス",
      passesFinalThird: "ピッチ最後の ⅓ でのパス",
      passesFinalThirdTooltip: "ピッチ最後の ⅓ でのパス",
      passesSuccessful: "成功したパス",
      passesSuccessfulTooltip: "成功したパス",
      ballProgressionPassing: "パスによるボール進行",
      ballProgressionPassingTooltip: "パスによるボール進行",
      ballProgressionDribbling: "ドリブルによるボール進行",
      ballProgressionDribblingTooltip: "ドリブルによるボール進行",
      passesTotal: "パス",
      passesTotalTooltip: "出されたパスの総数",
      shortPassesSuccessful: "成功したショートパス",
      shortPassesSuccessfulTooltip: "成功したショートパス",
      shortPassesTotal: "ショートパス",
      shortPassesTotalTooltip: "出されたショートパスの総数",
      tackles: "タックル *",
      adjustedTackles: "成功したタックル",
      interceptions: "インターセプト *",
      adjustedInterceptions: "成功したインターセプト",
      aerials: "空中戦",
      aerialsPercent: "空中戦 %",
      aerialEfficiency: "空中戦有効性",
      aerialEfficiencyTooltip: "空中戦有効性  (質と量を測る)",
      twd: "タックル / 奪われた",
      tacklesWasDribbled: "タックル / 奪われた",
      fouls: "ファール",
      indPressure: "個人のプレッシャー",
      pressure: "プレッシャー",
      dispossessed: "ボールロスト",
      recoveries: "ボール奪取",
      primary: "メインポジション",
      secondary: "セカンドポジション",
      position: "ポジション",
      nationality: "国籍",
      height: "身長(cm)",
      minHeight: "最低身長",
      maxHeight: "最高身長",
      age: "年齢",
      minAge: "最低年齢",
      maxAge: "最高年齢",
      games: "試合",
      minGames: "最低試合",
      maxGames: "最高試合",
      minutes: "時間",
      minMinutes: "最低時間",
      maxMinutes: "最高時間",
      minPercentMinutes: "最低時間の割合",
      dates: "日付",
      marketValue: "価値 (€)",
      teams: "チーム",
      contractEnd: "契約終了",
      minValue: "最低価値",
      maxValue: "最価値",
      excludeTeams: "チームを除外",
      recentSearches: "最後の検索",
      saveSearch: "検索を保存",
      loadSearch: "検索を読み込む",
      search: '検索',
      searchesList: "検索リスト",
      mySearches: "検索結果",
      mySearchesDescription: "以前に保存したもの",
      recentSearchesDescription: "最近実行した 10 件の検索",
      searchToLoad: "検索を読み込む",
      recentSearch: "最近の検索",
      saveSearchSuccess: "検索が正常に保存されました",
      removeSearch: "検索を削除",
      removeSearchMessage: "検索を削除してもよろしいですか?",
      deleteSearchSuccess: "検索が正常に削除されました。",
      playersFound: "見つかった選手",
      addAllToCollection: "すべてをコレクションに追加",
      npg: "ペナルティ抜きのゴール",
      goals: "ゴール",
      value: "価値",
      nationalTeams:"代表",
      gbeScore: "GBE",
      dlIndex: "スコア",
      minGbe: "GBE min.",
      goalsConceded: "被ゴール",
      npgConceded: "ペナルティ抜きの被ゴール",
      npgConcededTooltip: "PKなしの失点",
      xGOTConceded: "被枠内シュートの xG ",
      xGOTConcededTooltip: "被枠内シュートの xG ",
      goalsPrevented: "回避されたゴール",
      xGFacedPerShotOnTarget: "枠内シュート毎 xG",
      xGFacedPerShotOnTargetTooltip: "シュートごとの被 xG ",
      xGSavedPerxGFacedOnTarget: "セーブ xG",
      xGSavedPerxGFacedOnTargetTooltip: "xG を考慮したセーブ率",
      savesPct: "セーブ%",
      savesOutOfBoxPct: "ペナルティーエリア外からのセーブ%",
      savesInBoxPct: "ペナルティーエリア内からのセーブ%",
      xGFacedPerGoal: "1ゴールあたりの被 xG ",
      xGFacedPerGoalTooltip: "1ゴールを決めるために必要な xG ",
      catchingPct: "キャッチング%",
      catchingTooltip: "ボールキャッチの割合",
      passingOwnHalfPct: "自陣でのパス%",
      passingOwnHalfPctTooltip: "自陣でのパス成功率",
      passingOppHalfPct: "敵陣でのパス %",
      passingOppHalfPctTooltip: "敵陣でのパス成功率",
      passingContribution: "パスの貢献 %",
      passingContributionTooltip: "パスを使って脅威になるプレーをする貢献度は平均以上。",
      shotsPerGoal: "1ゴールあたりのシュート数",
      passesFinalThird: "ファイナルサードパス",
      passingFinalThird: "ファイナルサードパス %",
      claimAccuracy: "センタリングの精度",
      claimAccuracyTooltip: "キャッチされたセンタリングは平均以上",
      highTurnovers: "危険なボールロスト",
      highTurnoversTooltip: "ゴールから40メートルでのボールロスト",
      shotEndingHighTurnovers: "PP とシュート",
      shotEndingHighTurnoversTooltip: "シュートで終わった危険なボールロスト",
      goalEndingHighTurnovers: "PP とゴール",
      goalEndingHighTurnoversTooltip: "ゴールで終わった危険なボールロスト",
      avgCarriesProgress: "ボール前進平均",
      avgCarriesProgressTooltip: "ゴールに向かってボールを運んだ平均距離（メートル）",
      carriesChance: "ボール運びとチャンス",
      carriesChanceTooltip: "ボール運んでキーパス",
      carriesAssist: "ボール運びとアシスト",
      carriesAssistTooltip: "ボール運んでアシスト",
      carriesShot: "ボールを運んでシュート",
      carriesShotTooltip: "ボールを運んで続けてシュート",
      carriesGoal: "ボールを運んでゴール",
      carriesGoalTooltip: "ボールを運んでゴール",
      shotEndingSequence: "シュートで終わる",
      shotEndingSequenceTooltip: "選手が参加したシュートで終わった一連のプレー",
      goalEndingSequence: "ゴールで終わる",
      goalEndingSequenceTooltip: "選手が参加したゴールで終わった一連のプレー",
      gbeScoreTooltip: "FA Football's Governing Body Endorsement",
      goalsPreventedTooltip: "ゴールキーパーがセーブしたゴール (ペナルティを除く) (被 xG  - ペナルティ抜きの被ゴール )",
      freePlayers:"フリーな選手",
      index:"指標",
      playerName:"名前",
      teamName:"チーム",
      secondPos:"中等教育後",
      side:"サイド",
      dob:"生年月日",
      countryName:"国",
      secondCountryName:"2つ目の国",
      leagueName:"リーグ",
      seasonYear:"シーズン",
      assists:"アシスト",
      placeholder: "画面を表示するには検索したい条件を選んでください",
      placeholder2: '検索ボタンをクリックすると結果が表示されます。',
      passesPct:"パスの %",
      passingPct:"パスの %",
      oppBoxPasses:"敵ペナルティーエリアでのパス",
      adjustedClearances:"正確なクリア",
      aerialsPct:"空中戦 %",
      leagueCountryCode:"リーグの国コード",
      shooting:"枠内シュートの%",
      xtPassing:"xT パス",
      xtPassingTooltip:"パスにより脅威を追加",
      xtDribbling:"ボール運び xT ",
      xtDribblingTooltip:"ボール運びにより脅威を追加",
      foot: "利き足",
      aggressiveActions: "攻撃的なアクション",
      aggressiveActionsTooltip: "ボールを失ってから2秒以内に行われたタックル",
      tacklesAttempted: "行われたタックル",
      highDefensiveActionPct: "高い位置でのディフェンシブアクション %",
      highDefensiveActionPctTooltip: "自身のゴールラインから40mを超える位置での防御アクション（タックル、インターセプト、ブロック、ファウル、及び1対1）の合計の割合",
      individualPressureOppHalf: "相手へのプレッシャー",
      individualPressureOppHalfTooltip: "選手が相手陣内でのプレッシングで成功した回数を数値化",
      xGBuildUp5Pass: "組み立て　5パス xG ",
      xGBuildUp5PassTooltip: "最後の5パスでの組み立て xG (シュートとシュートに至るパスを除く)",
      chancesCreatedOpenPlay: "インプレーで生まれたチャンス",
      chancesCreatedOpenPlayTooltip: "シュートで終わるインプレーのパスの数",
      fmf:{
        "Defender":"ディフェンス",
        "aerial":"空中戦",
        "goodDefender": "良いディフェンス",
        "goodPresence": "存在感のある",
        "playmaking": "創造性",
        "Fullback":"サイドバック",
        "defensiveness":"守備",
        "offensiveness":"攻撃",
        "fast":"速さ",
        "Forward":"フォワード",
        "goalChances":"ゴールチャンス",
        "goodDecissions":"良い決断",
        "individualTechnique":"テクニック",
        "Goalkeeper":"ゴールキーパー",
        "footWork":"フットワーク",
        "leadership":"リーダーシップ",
        "Midfielder":"守備的ミッドフィールダー",
        "balance":"バランス",
        "ballRetention":"ボール保持力 %",
        "offensivePasses":"攻撃的パス",
        "recoveries":"ボール奪取",
        "shotToGoal":"枠内シュート",
        "Attacking-Midfielder":"トップ下",
        "defensiveGame":"守備的ゲーム",
        "offensiveGame":"攻撃ゲーム",
        "Winger":"ウインガー",
        "crossing":"センタリング",
        "deepProgressions":"進行",
        "defendingEffort":"守備面での頑張り",
        "facing":"対峙"
      },
      yellowCards:"イエローカード",
      redCards: "レッドカード",
      alert:"通知",
      yearOfBirth: "生年",
      minYearOfBirth: "最小生年",
      maxYearOfBirth: "最高生年",
      women: "女性",
      continental: "コンチネンタル",
      countryCup: "国内カップ",
      statsName: "統計名",
      abbreviation: "略語",
    },
    playerComparison: {
      upTo5Players: "最大5人の選手を比較",
      requestReport: "レポートを依頼する",
      searchBarPlaceholder: "比較する選手を検索して選択する",
      allStats: "すべての統計",
      placeholder: "プレーヤーを追加することから始めることができます"
    },
    reports: {
      detailedInsights: "詳細情報を取得する",
      features: "レポート内容",
      performance: "パフォーマンス",
      evolution: "進化",
      compareWithMyTeam: "自分のチームと比較",
      similarPlayers: "似た選手",
      potentialTeams: "ポテンシャルのあるチーム",
      requestSuccess: "リクエストが正常に送信されました",
      requestAt: "申請済",
      reportConversation:"報告の会話",
      writeYourMessage:"メッセージを書いてください",
      you:"あなた"
    },
    state: {
      requested: "申請済",
      inProgress: "進行中",
      delivered: "届け済",
    },
    langs: {
      es: "スペイン語",
      en: "英語",
      fr: "フランス語",
      de: "ドイツ語",
      it: "イタリア語",
      pt: "ポルトガル語",
      tr: "トルコ語",
      jp: "日本語",
      cn: "中国語",
      sa: "アラブ語"
    },
    inbox: {
      subtitle: "最新の状態に保つ",
      new_injury_alert:"怪我の新たな通知",
      new_contract_alert:"契約の新たな通知",
      new_team_alert:"新規署名アラート",
      new_marketValue_alert:"市場価格の新たな通知",
      new_game_alert: "新しいゲームプレイのアラート",
      receive_mail: "メールを受信",
      receive_mail_subtitle: "フィルターを満たすプレーヤーからの電子メールを毎日受信します",
      receive_notifications: "通知",
      receive_notifications_subtitle: "フィルターを通過した選手の通知をアプリケーションで受け取る",
      changedTo: "に変える",
      alerts: "通知",
      includedIn: "に含まれる",
      noContract: "契約なし",
      newMessages:"新しいメッセージ",
      reply: {
        reply: "Reply",
        replyTitle: "Give feedback to the client:",
        replyPlaceholder: "The user will receive the reply along with the status update"
      }
    },
    gameAnalysis: {
      subtitle: "最近の試合を掘り下げる",
      subtitle2: "次の7日間の試合を表示",
      subtitle3: "最新の試合から洞察を得て、次の試合を探る",
      seeDetail: "詳細を見る"
    },
    statsNaming: {
      Possession: 'ポゼッション',
      TimePossession: 'ボール支配時間',
      PassesPerShots: 'シュート毎のパス',
      PPDA: 'ピーピーディーエー',
      ExpectedPoints: 'ポイント期待値',
      Points: 'ポイント',
      Directness: '縦性',
      PassesPerLongBall: 'ロングボールごとのパス',
      CrossingPerXG: ' xG 毎のセンタリング',
      PenaltySavedPenaltyFaced: 'PKセーブ / 被PK',
      Goals: "ゴール",
      NonPenaltyGoals: 'PKを除くゴール',
      NPGOpenPlay: "インプレーでのPKを除くゴール",
      NPGSetPiece: "セットプレーでのPKを除くゴール",
      Shooting: '枠内シュート % ',
      Finishing: '仕上げ',
      xGEfficiency: 'xG 有効性',
      HeaderPerShot: 'シュートあたりのヘディングシュート',
      HeaderPerCross: 'センタリングあたりのヘディングシュート',
      Assists: 'アシスト',
      ThroughBalls: 'スルーパス',
      CrossEfficiency: 'センタリング有効性',
      ScoringContribution: '得点への貢献',
      xAssistsOpenPlay: 'インプレーでの xA ',
      xAssistsSetPiece: 'セットプレーでの xA ',
      xAssistsOpenPlayInTeam: 'インプレーでの チーム内 xA ',
      xAssistsSetPieceInTeam: 'セットプレーでの チーム内 xA ',
      xGBuildupFinalThird: 'ファイナルサードでの組み立て xG ',
      xGChainFinalThird: 'ファイナルサードでの関与 xG ',
      BallProgressionPassing: 'パスによるボール進行',
      BallProgressionDribbling: 'ドリブルによるボール進行',
      TacklesWasDribbled: 'タックル/ドリブルで抜かれた',
      TacklesSuccessful: '成功したタックル',
      TacklesUnsuccessful: "失敗したタックル",
      Interceptions: 'インターセプト',
      Clearances: 'クリア',
      Fouls: 'ファール',
      Recoveries: 'ボール奪取',
      Shots: 'シュート',
      ShotsPerGoal: 'ゴール毎のシュート',
      ShortPassesSuccessful: '成功したショートパス',
      PassingSuccessForwardPct: '成功した前へのパス % ',
      PassingSuccessBackwardPct: '成功した後ろへのパス % ',
      PassingForwardBackwardPct: 'バックパスあたりの前へのパス %',
      LongBallPerPassesPct: '成功したパスごとのロングパスの % ',
      LongBallReceived: '受けたロングパス',
      LongBallReceivedOppHalf: '敵陣で受けたロングパス',
      OffensiveActions: '攻撃的なアクション',
      DribblesAttempted: '抜くドリブル数',
      SuccessfulDribblesPct: ' ドリブル成功 %',
      OffensiveTouchesOutBoxPct: 'ペナルティーエリア外での攻撃的なタッチ% ',
      BallRetention: 'ボール保持力 % ',
      PassingPct: 'パス % ',
      PassingOwnHalfPct: '自陣でのパス % ',
      PassingOppHalfPct: '敵陣でのパス % ',
      PassingFinalThird: 'ファイナルサードでのパス ',
      PassingFinalThirdPct: 'ファイナルサードでのパス % ',
      LongBallSuccessful: 'ロングパス',
      LongBallPct: 'ロングパス % ',
      SavesPct: 'セーブ % ',
      SavesInBoxPct: 'ペナルティーエリア内でのセーブ % ',
      SavesOutOfBoxPct: 'ペナルティーエリア外でのセーブ% ',
      xGSavedPerXGFacedOnTarget: 'セーブ xG /被 xG ',
      xGFacedOnTargetPerGoalReceived: '1ゴールごとの被 xG ',
      xGFacedOnTargetEfficiency: '回避されたゴール',
      xGFacedOnTarget: "被 xG ",
      IndividualPressure: '個人でのプレッシャー',
      AerialEfficiency: '空中戦有効性',
      AerialWins: '空中戦勝利',
      AerialWinsPct: '空中戦勝利 % ',
      xG: 'ゴール期待値',
      xGDiff: "xG 差",
      xGOpenPlay: "xG インプレー",
      xGSetPiece: "xG セットプレー",
      xGPerShot: 'シュート毎の xG ',
      ChancesCreated: 'ゴールチャンスを演出',
      Crossing: '成功したセンタリング % ',
      OpenPlayKeyPasses: 'インプレーでのキーパス',
      OpenPlayKeyPassesInTeam: 'オープンプレーでのキーパス',
      OpenPlayPassesIntoOpponentBox: 'インプレーでの相手のペナルティーエリア内でのパス',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'インプレーでの相手のペナルティーエリア内でのパス',
      xAssists: 'アシスト期待値',
      xGChain: ' xG　関与',
      xGBuildup: 'ビルドアップ xG',
      xGBuildupInTeam: 'ビルドアップ in Team',
      BallProgression: 'ボールの進行',
      SuccessfulDribbles: 'ドリブル成功',
      Dispossessed: '奪われた',
      TouchesInOpponentBox: '相手ペナルティーエリア内のタッチ',
      xGSavedPerShot: 'シュート毎のセーブ xG ',
      BallRetentionOppHalf: '敵陣でのボール保持 % ',
      DeepProgression: '深さ',
      DeepProgressionFinalThird: 'ファイナルサードでの深さ',
      FoulsTaken: '被ファール',
      PenaltiesTaken: '被PK',
      BlockedCrosses: 'センタリングのインターセプション',
      BlockedShots: 'シュートのインターセプション',
      Blocks: 'ブロック',
      NonPenaltyGoalsAgainst: 'PKなしの被ゴール',
      Headers: "ヘディングシュート",
      AveragePassDistance: "中距離パス",
      ProgressiveRuns: "前進的なボール運び",
      xT: "脅威期待値 (xT)",
      xTOpenPlay: "インプレー xT ",
      xTSetPiece: "セットプレー xT",
      xGOT:"枠内シュートのゴール期待値",
      BadActions: '悪い行為',
      BadActionsOwnHalf: "自陣でのボールロスト",
      AerialsWonOwnBox: "自分のペナルティーエリア内での空中戦勝利",
      AerialsWonOppBox: "敵ペナルティーエリア内での空中戦勝利",
      AerialsTotalOppBox: "自分のペナルティーエリア内での空中戦合計",
      AerialsTotalOwnBox: "敵ペナルティーエリア内での空中戦合計",
      FoulsOwnHalfPct: "自陣でのファウル %",
      RecoveriesOppHalf: "敵陣でのボール奪取",
      DuelsPct: "デュエル成功 %",
      TacklesWasDribbledFirstThird: "タックル/ドリブルで抜かれた　ファーストサード",
      TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
      TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
      BallProgressionFinalThird: "ファイナルサードでのボールの前進",
      DuelsTotal: "デュエル数",
      QuickRecoveries: "素早いボール奪取",
      ShotsPerNPG: "ゴール毎のシュート、PK抜き",
      ShotsOutBox: "ペナルティーエリア外からのシュート",
      GoalsOutBox: "ペナルティーエリア外からのゴール",
      ShootingOutBox: "ペナルティーエリア外からの枠外シュート %",
      HandPassing: "手でのパス %",
      Catching: "キャッチング %",
      ClaimAccuracy: "センタリングの精度",
      HighTurnovers: "危険なボールロスト",
      ShotEndingHighTurnovers: "シュートに繋がった危険なボールロスト",
      GoalEndingHighTurnovers: "ゴールに繋がった危険なボールロスト",
      AverageCarriesProgress: "平均前進ドリブル",
      ChanceEndingCarries: "ボールを運んでチャンス演出",
      AssistEndingCarries: "ボールを運んでアシスト",
      ShotEndingCarries: "ボールを運んでシュート",
      GoalEndingCarries: "ボールを運んでゴール",
      ShotEndingSequence: "一連の流れをシュートで終える",
      GoalEndingSequence: "一連の流れをゴールで終える",
      xGPerNPG: "PK抜きのゴール毎の xG",
      xGSetPiece: "セットプレー xG ",
      AerialWonOffensive: "攻撃的な空中戦勝利",
      AerialWonDefensive: "守備的な空中戦勝利",
      xGAgainst: "被 xG ",
      xGPerNPGAgainst: "PK抜きの被ゴール毎の xG ",
      xGSetPieceAgainst: "セットプレー被 xG ",
      xGPerShotAgainst: "シュート毎の被 xG ",
      ShotsAgainst: "被シュート",
      ShotsOnTargetAgainst: "被枠内シュート",
      RivalPossession: "相手のポゼッション",
      AerialDefensivePct: "ディフェンス空中戦勝率 %",
      HighRecoveries: "高い位置での奪取",
      HighDefensiveActionPct: "高い守備的アクション位置 %",
      HighDefensiveDistance: "守備の高さの距離",
      PassesPerPossession: "ポゼッション毎のパス",
      LengthPerPossession: "ポゼッション毎の距離",
      xTNet:"xT 正味",
      AvgCarriesDistance:"平均ドリブル距離",
      PassesForwardPct:"前へのパス %",
      TacklesAttempted:"タックル数",
      DuelsLost:"負けたデュエル",
      Carries:"運ぶドリブル",
      CarriesPct: "運ぶドリブル %",
      Aerials:"空中戦",
      ProgressivePassesReceivedIntoBox:"ペナルティーエリアで受けた前へのパス",
      PassesOppHalf: "敵陣へのパス",
      LongBallReceived:"受けたロングパス",
      CompletedCrosses:"成功したセンタリング",
      ShotsOnTarget:"枠内シュート",
      AggressiveActions: "攻撃的なアクション",
      Crosses:"センタリング",
      xGBuildup5pass: "ビルドアップ xG 5パス",
      DefensiveDistance: "守備の距離",
      SpeedSequence: "ポゼッション時のボール移動速度",
      Touches: "タッチ",
      AerialsTotalOppHalf: "敵陣での空中戦合計",
      AerialsOppHalf: "敵陣での空中戦",
      AerialsWonOppHalfPct: "敵陣での空中戦勝利 %",
      AerialsPctOppBox: "相手ペナルティーエリアでの空中戦勝利 %",
      AerialsPctOwnBox: "自陣ペナルティーエリアでの空中戦勝利 %",
      AerialDefensive: "エアリアル・ディフェンス",
      AerialOffensive: "エアリアル・オフェンス",
      AerialOffensivePct: "空中攻撃",
      IndividualPressureOppHalf: "相手へのプレッシャー",
      ChancesCreatedOP: "インプレーで生まれたチャンス",
      TouchesPerShot: "シュート毎のタッチ",
      PassesFinalThirdTotalPct: "ファイナルサードでのパス %",
      xACrosses: "センタリングの xA ",
      Passes: "パス",
      PassesSuccessful: "成功したパス",
      TacklesWasDribbledFouls: "地上でのデュエル %",
      OffsidesCaught: "オフサイド",
      ProgressivePassesReceivedFinalThird: "ファイナルサードで受け取った前向きのパス",
      ProgressivePassesReceived: "受け取った前向きのパス",
      Breadth: "Amplitud",
      DuelsDefTotal: "守備的なデュエル",
      DefensiveActions: "守備的なアクション",
      ProgressivePassesReceivedOppHalf: "敵陣で受け取った前向きのパス",
      CompletedCrossesOP: "成功したセンタリング",
      CrossingOP: "成功したセンタリング %",
      PassingContribution: "パスの貢献 %",
      BallProgressionOppHalfInTeam: "チーム全体での敵陣でのボールの進行 %",
      PassesOPIntoBoxInTeam: "インプレーでのチーム全体での相手ペナルティーエリア内のパス %",
      TouchesOppBoxInTeam: "チーム全体での相手ペナルティーエリア内のタッチ %",
      xGOPInTeam: "インプレーでのチーム全体での xG %",
      DeepPasses: "深いパス",
      DefensiveDuelsPct: "守備的なデュエル %",
      DefensiveDistance: "守備の距離",
      QuickRecoveriesPct: "素早いボール奪取 %",
      DiffDefensiveDistanceTeam: "チームとの守備の距離の差",
      xTPassing: "xT パス",
      xTPassing100Passes: "100本中 パス xT  ",
      ProgressivePassesAccurate: "成功した前進のパス",
      xP: "パス成功期待値",
      PassAbility: "スキルパス",
      OPPassesIntoOppBoxPct: "インプレーでのペナルティーエリア内へのパス %",
      EntriesOppBox: "ペナルティーエリアへの侵入",
      Crosses6yardBox: "ゴールエリア内へのセンタリング",
      Cutbacks: "ペナルティーエリアの侵入し、深い位置からマイナス方向へのクロス",
      xTDribbling: "仕掛けるドリブル xT ",
      AvgShotDistance: "平均シュート距離",
      xGOnTarget: "枠内 xG ",
      FinishingxGOT: "決定率 枠内シュートの xG ",
      DribblesWonOwnHalf: "自陣で成功した仕掛けるドリブル",
      DribblesOwnHalf: "自陣で仕掛けたドリブル",
      DribblesOwnHalfPct: "自陣で成功した仕掛けるドリブル %",
      DribblesWonOppHalf: "敵陣で成功した仕掛けるドリブル",
      DribblesOppHalf: "敵陣で仕掛けたドリブル",
      DribblesOppHalfPct: "敵陣で成功した仕掛けるドリブル %",
      DribblesWonFinalThird: "ファイナルサードで成功した仕掛けるドリブル",
      DribblesFinalThird: "ファイナルサードで仕掛けたドリブル",
      DribblesFinalThirdPct: "ファイナルサードで成功した仕掛けるドリブル%",
      ShotEndingHighRecoveries: "シュートで終わる高い位置でのボール奪取",
      PassingFinalThirdAgainst: "ファイナルサードへのパス被成功数",
      OpenPlayPassesIntoOpponentBoxAgainst: "オープンプレー中のボックス内被パス数",
      EntriesOppBoxAgainst: "相手のボックス侵入回数（被）",
      DeepProgressionAgainst: "被ディーププログレッション数",
      TouchesInOpponentBoxAgainst: "ボックス内の被タッチ数",
      Score: 'スコア',
      PDScore: 'フィジカルスコア',
      OrlegiScore: "Orlegi スコア",
      SirScore: "Sirius スコア",
      xTOPInTeam: "インプレーでのチーム全体 xT ",
      YellowCards: "イエローカード",
      RedCards: "レッドカード",
      xTOpenPlayAgainst: "インプレーで与えた xT ",
      xTSetPieceAgainst: "与えたセットプレー xT ",
      NPGOpenPlayAgainst: "インプレーで与えた GSP ",
      NPGSetPieceAgainst: "与えたセットプレー GSP",
      PassesOppHalfPerPossession: "ポゼッション毎の敵陣でのパス",
      AverageTimeRecovery: "ボールを奪うまでの平均時間",
      ExpectedPassing: "合格見込み",
      NumPossession10Passes: "ポゼッション 10パス",
      PassesReceived: "パス獲得数",
      PassesReceivedFinalThird: "最終パス数 ⅓ 最終パス数 ⅓ 最終パス数 ⅓ 最終パス数",
      ProgressivePassesTotalPct: "プログレッシブ・パス",
      ShortPassesPct: 'ショートパス',
      TouchesOppBoxOppTeam: "彼が出場時の自陣ペナルティエリア内被タッチ数",
      ShotsOnTargetOppTeam: "彼が出場時の被枠内シュート数",
      NPGOppTeam: "彼が出場時の相手チームのPK除くxG",
      //Physical Stats
      TotalDistance: "距離",
      DistanceTIP: "距離 TIP",
      DistanceOTIP: "距離 OTIP",
      WalkingDistance: "歩行距離",
      JoggingDistance: "ジョギング距離",
      RunningDistance: "走行距離",
      ExtremeAccelerations: "極端な加速",
      NumberOfRuns: "走行回数",
      HsrNumber: "HSR数量",
      HsrDistance: "HSR距離",
      HsrDistancePct: "ハイスピードランニングの距離 %",
      SprintsNumber: "スプリント数",
      SprintsDistance: "スプリント距離",
      SprintNumberDeclinePct: "スプリント回数の減少 %",
      SprintDistanceDeclinePct: "スプリント距離の減少 %",
      SprintDistancePct: "スプリント距離 %",
      Accelerations: "加速",
      ExplosiveDistance: "エクスプローシブディスタンス ",
      MaxSpeed: "最高速度",
      AvgMaxSpeed: "平均最高速度",
      MaxAccelerations: "最高加速度",
      //Arrigo
      BypassedPlayersByPasses: "回避されたプレイヤー",
      BypassedDefendersByPasses: "回避されたディフェンダー",
      PassesBypassingPlayers: "プレイヤーを回避するパス",
      PassesBypassingDefenders: "ディフェンダーを回避するパス",
      BypassedPlayersPerPass: "パスごとに回避されたプレイヤー",
      BypassedDefendersPerPass: "パスごとに回避されたディフェンダー",
      LineBreakingPasses: "ラインブレイクパス",
      LineBreakingPassesMD: "ラインブレイクパス MD",
      LineBreakingPassesM: "",
      LineBreakingThroughBalls: "ラインブレイクスルーパス",
      LineBreakingPassesPerPass: "パスごとのライン間突破パスの割合",
      TotalPassesUnderStrongPressure: "強いプレッシャー下での総パス数",
      TotalPassesUnderLightPressure: "弱いプレッシャー下での総パス数",
      SuccessfulPassesUnderStrongPressure: "強いプレッシャー下のパス",
      SuccessfulPassesUnderLightPressure: "弱いプレッシャー下のパス",
      PassingUnderStrongPressure: "強いプレッシャー下のパス %",
      PassingUnderLightPressure: "弱いプレッシャー下のパス %",
      PassReceiptsInSpaceCompleted: "スペース内でのパス（受けた/出した）",
      PassReceiptsInSpace: "スペース内で受けたパス",
      TotalStrongOnBallPressures: "ボールへの強いプレッシャー総数",
      TotalLightOnBallPressures: "ボールへの弱いプレッシャー総数",
      SuccessfulStrongOnBallPressures: "ボールへの強いプレッシャー",
      SuccessfulLightOnBallPressures: "ボールへの弱いプレッシャー",
      StrongOnBallPressuresPct: "強いプレッシャーの割合 %",
      LightOnBallPressuresPct: "弱いプレッシャーの割合 %",
      TimesBypassedByPasses: "パスによって突破された",
      TimesBypassedByCarries: "ドリブルによって突破された",
      TimesBypassedByActions: "アクションによって突破された",
      BypassedPlayersByCarries: "ドリブルで突破された選手",
      BypassedDefendersByCarries: "ドリブルで突破されたディフェンダー",
      BypassedPlayersByActions: "アクションで突破された選手",
      BypassedDefendersByActions: "アクションで突破されたディフェンダー",
      CarriesBypassingPlayers: "選手を突破するドリブル",
      CarriesBypassingDefenders: "ディフェンダーを突破するドリブル",
      BypassedPlayersPerCarry: "1回のドリブルで突破された選手数",
      BypassedDefendersPerCarry: "1回のドリブルで突破されたディフェンダー数",
      LineBreakingCarries: "ライン間のドリブル",
      LineBreakingCarriesMD: "ディフェンスとミッドフィルダーの間のドリブル",
      LineBreakingCarriesM: "ミッドフィルダーライン間のドリブル",
      LineBreakingCarriesD: "ディフェンスライン間のドリブル",
      LineBreakingCarriesPerCarry: "1回のドリブルあたりのライン間ドリブル",
      LineBreakingActions: "ライン間のアクション",
      LineBreakingActionsMD: "ディフェンスとミッドフィルダーの間のアクション",
      LineBreakingActionsM: "ミッドフィルダーラインのアクション",
      LineBreakingActionsD: "ディフェンスラインのアクション",
      PassesPerLineBreakingPass: "ライン間パスごとのパス数",
      CarriesPerLineBreakingCarry: "ライン間ドリブルごとのドリブル数",
      LinesBrokenByPasses: "パスによって破ったライン数",
      LinesBrokenByCarries: "運びによって破ったライン数",
      LinesBrokenByActions: "アクションによって破ったライン数",
      LinesBrokenPerPass: "1パスあたりの突破ライン数",
      LinesBrokenPerCarry: "1運びあたりの突破ライン数",
      AvgLastDefenderDistanceIP: "ラストディフェンダー距離 IP",
      AvgLastDefenderDistanceOOP: "ラストディフェンダー距離 OOP",
      AvgDefensiveLineDistanceIP: "ディフェンスライン距離 IP",
      AvgDefensiveLineDistanceOOP: "ディフェンスライン距離 OOP",
      AvgRBDistanceIP: "右サイドバック距離 IP",
      AvgRBDistanceOOP: "右サイドバック距離 OOP",
      AvgLBDistanceIP: "左サイドバック距離 IP",
      AvgLBDistanceOOP: "左サイドバック距離 OOP",
      AvgBlockDistanceIP: "ブロック距離 IP",
      AvgBlockDistanceOOP: "ブロック距離 OOP",
      AvgBlockAreaIP: "ブロックエリア IP",
      AvgBlockAreaOOP: "ブロックエリア OOP",
      AvgDefensiveLineWidthOOP: "ディフェンスライン幅 OOP",
      AvgOffensiveLineLastThirdWidthIP: "オフェンスライン最終サード幅 IP",
      AvgLByIP: "左サイドバック位置 IP",
      AvgRByIP: "右サイドバック位置 IP",
      AvgOffensiveLineDistanceIP: "オフェンスライン距離 IP",
      AvgOffensiveLineLastThirdDistanceIP: "オフェンスライン最終サード距離 IP",
      AvgOffensiveLineWidthIP: "オフェンスライン幅 IP",
      OffBallRuns: "オフザボールの合計ラン",
      OffBallRunsOverlap: "オーバーラップラン",
      OffBallRunsUnderlap: "アンダーラップラン",
      OffBallRunsRunAhead: "前方へのラン",
      OffBallRunsRunBehind: "裏へのラン",
      OffBallRunsCrossReceiver: "クロス受けラン",
      OffBallRunsSupport: "サポートラン",
      OffBallRunsComingShort: "ショートサポートラン",
      description: {
        Possession: "チームポゼッション率",
        TimePossession: 'チームのボール支配時間',
        PassesPerShots: "1シュートあたりのパス数",
        PPDA: "守備アクションあたりのパス数。チームが1回の守備フェーズでボールを取り戻すまでに相手チームに与えたパスの数。PPDAが高いほど相手へのプレッシャーが低い。",
        Directness: "敵のゴールまでパスでつなぐ、チームのパスがどれだけ直接的であるかを測定します。",
        ExpectedPoints: "各試合で作られたゴール期待値、被ゴール期待値から計算された、チームの予想ポイント数。この計算は、チームが実際に達成したポイントと比較して、ゲーム (または累積ゲーム) でのチームのパフォーマンスによって知ることができます。",
        PassesPerLongBall: "ロングパスごとのパス数",
        CrossingPerXG: "ボックス内へのクロスからのゴール期待値の割合",
        PenaltySavedPenaltyFaced: "被PKごとの救われたPKの割合",
        Goals: "90分あたりの得点数",
        NonPenaltyGoals: "90分あたりのPKを除く得点数",
        NPGOpenPlay: "90分あたりのインプレーでの得点数",
        NPGSetPiece: "90分あたりのPKを除く、セットプレーでの得点数",
        Shooting: "枠内シュートの％",
        Finishing: "シュートがゴールに入った割合",
        xGEfficiency: "選手がゴールを決めるのに必要なゴール期待値数",
        HeaderPerShot: "90分あたりのヘディングシュート数",
        HeaderPerCross: "チームが出したクロスの総数のうち、選手がヘディングした割合",
        Assists: "90分あたりのアシスト数",
        ThroughBalls: "90分あたりのスルーパス",
        CrossEfficiency: "試行されたセンタリングの総数のうち、繋がったセンタリングの数",
        ScoringContribution: "90分プレーあたりのアシスト数とゴール数",
        xAssistsOpenPlay: "90分間のセットプレーからではなくプレーからのアシスト期待値",
        xAssistsSetPiece: "90分間のセットプレーからのアシスト期待値",
        xAssistsOpenPlayInTeam: 'チーム内分間のセットプレーからではなくプレーからのアシスト期待値',
        xAssistsSetPieceInTeam: 'チーム内分間のセットプレーからのアシスト期待値',
        xGChainFinalThird: "ファイナルサードで関与した選手のゴール期待値",
        xGBuildupFinalThird: "ファイナルサードで関与した選手のゴール期待値(その前のシュートとパスを除く)",
        BallProgressionPassing: "パスによるボール進行",
        BallProgressionDribbling: "ドリブルによるボール進行",
        TacklesWasDribbled: "選手がタックルでボールを取り戻した回数と、ドリブルで抜かれた、かわされた回数の割合を考慮した指標。 指標が高いほど良い。",
        TacklesSuccessful: "プレーヤーが成功したタックルの数",
        TacklesUnsuccessful: "相手がドリブルで突破したにもかかわらず、プレーヤーがボールを奪えなかった回数",
        Interceptions: "90分あたりのパスをインターセプトした回数",
        Clearances: "90分あたりの選手のパスをクリアした回数",
        Fouls: "90分あたりの選手のファール数",
        Recoveries: "90分あたりの選手のボールを奪取した回数",
        Shots: "90分あたりの選手のシュート数",
        ShotsPerGoal: "選手がゴールを決めるのに必要なシュート数",
        ShortPassesSuccessful: "90分あたりに完了したショートパス（12メートル未満）の数",
        PassingSuccessForwardPct: "90分あたりに成功した前へのパスの割合",
        PassingSuccessBackwardPct: "90分あたりに成功した後ろへのパスの割合",
        PassingForwardBackwardPct: "後方パスに比べて前方パスの比率",
        LongBallPerPassesPct: "総パス数に対するロングボールの割合",
        LongBallReceived: "90分間で受けたロングパス",
        LongBallReceivedOppHalf: "90分間に敵陣で受けたロングパス数",
        DribblesAttempted: "90分あたりのドリブル試行回数",
        SuccessfulDribblesPct: "成功したドリブル数 / ドリブル試行の総数",
        BallRetention: "ボールを保持し、最終的にボールを失うことのなかった回数の割合",
        PassingPct: "選手が行ったパスの総数のうち、成功したパスの割合",
        PassingOwnHalfPct: "自陣で終わるパスの成功率",
        PassingOppHalfPct: "敵陣で終わるパスの成功率",
        PassingFinalThird: "90分間でピッチのファイナルサードに到達したパスの数",
        PassingFinalThirdPct: "ピッチのファイナルサードに到達し成功したパスの割合",
        LongBallSuccessful: "90分間で32メートル以上のパスを成功させた回数",
        LongBallPct: "成功したロングパス (32メートル以上) の割合",
        SavesPct: "総被弾数に対するセーブの割合",
        SavesInBoxPct: "ペナルティーエリア内からのシュートのセーブ率",
        SavesOutOfBoxPct: "ペナルティーエリア外からのシュートのセーブ率",
        xGSavedPerXGFacedOnTarget: "ゴールキーパーによって止められた予想 xG のパーセンテージを示す。 1に近づくほど得点が難しくなる",
        xGFacedOnTargetPerGoalReceived: "ゴールキーパーに対してゴールを決めるために必要なゴール期待値を示す。 この指標は、このゴールキーパー相手にゴールを決めるには高い xG が必要であることを意味します。",
        xGFacedOnTargetEfficiency: "ゴールキーパーによって妨げられたゴールの数。ゴール期待値 (ゴールへのシュートのみ) からゴールキーパーが許したゴール数を差し引いたもの。 ゴールキーパーのおかげで妨げられたゴールの数を示します。",
        xGFacedOnTarget: "ゴールキーパーが受けた総 xG (セーブと失点)",
        IndividualPressure: "ボールを持たない選手が相手に与えるプレッシャーを数値化したモデル。このモデルは、ボールがリカバーされたかどうかにかかわらず、守備チームのプレーヤーがフィールドの最後の5分の3で対戦相手に対して行ったプレッシャーの数を測定します。プレッシャーの数値が高いほど、対戦相手ができることが少なくなります。",
        AerialEfficiency: "空中戦の成功率と空中戦の勝数を合わせたモデル",
        AerialWins: "選手が勝利した空中戦の数",
        AerialWinsPct: "行われた空中戦の合計のうち、勝った空中戦の数",
        xG: "90分ごとに生成されるゴール期待値。この指標はシュートのさまざまな変数に基づいて、シュートがゴールで終わる確率のパーセンテージを測定します。詳細については、 <a href='https://www.driblab.com/es/analisis-equipo/goles-esperados-xg/'>ゴール期待値: とは何か、何に役立つのか </a>",
        xGDiff: "xG と得点の差",
        xGOpenPlay: "インプレーで作られたゴール期待値",
        xGSetPiece: "セットプレーで作られたゴール期待値",
        xGPerShot: "シュートあたりのゴール期待値。この指標は、被シュートの平均的な危険度を測定します。高いほどシュートがゴールになる可能性が高くなります。 高い値はプレーヤーがエリア内からシュートを放ちゴールに向かうように、シュートまでうまく運んでいることを意味します。",
        ChancesCreated: "味方選手がシュートで終わるパスを出した数",
        CompletedCrosses:"90分間での成功したセンタリング",
        Crossing: "成功したセンタリングの割合",
        OpenPlayKeyPasses: "90分あたりのシュート（アシストを除く）につながるインプレーでの成功したパス数",
        OpenPlayKeyPassesInTeam: 'チーム内でのオープンプレー中に選手がパスを完了した割合',
        OpenPlayPassesIntoOpponentBox: "90分間での敵ペナルティーエリア内への成功したパス数",
        OpenPlayPassesIntoOpponentBoxSuccessful: '90分間での敵ペナルティーエリア内への成功したパス数',
        xAssists: "アシスト期待値(xA)とは、試合中に味方が”シュート”か”得点”に繋がるパスの質を数 値化したものです。 ※アシスト数は、パスを受けてからシュートを決める味方選手の質が関係するため、xAの正しい測定が出来ないため、以下の項目を考慮してパスの質を数値化します。「パスを出した場所・パスの種類(クロスボール・スルーパス・セットプレーからのパス...etc)・試合の状態(人数・天候...etc) など」",
        xGChain: "参加した選手のゴール期待値数。 選手がシュートで終了するプレーに参加した場合、プレーの xG がこの指標に追加されます",
        xGBuildup: "xG 参加と同様ですが、プレーの流れの最後の2人のプレーヤー (最後のパサーとシュートを打った選手) は含みません。",
        xGBuildupInTeam: 'ビルドアップ in Team',
        BallProgression: "パスとドリブルの両方、または両方の組み合わせで、選手が10メートル以上前進した回数（90分間）",
        SuccessfulDribbles: "90分あたりのドリブル成功数",
        Dispossessed: "90分あたりのプレーヤーのボールロスト数",
        TouchesInOpponentBox: "90分間の選手の敵ペナルティーエリア内でのアクションの回数",
        xGSavedPerShot: "被枠内シュートの平均危険度",
        BallRetentionOppHalf: "相手陣内でボールを保持し、ボールを失うことがなかった回数の割合",
        DeepProgression: "プレーヤーがフィールドの最後の5分の1に到達した回数と、プレーヤーが最後の5分の1でボールをコントロールした回数を足した数。",
        DeepProgressionFinalThird: "プレーヤーがフィールドのファイナルサードに到達した回数と、プレーヤーがファイナルサードでボールをコントロールした回数を足した数。",
        FoulsTaken: "90分間の被ファール数",
        PenaltiesTaken: "90分あたりの誘発したPK",
        BlockedCrosses: "90分あたりのブロックされたセンタリング",
        BlockedShots: "90分あたりのブロックされたシュート",
        NonPenaltyGoalsAgainst: "90分あたりの失点（PKを除く）",
        Headers: "ヘディングシュート",
        AveragePassDistance: "平均パス距離",
        ProgressiveRuns: "相手エリアに近づく行動。選手が自陣で開始および終了するときには30メートルの前進、自陣で始まり敵陣で終わる時は15メートルの前進、敵陣で開始および終了するときには10メートルの前進、これらを前進と見なします。",
        xT: "脅威期待値(xT)、これは選手がドリブルとパスの両方で、ポゼッションがゴールになる可能性が高いエリアにボールを持っていき、相手チームにもたらす脅威を測定する指標です。",
        xTOpenPlay: "90分間のセットプレーからではなく、インプレーからの脅威期待値",
        xTSetPiece: "90分間のインプレーからではなく、セットプレーからの脅威期待値",
        xGOT:"枠内シュートのゴール期待値。ゴールキーパーが直面するゴール期待値。この指標では枠内シュートのみが考慮されます。(枠外シュートとバー、ポストへのシュートは除外)。",
        BadActions: '犯したすべての悪行の合計',
        BadActionsOwnHalf: "自陣でのボールロスト",
        AerialsWonOwnBox: "自ペナルティーエリアで空中戦勝利",
        AerialsWonOppBox: "相手ペナルティーエリアで空中戦勝利",
        AerialsTotalOppBox: "自ペナルティーエリアで空中戦数",
        AerialsTotalOwnBox: "相手ペナルティーエリアで空中戦数",
        FoulsOwnHalfPct: "自陣でのファール %",
        RecoveriesOppHalf: "敵陣で選手が90分間に奪取したボールの数",
        DuelsPct: "デュエル成功 %",
        TacklesWasDribbledFirstThird: "ファイナルサードでタックル/ドルブルで抜かれた",
        TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
        TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
        BallProgressionFinalThird: "ファイナルサードでのボールの前進",
        DuelsTotal: "90分間に犯したタックル、エアリアル、ボールタッチ、ドリブル、ファウルの総数",
        QuickRecoveries: "自ゴールから40メートル以上離れて場所で、ボールを失ってから5秒以内にリカバリー",
        ShotsPerNPG: "PK抜きのゴールごとのシュート数",
        ShotsOutBox: "90分間でのペナルティーエリア外からのショット",
        GoalsOutBox: "90分間でのペナルティーエリア外からのゴール",
        ShootingOutBox: "ペナルティーエリアからの枠内シュート率",
        HandPassing: "ハンドでパスを成功させた割合",
        Catching: "キャッチの割合",
        ClaimAccuracy: "ゴールキーパーが空中でどれだけ優れているかを測定します。1より大きい数値は、ゴールキーパーが予想よりも多くの空中ボールをインターセプトしたことを示します。",
        HighTurnovers: "自ゴールから40メートル以内でのボールロスト",
        ShotEndingHighTurnovers: "自ゴールから40メートル以内で、シュートで終わったボールロスト",
        GoalEndingHighTurnovers: "自ゴールから40メートル以内で、ゴールに繋がったボールロスト",
        AverageCarriesProgress: "縦へのボール運びの平均距離 (メートル)",
        ChanceEndingCarries: "パスで終わりその後シュートに繋がった7メートル以上のドリブルでの運び",
        AssistEndingCarries: "ゴールアシストのパスで終えた7メートル以上のドリブルでの運び",
        ShotEndingCarries: "シュートで終了する少なくとも7メートルのドリブルでの運び",
        GoalEndingCarries: "ゴールで終了する少なくとも7メートルのドリブルでの運び",
        ShotEndingSequence: "選手が参加したシュートで終わった一連のプレー",
        GoalEndingSequence: "選手が参加したゴールで終わった一連のプレー",
        xGPerNPG: "各ゴールあたりのPKを含まないゴール期待値",
        xGSetPiece: "セットプレーのみで生み出されるゴール期待値",
        AerialWonOffensive: "攻撃での空中戦での勝利数",
        AerialWonDefensive: "守備での空中戦での勝利数",
        xGAgainst: "相手のゴール期待値",
        xGPerNPGAgainst: "各ゴールあたりのPKを含まない被ゴール期待値",
        xGSetPieceAgainst: "セットプレーでの被ゴール期待値",
        xGPerShotAgainst: "各被シュートの平均 xG ",
        ShotsAgainst: "90分間の被シュート",
        ShotsOnTargetAgainst: "90分間の被枠内シュート",
        RivalPossession: "相手のポゼッション",
        AerialDefensivePct: "ディフェンス空中戦勝率 %",
        HighRecoveries: "相手ペナルティーエリアから40メートル以内でのボール奪取",
        HighDefensiveActionPct: "自身のゴールラインから40mを超える位置での守備アクション (タックル、インターセプト、ブロック、ファウル、および1対1) の合計の割合",
        HighDefensiveDistance: "自身のゴールから全守備アクション位置までの平均距離",
        PassesPerPossession: "ポゼッション毎のパス",
        LengthPerPossession: "ポゼッション毎の距離",
        xTNet:"脅威期待値 正味",
        AvgCarriesDistance:"平均ドリブル距離",
        PassesForwardPct:"合計に対する前へのパスの割合",
        TacklesAttempted:"タックル回数",
        DuelsLost:"90分間のデュエル負け数",
        Carries:"90分間のドリブル",
        CarriesPct: "90分あたりのドリブル %",
        Aerials:"90分間の空中戦",
        ProgressivePassesReceivedIntoBox:"ペナルティーエリア内で受けた前へのパス",
        PassesOppHalf: "相手のフィールドで終了する成功したパスの合計数",
        LongBallReceived:"32メートル以上の受けたロングパス",
        ShotsOnTarget:"90分での枠内シュート",
        AggressiveActions: "ボールを失ってから2秒以内にタックルを試みた",
        Crosses:"90分間の合計センタリング",
        xGBuildup5pass: "最後の5パスでの xG ビルドアップ (シュートとシュートに至るまでのパスを除く)",
        DefensiveDistance: "すべての守備アクションの相手ゴールまでの平均距離",
        SpeedSequence: "ポゼッション時のボール移動速度",
        Touches: "90分あたりの選手のタッチ数",
        AerialsTotalOppHalf: "90分間での敵陣で空中戦の合計",
        AerialsOppHalf: "90分間での敵陣で繰り広げられる空中戦",
        AerialsWonOppHalfPct: "敵陣で行われた空中戦の総数に対する空中戦の勝率",
        AerialsPctOppBox: "相手ペナルティーエリア内で行われた空中戦の総数に対する空中戦の勝率",
        AerialsPctOwnBox: "自ペナルティーエリア内で行われた空中戦の総数に対する空中戦の勝率",
        AerialDefensive: "自チームがポゼッションしているときの空中戦の総数",
        AerialOffensive: "相手チームがポゼッションしているときの空中戦の総数",
        AerialOffensivePct: "自チームがポゼッションしているときに獲得した空中戦の割合",
        IndividualPressureOppHalf: "選手が相手陣内でプレッシャーをかけ成功した回数を数値化するモデル",
        ChancesCreatedOP: "90分間での枠内シュートで終わったインプレーのパスの数",
        TouchesPerShot: "各シュートで実行されるタッチ数",
        PassesFinalThirdTotalPct: "ファイナルサードで行われたパス (成功および失敗) の割合",
        xACrosses: "90分あたりのセンタリングから生まれるアシスト期待値",
        Passes: "パスの総数",
        PassesSuccessful: "成功したパス",
        TacklesWasDribbledFouls: "タックルと犯したファウルの合計と比べて、勝ったタックルの割合",
        OffsidesCaught: "オフサイド",
        ProgressivePassesReceivedFinalThird: "ファイナルサードで受け取った前向きのパス",
        ProgressivePassesReceived: "受け取った前向きのパス",
        Breadth: "サイドでのタックル、受けたドリブル、インターセプト、犯したファウルの合計数",
        DuelsDefTotal: "合計タックル、守備的な空中戦、犯したファウルの合計",
        DefensiveActions: "守備的なアクション",
        ProgressivePassesReceivedOppHalf: "敵陣で受けた前向きなパス",
        CompletedCrossesOP: "インプレーで成功したクロス",
        CrossingOP: "インプレーで成功したクロスの割合",
        PassingContribution: "レシーバーの位置を考慮してパスの価値を加え出した、脅威度を測る割合。",
        BallProgressionOppHalfInTeam: "チームの合計に対して、相手のフィールドでのボールの進行率",
        PassesOPIntoBoxInTeam: "チームの合計に対して、相手のフィールドでのインプレーでのパスの割合",
        TouchesOppBoxInTeam: "チームの合計に対して、相手のフィールドでのボールタッチの割合",
        xGOPInTeam: "インプレーで生まれたチームの合計のゴール期待値の割合",
        DeepPasses: "相手ゴールから半径20メートルの外側からのその内側へのパス",
        DefensiveDuelsPct: "守備デュエルの合計と勝利の割合",
        DefensiveDistance: "自ゴールから守備デュエルが行われた位置までの距離の平均",
        QuickRecoveriesPct: "タックル成功でのクイックリカバリーの割合",
        DiffDefensiveDistanceTeam: "選手とチームの守備距離差",
        xTPassing: "パスだけで生まれる脅威期待値",
        xTPassing100Passes: "パスのみ、100回ごとの脅威期待値",
        ProgressivePassesAccurate: "相手ゴールの方向に向かって成功させた10メートル以上のパス",
        xP: "パス期待値 (xP) は、パスが終了するフィールドの部分に基づいてパスの品質を測定します",
        PassAbility: "成功したパスとパス期待値(xP)の比率",
        OPPassesIntoOppBoxPct: "インプレーでの相手ペナルティーエリアのパス成功と合計の割合",
        EntriesOppBox: "相手ペナルティーエリアへのパスとドリブルの合計",
        Crosses6yardBox: "ゴールエリアに上がったセンタリングの総数",
        Cutbacks: "ゴールライン際からのペナルティーエリアへマイナスパス",
        xTDribbling: "ドリブルのみから生まれる xT ",
        AvgShotDistance: "シュートの合計の平均距離",
        xGOnTarget: "枠内シュートのゴール期待値。ゴール期待値と異なり、このモデルはシュートの方向を考慮して、枠内シュートがゴールに終わる確率を測定します。",
        FinishingxGOT: "枠内シュートのゴール期待値を使用しての、ゴールにつながった枠内シュートの割合。この指標は、枠内へのシュートとゴールの割合の測定から、ストライカーがシュートの質によってどれだけの価値を加えたかを表します。",
        DribblesWonOwnHalf: "自陣でのドリブル成功数",
        DribblesOwnHalf: "自陣でのドリブル試行回数",
        DribblesOwnHalfPct: "自陣での合計ドリブル数に対するドリブル成功率",
        DribblesWonOppHalf: "敵陣でのドリブル成功数",
        DribblesOppHalf: "敵陣でのドリブル試行回数",
        DribblesOppHalfPct: "敵陣での合計ドリブル数に対するドリブル成功率",
        DribblesWonFinalThird: "ファイナルサードでのドリブル成功数",
        DribblesFinalThird: "ファイナルサードでのドリブル試行回数",
        DribblesFinalThirdPct: "ファイナルサードでの合計ドリブル数に対するドリブル成功率",
        ShotEndingHighRecoveries: "シュートで終わるハイリカバリー（相手ゴールから40メートル以内でのボール奪取）",
        PassingFinalThirdAgainst: "相手のファイナルサードへの成功したパス",
        OpenPlayPassesIntoOpponentBoxAgainst: "オープンプレー中に相手が自陣ボックス内に試みたパスの総数",
        EntriesOppBoxAgainst: "相手による自陣ボックスへのパスとドリブルの回数",
        DeepProgressionAgainst: "相手がボールを運んで最終5分の1に到達した回数＋自陣5分の1でのボール保持回数",
        TouchesInOpponentBoxAgainst: "相手が自陣ボックス内でボールを保持した回数",
        Score: 'さまざまな指標に基づくプレーヤーのパフォーマンス',
        PDScore: 'さまざまな身体的指標に基づく選手の身体的パフォーマンス',
        OrlegiScore: "さまざまな指標に基づくプレーヤーのパフォーマンス",
        SirScore: "さまざまな指標に基づくプレーヤーのパフォーマンス",
        xTOPInTeam: "チームの合計に対して、インプレーで生まれる脅威期待値 (xT)",
        YellowCards: "受けたイエローカード ",
        RedCards: "受けたレッドカード",
        xTOpenPlayAgainst: "セットプレーではなく、インプレーで与えた脅威期待値",
        xTSetPieceAgainst: "インプレーではなく、セットプレーで与えた脅威期待値",
        NPGOpenPlayAgainst: "インプレーでのPKを除く被ゴール",
        NPGSetPieceAgainst: "セットプレーでのPKを除く被ゴール",
        PassesOppHalfPerPossession: "ポゼッションによる敵陣へのパス",
        AverageTimeRecovery: "ボール奪取の平均時間",
        ExpectedPassing: "合格見込み",
        NumPossession10Passes: "ポゼッション 10パス",
        PassesReceived: "パス獲得数",
        PassesReceivedFinalThird: "最終パス数 ⅓ 最終パス数 ⅓ 最終パス数 ⅓ 最終パス数",
        ProgressivePassesTotalPct: "プログレッシブ・パス",
        ShortPassesPct: 'ショートパス',
        TouchesOppBoxOppTeam: "選手が出場している間に自陣ペナルティエリア内で許した相手のアクション数",
        ShotsOnTargetOppTeam: "選手が出場している間に被シュート（枠内）数",
        NPGOppTeam: "選手が出場している間に被ゴール（PK除く）数",
        //Physical Stats
        TotalDistance: "試合中に選手が移動した総距離",
        WalkingDistance: "試合中に選手が2 m/s（7.2 km/h）未満の速度で移動した総距離",
        JoggingDistance: "試合中に選手が2 m/s（7.2 km/h）から4 m/s（14.4 km/h）の速度でジョギングした総距離",
        RunningDistance: "試合中に選手が4 m/s（14.4 km/h）から5.5 m/s（19.8 km/h）の速度で走った総距離",
        NumberOfRuns: "試合中に選手が4 m/s（14.4 km/h）から5.5 m/s（19.8 km/h）の速度で完了した走行の回数",
        ExtremeAccelerations: "選手が3 m/s²以上で加速した回数",
        DistanceTIP: "試合中、選手がポゼッションを持って移動した距離（チームがポゼッション時）",
        DistanceOTIP: "試合中、選手がポゼッションを持たずに移動した距離（相手チームがポゼッション時）",
        HsrNumber: "試合中に選手が少なくとも1秒間に5.5 m/s（19.8 km/h）以上かつ7 m/s（25.2 km/h）未満の速度で移動した回数",
        HsrDistance: "試合中に選手が5.5 m/s（19.8 km/h）以上かつ7 m/s（25.2 km/h）未満の速度で移動した総距離",
        HsrDistancePct: "総移動距離に対する高速走行（HSR）の距離の割合",
        SprintsNumber: "試合中に選手が少なくとも1秒間に7 m/s（25.2 km/h）以上の速度で移動した回数",
        SprintsDistance: "試合中に選手が7 m/s（25.2 km/h）以上の速度でスプリントした総距離",
        SprintNumberDeclinePct: "試合の後半と比較したスプリント数の減少率",
        SprintDistanceDeclinePct: "試合の後半と比較したスプリント中の走行距離の減少率",
        SprintDistancePct: "総移動距離に対するスプリント距離の割合",
        Accelerations: "試合中に選手が1.5 m/s²から3 m/s²の間で加速した回数",
        ExplosiveDistance: "爆発的な距離",
        MaxSpeed: "選手が記録した最高速度",
        AvgMaxSpeed: "選手が記録した平均最高速度",
        MaxAccelerations: "選手が記録した最大加速度（メートル/秒²）",
        BypassedPlayersByPasses: "タッチイベントの開始時にボール保持者よりゴール側にいる選手数から、タッチイベント終了時にゴール側にいる選手数を引いた数",
        BypassedDefendersByPasses: "タッチイベントの開始時にボール保持者よりゴール側にいる守備選手の数から、終了時の守備選手の数を引いた数",
        PassesBypassingPlayers: "選手を突破したパスの数",
        PassesBypassingDefenders: "守備選手を突破したパスの数",
        BypassedPlayersPerPass: "パスごとに突破された選手の合計数",
        BypassedDefendersPerPass: "パスごとに突破された守備選手の合計数",
        LineBreakingPasses: "ボールを相手ゴールに少なくとも10%近づけ、近接する守備選手のペアを交差する、または守備ラインを超えるパスの数",
        LineBreakingPassesMD: "中盤ラインと最終ラインを突破した成功パス",  
        LineBreakingPassesM: "中盤ラインを突破した成功パス",  
        LineBreakingThroughBalls: "最終ラインを突破した成功パス",
        LineBreakingPassesPerPass: "パスごとに突破したラインの数",
        TotalPassesUnderStrongPressure: "強いプレッシャー下で行われたパスの合計数(相手選手から0～2メートル以内）",
        TotalPassesUnderLightPressure: "軽いプレッシャー下で行われたパスの合計数（相手選手から2～5メートル以内）",
        SuccessfulPassesUnderStrongPressure: "強いプレッシャー下で成功したパスの数（相手選手から0～2メートル以内）",
        SuccessfulPassesUnderLightPressure: "軽いプレッシャー下で成功したパスの数（相手選手から2～5メートル以内）",
        PassingUnderStrongPressure: "強いプレッシャー下での成功パスの割合（相手選手から0～2メートル以内）",
        PassingUnderLightPressure: "軽いプレッシャー下での成功パスの割合（相手選手から2～5メートル以内）",
        PassReceiptsInSpaceCompleted: "受け手が攻撃側ハーフ内でゴール方向に5メートル以内に守備選手がいない場合のパス",
        PassReceiptsInSpace: "攻撃側ハーフ内でゴール方向に5メートル以内に守備選手がいない場合に受け取ったパス",
        TotalStrongOnBallPressures: "強いプレッシャー（ボール保持者から0～2メートル以内）の数",
        TotalLightOnBallPressures: "プレッシャー（ボール保持者から2～5メートル以内）の数",
        SuccessfulStrongOnBallPressures: "成功した強いプレッシャー（ボール保持者から0～2メートル以内）の数",
        SuccessfulLightOnBallPressures: "成功したプレッシャー（ボール保持者から2～5メートル以内）の数",
        StrongOnBallPressuresPct: "成功した強いプレッシャーの割合（ボール保持者から0～2メートル以内）",
        LightOnBallPressuresPct: "成功したプレッシャーの割合（ボール保持者から2～5メートル以内）",
        TimesBypassedByPasses: "パスによって突破された合計回数",
        TimesBypassedByCarries: "ドリブルによって突破された合計回数",
        TimesBypassedByActions: "パスとドリブルの合計で突破された合計回数",
        BypassedPlayersByCarries: "ドリブルで突破された相手（DFとMF）の合計人数",
        BypassedDefendersByCarries: "ドリブルで突破された相手（DF）の合計人数",
        BypassedPlayersByActions: "パスとドリブルの合計で突破された相手（DFとMF）の合計人数",
        BypassedDefendersByActions: "パスとドリブルの合計で突破された相手（DF）の合計人数",
        CarriesBypassingPlayers: "相手選手を突破したドリブルの回数",
        CarriesBypassingDefenders: "DFを突破したドリブルの回数",
        BypassedPlayersPerCarry: "1回のドリブルで突破した相手選手の平均数",
        BypassedDefendersPerCarry: "1回のドリブルで突破したDFの平均数",
        LineBreakingCarries: "守備ラインを突破したドリブルの回数",
        LineBreakingCarriesMD: "MFラインとDFラインを突破したドリブルの回数",
        LineBreakingCarriesM: "MFラインを突破したドリブルの回数",
        LineBreakingCarriesD: "DFラインを突破したドリブルの回数",
        LineBreakingCarriesPerCarry: "ドリブルごとのライン間突破率",
        LineBreakingActions: "守備ラインを突破したパスとドリブルの合計回数",
        LineBreakingActionsMD: "MFラインとDFラインを突破したパスとドリブルの合計回数",
        LineBreakingActionsM: "MFラインを突破したパスとドリブルの合計回数",
        LineBreakingActionsD: "DFラインを突破したパスとドリブルの合計回数",
        PassesPerLineBreakingPass: "ライン間突破パス1本あたりの全パス数の比率",
        CarriesPerLineBreakingCarry: "ライン間突破ドリブル1本あたりの全ドリブル数の比率",
        LinesBrokenByPasses: "パスで突破したラインの合計数",
        LinesBrokenByCarries: "ドリブルで突破したラインの合計数",
        LinesBrokenByActions: "パスとドリブルの合計で突破したラインの合計数",
        LinesBrokenPerPass: "1本のパスで突破したラインの平均数",
        LinesBrokenPerCarry: "1本のドリブルで突破したラインの平均数",
        AvgLastDefenderDistanceIP: "最後のディフェンダー（自陣ゴールに最も近い選手）とゴールラインの距離（ボール保持時）",
        AvgLastDefenderDistanceOOP: "最後のディフェンダー（自陣ゴールに最も近い選手）とゴールラインの距離（非保持時）",
        AvgDefensiveLineDistanceIP: "最も深いディフェンスラインとゴールの距離（ボール保持時）",
        AvgDefensiveLineDistanceOOP: "最も深いディフェンスラインとゴールの距離（非保持時）",
        AvgRBDistanceIP: "右サイドバックと自陣ゴールの距離（ボール保持時）",
        AvgRBDistanceOOP: "右サイドバックと自陣ゴールの距離（非保持時）",
        AvgLBDistanceIP: "左サイドバックと自陣ゴールの距離（ボール保持時）",
        AvgLBDistanceOOP: "左サイドバックと自陣ゴールの距離（非保持時）",
        AvgBlockDistanceIP: "最も後方と最も前方のフィールドプレーヤー間の距離（ボール保持時）",
        AvgBlockDistanceOOP: "最も後方と最も前方のフィールドプレーヤー間の距離（非保持時）",
        AvgBlockAreaIP: "全フィールドプレーヤーを囲むバウンディングボックスの面積（チームの占有スペース）ボール保持時",
        AvgBlockAreaOOP: "全フィールドプレーヤーを囲むバウンディングボックスの面積（チームの占有スペース）非保持時",
        AvgDefensiveLineWidthOOP: "最も後方の選手ラインの横幅（非保持時）",
        AvgOffensiveLineLastThirdWidthIP: "最終サードにおけるオフェンスラインの横幅（ボール保持時）",
        AvgLByIP: "左サイドバックの位置（ボール保持時）",
        AvgRByIP: "右サイドバックの位置（ボール保持時）",
        AvgOffensiveLineDistanceIP: "自陣ゴールとオフェンスライン間の距離（ボール保持時）",
        AvgOffensiveLineLastThirdDistanceIP: "自陣ゴールと最終サードのオフェンスラインの距離（ボール保持時）",
        AvgOffensiveLineWidthIP: "オフェンスラインの横幅（ボール保持時）",
        OffBallRuns: "攻撃をサポートする意図的なオフザボールの動き（ラン）",
        OffBallRunsOverlap: "味方がボールを持っている際に、サイドライン側（外側）を回って走る動き",
        OffBallRunsUnderlap: "味方の内側（ピッチ中央側）を通って走る動き",
        OffBallRunsRunAhead: "ボール保持者を追い越して前に出るが、最終ラインより手前で止まる動き",
        OffBallRunsRunBehind: "最終ディフェンスラインを突破し、ディフェンダーとゴールキーパーの間に入る動き",
        OffBallRunsCrossReceiver: "クロスを受けるためにエリア内に走り込む動き",
        OffBallRunsSupport: "ボール保持者に並ぶ位置へ走り、近くでパスの選択肢となる動き",
        OffBallRunsComingShort: "ボール保持者に近づいてサポートやパスの受け手となる動き",
      },
      subtitles: {
        Possession: "チームのポゼッション率",
        TimePossession: 'チームのボール支配時間',
        PassesPerShots: "各シュートのパス数",
        PPDA: "相手チームのボールポゼッションを失うまでのパス数",
        Directness: "縦性。チームがパスでどれだけ直接的であるか",
        AerialWins: "90分間での空中戦勝利",
        AerialEfficiency: "90分間の空中戦勝利数と空中戦の合計を組み合わせたモデル",
        AerialWinsPct: "空中戦勝率",
        Assists: "90分あたりのアシスト数",
        BallProgression: "90分間での10メートルを超えるパスまたはドリブルによる進行",
        Catching: "ゴールキーパーがボールをキャッチした割合",
        ChancesCreated: "90分あたりのシュートで終わるパスの数",
        ClaimAccuracy: "センタリングに対しての守りの有効性",
        CompletedCrosses: "90分間での成功したセンタリング",
        Crossing: "成功したセンタリングの割合",
        Dispossessed: "90分間での非ポゼッション時間",
        Finishing: "ゴールで終わるシュートの割合",
        xGEfficiency: "選手がゴールを決めるのに必要なゴール期待値",
        Fouls: "90分間で犯したファウル",
        FoulsTaken: "90分間で受けたファウル",
        IndividualPressure: "90分間で成功したプレッシャー数",
        Interceptions: "90分間でのインターセプション",
        LongBallPct: "成功した32メートル以上のパスの割合",
        LongBallSuccessful: "90分間で成功した32メートル以上のパス",
        Goals: "90分あたりの得点数",
        NonPenaltyGoals: "90分あたりの得点数 (PKを除く)",
        NPGOpenPlay: "90分あたりのインプレーでの得点数",
        NPGSetPiece: "90分あたりのセットプレーでの得点数。(PKを除く)",
        OpenPlayKeyPasses: "90分あたりのインプレーでのシュートで終わるパス (アシストを除く) ",
        OpenPlayKeyPassesInTeam: 'チーム内でのオープンプレー中に選手がパスを完了した割合',
        PassingFinalThird: "90分あたりのファイナルサードで完了したパスの数",
        PassingFinalThirdPct: "ファイナルサードでのパスの割合",
        PassingOppHalfPct: "敵陣での成功したパスの割合",
        PassingOwnHalfPct: "自陣での成功したパスの割合",
        PassingPct: "成功したパスの割合",
        Recoveries: "90分間でのボール奪取数",
        SavesInBoxPct: "ペナルティーエリア内でのセーブ率",
        SavesOutOfBoxPct: "ペナルティーエリア外でのセーブ率",
        SavesPct: "セーブ率",
        ScoringContribution: "90分プレーあたりのアシスト数とゴール数",
        xAssistsOpenPlay: "90分間のインプレーでのアシスト期待値",
        xAssistsSetPiece: "90分間のセットプレーでのアシスト期待値",
        xAssistsOpenPlayInTeam: 'チーム内分間のセットプレーからではなくプレーからのアシスト期待値',
        xAssistsSetPieceInTeam: 'チーム内分間のセットプレーからのアシスト期待値',
        xGChainFinalThird: "ファイナルサードで関与した選手のゴール期待値数",
        xGBuildupFinalThird: "ファイナルサードで関与した選手のゴール期待値数 (その前のシュートとパスを除く)",
        BallProgressionPassing: "パスによるボール進行",
        BallProgressionDribbling: "ドリブルによるボール進行",
        Shooting: "枠内シュートの割合（PKを除く）",
        Shots: "90分あたりの合計シュート数（PKを除く）",
        ShotsPerGoal: "ゴールを決めるための平均枠内シュート数",
        SuccessfulDribbles: "90分間での成功したドリブル",
        TacklesSuccessful: "90分間の合計タックル数",
        TacklesWasDribbled: "タックルでデュエルに勝った割合",
        ThroughBalls: "90分あたりの最終ディフェンスライン越えたパス数",
        TouchesInOpponentBox: "90分あたりの相手ペナルティーエリアでのボールタッチ数",
        xAssists: "90分あたりのアシスト期待値",
        xG: "90分あたりのゴール期待値",
        xGDiff: "xG と得点の差",
        xGOpenPlay: "90分あたりのインプレーで生まれるゴール期待値",
        xGSetPiece: "90分間のセットプレーからのゴール期待値",
        xGBuildup: "90分間のビルドアップ xG ",
        xGBuildupInTeam: 'ビルドアップ in Team',
        xGChain: "90分間の関与 xG ",
        xGPerNPG: "ゴールを決めるのに必要な平均 xG (PKを除く)",
        xGPerShot: "シュートごとの平均 xG ",
        xGSavedPerShot: "シュートごとの平均 xG セーブ",
        xGSavedPerXGFacedOnTarget: "被枠内 xG 毎の平均 xG セーブ",
        xGFacedOnTargetPerGoalReceived: "ゴールキーパーにゴールを決めるために必要なゴール期待値",
        xGFacedOnTargetEfficiency: "90分あたりのゴールキーパーによって妨げられたゴールの数",
        xGFacedOnTarget: "90分間にゴールキーパーが受けた総 xG (セーブと失点)",
        HighTurnovers: "自ゴールから40メートル以内でのロスト",
        OpenPlayPassesIntoOpponentBox: "90分間にインプレーで相手ペナルティーエリアで成功したパス",
        OpenPlayPassesIntoOpponentBoxSuccessful: "90分間にインプレーで相手ペナルティーエリアで成功したパス",
        DeepProgressionFinalThird: "プレーヤーがファイナルサードでボールを保持した回数",
        ChancesCreatedOP: "90分間のインプレーでゴールへのシュートで終わったプレーのパスの数",
        PenaltiesTaken: "90分間でのPK誘発回数",
        BlockedCrosses: "90分間でのセンタリングブロック数",
        BlockedShots: "90分での止められたシュート数",
        NonPenaltyGoalsAgainst: "90分間での被ゴール数(PKを除く)",
        Headers: "ヘディングシュート",
        AveragePassDistance: "平均パス距離",
        ProgressiveRuns: "90分間の相手エリアに近づくドリブル",
        xT: "90分間でのボールを危険な場所に移動させて発生する脅威",
        xTOpenPlay: "90分間のセットプレーからではなく、インプレーから脅威期待値",
        xTSetPiece: "90分間のインプレーからではなく、セットプレーから脅威期待値",
        xGOT:"枠内シュートのゴール期待値。ゴールキーパーが直面するゴール期待値。この測定基準では、枠内へのシュートのみが考慮されます。(外とポスト、バーへのシュートは除外)",
        BadActions: '犯したすべての悪行の合計',
        BadActionsOwnHalf: "自陣でのボールロスト",
        AerialsWonOwnBox: "自ペナルティーエリアでの空中戦勝利",
        AerialsWonOppBox: "相手ペナルティーエリアでの空中戦勝利",
        AerialsTotalOppBox: "自ペナルティーエリアでの合計空中戦数",
        AerialsTotalOwnBox: "相手ペナルティーエリアでの合計空中戦数",
        FoulsOwnHalfPct: "自陣でのファール %",
        RecoveriesOppHalf: "90分間に選手が敵陣でボールを奪った数",
        DuelsPct: "成功したデュエル %",
        TacklesWasDribbledFirstThird: "ファイナルサードでのタックル/抜かれたドルブル",
        TacklesWasDribbledSecondThird: "Tackles/Was Dribbled ⅔",
        TacklesWasDribbledFinalThird: "Tackles/Was Dribbled Final ⅓",
        BallProgressionFinalThird: "ファイナルサードでのボール進行",
        DuelsTotal: "90分間に犯したタックル、エアリアル、ボールタッチ、ドリブル、ファウルの総数",
        QuickRecoveries: "自ゴールから40メートル以上の場所でボールロストから5秒以内に取り返した",
        ShotsPerNPG: "PKなしのゴールごとのシュート数",
        ShotsOutBox: "90分あたりのペナルティーエリア外からのシュート",
        GoalsOutBox: "90分あたりのペナルティーエリア外からのゴール",
        ShootingOutBox: "ペナルティーエリア外からの枠内シュート率",
        HandPassing: "手で成功したパスの割合",
        ShotEndingHighTurnovers: "自ゴールから40メートル以内の場所でシュートで終わったボールロス",
        GoalEndingHighTurnovers: "自ゴールから40メートル以内の場所でゴールで終わったボールロス",
        AverageCarriesProgress: "ドリブルでの前進の平均距離 (メートル)",
        ChanceEndingCarries: "パスからシュートで終わる 7 メートル以上のドリブル",
        AssistEndingCarries: "アシストで終わる7メートル以上のドリブル",
        ShotEndingCarries: "シュートで終わる少なくとも7メートルのボール運び",
        GoalEndingCarries: "ゴールで終わる少なくとも7メートルのボール運び",
        ShotEndingSequence: "選手が参加したシュートで終わった一連のプレー",
        GoalEndingSequence: "選手が参加したゴールで終わった一連のプレー",
        xGSetPiece: "セットプレーのみで生み出されるゴール期待値",
        AerialWonOffensive: "攻撃での空中戦での勝利数",
        AerialWonDefensive: "守備での空中戦での勝利数",
        xGAgainst: "相手のゴール期待値",
        xGPerNPGAgainst: "PKを除く失点ごとの被ゴール期待値",
        xGSetPieceAgainst: "セットプレーからの被ゴール期待値",
        xGPerShotAgainst: "各シュートの平均 xG ",
        ShotsAgainst: "90分間の被シュート",
        ShotsOnTargetAgainst: "90分間の被枠内シュート",
        RivalPossession: "相手のポゼッション",
        AerialDefensivePct: "ディフェンス空中戦勝率 %",
        HighRecoveries: "相手ペナルティーエリアから40メートル以内でのボール奪取",
        HighDefensiveActionPct: "自身のゴールラインから40mを超える位置での合計守備アクション (タックル、インターセプト、ブロック、犯したファウル、および 1v1) の割合",
        HighDefensiveDistance: "自ゴールから全守備アクションまでの平均距離",
        PassesPerPossession: "ポゼッションあたりのパス",
        LengthPerPossession: "ポゼッションあたりの距離",
        xTNet:"脅威期待値 正味",
        AvgCarriesDistance:"平均ドリブル距離",
        PassesForwardPct:"合計に対する前へのパスの割合",
        TacklesAttempted:"タックル数",
        DuelsLost:"90分間で負けたデュエル",
        Carries:"90分間でのドリブル",
        CarriesPct: "90分間でのドリブル %",
        Aerials:"90分間での空中戦",
        ProgressivePassesReceivedIntoBox:"ペナルティーエリアで受け取った前進のパス",
        PassesOppHalf: "相手フィールドで終了した成功したパスの合計数",
        LongBallReceived:"32メートル以上の受け取ったパス",
        ShotsOnTarget:"90分間での枠内シュート",
        AggressiveActions: "ボールロストから2秒以内に行ったタックル",
        Crosses:"90分間での合計センタリング数",
        xGBuildup5pass: "最後の5パスでの xG ビルドアップ (シュートとシュートに至るまでのパスを除く)",
        DefensiveDistance: "すべての守備アクションの相手ゴールまでの平均距離",
        SpeedSequence: "ポゼッション時のボール移動速度",
        Touches: "90分あたりの選手のタッチ数",
        AerialsTotalOppHalf: "90分間での敵陣で空中戦の合計",
        AerialsOppHalf: "90分間での敵陣で繰り広げられる空中戦",
        AerialsWonOppHalfPct: "敵陣で行われた空中戦の総数に対する空中戦の勝率",
        AerialsPctOppBox: "相手ペナルティーエリア内で行われた空中戦の総数に対する空中戦の勝率",
        AerialsPctOwnBox: "自ペナルティーエリア内で行われた空中戦の総数に対する空中戦の勝率",
        AerialDefensive: "自チームがポゼッションしているときの空中戦の総数",
        AerialOffensive: "相手チームがポゼッションしているときの空中戦の総数",
        AerialOffensivePct: "自チームがポゼッションしているときに獲得した空中戦の割合",
        IndividualPressureOppHalf: "選手が相手陣内でプレッシャーをかけ成功した回数を数値化するモデル",
        TouchesPerShot: "各シュートで実行されるタッチ数",
        PassesFinalThirdTotalPct: "ファイナルサードで行われたパス (成功および失敗) の割合",
        xACrosses: "90分あたりのセンタリングから生まれるアシスト期待値",
        Passes: "合計パス数",
        PassesSuccessful: "成功したパス",
        TacklesWasDribbledFouls: "タックルと犯したファウルの合計と比べて、勝ったタックルの割合",
        OffsidesCaught: "オフサイド",
        ProgressivePassesReceivedFinalThird: "ファイナルサードで受け取った前向きのパス",
        ProgressivePassesReceived: "受け取った前向きのパス",
        Breadth: "サイドでのタックル、受けたドリブル、インターセプト、犯したファウルの合計数",
        DuelsDefTotal: "合計タックル、守備的な空中戦、犯したファウルの合計",
        DefensiveActions: "守備的なアクション",
        ProgressivePassesReceivedOppHalf: "敵陣で受けた前向きなパス",
        CompletedCrossesOP: "インプレーで成功したクロス",
        CrossingOP: "インプレーで成功したクロスの割合",
        CrossingPerXG: "ペナルティーエリア内からのクロスでのゴール期待値の割合",
        PassesPerLongBall: "各ロングパスごとのパス数",
        PassingContribution: "レシーバーの位置を考慮してパスの価値を加え出した、脅威度を測る割合。",
        BallProgressionOppHalfInTeam: "チームの合計に対して、相手のフィールドでのボールの進行率",
        PassesOPIntoBoxInTeam: "チームの合計に対して、相手のフィールドでのインプレーでのパスの割合",
        TouchesOppBoxInTeam: "チームの合計に対して、相手のフィールドでのボールタッチの割合",
        xGOPInTeam: "インプレーで生まれたチームの合計のゴール期待値の割合",
        DeepPasses: "相手ゴールから半径20メートルの外側からのその内側へのパス",
        DefensiveDuelsPct: "守備デュエルの合計と勝利の割合",
        DefensiveDistance: "自ゴールから守備デュエルが行われた位置までの距離の平均",
        QuickRecoveriesPct: "タックル成功でのクイックリカバリーの割合",
        DiffDefensiveDistanceTeam: "選手とチームの守備距離差",
        xTPassing: "パスだけで生まれる脅威期待値",
        xTPassing100Passes: "パスのみ、100回ごとの脅威期待値",
        ProgressivePassesAccurate: "相手ゴールの方向に向かって成功させた10メートル以上のパス",
        xP: "パス期待値 (xP) は、パスが終了するフィールドの部分に基づいてパスの品質を測定します",
        PassAbility: "成功したパスとパス期待値(xP)の比率",
        OPPassesIntoOppBoxPct: "インプレーでの相手ペナルティーエリアのパス成功と合計の割合",
        EntriesOppBox: "相手ペナルティーエリアへのパスとドリブルの合計",
        Crosses6yardBox: "ゴールエリアに上がったセンタリングの総数",
        Cutbacks: "ゴールライン際からのペナルティーエリアへマイナスパス",
        xTDribbling: "ドリブルのみから生まれる xT ",
        AvgShotDistance: "シュートの合計の平均距離",
        xGOnTarget: "枠内シュートのゴール期待値",
        FinishingxGOT: "枠内シュートがゴールに終わる確率",
        DribblesAttempted: "90分あたりのドリブル試行回数",
        DribblesWonOwnHalf: "自陣でのドリブル成功数",
        DribblesOwnHalf: "自陣でのドリブル試行回数",
        DribblesOwnHalfPct: "自陣での合計ドリブル数に対するドリブル成功率",
        DribblesWonOppHalf: "敵陣でのドリブル成功数",
        DribblesOppHalf: "敵陣でのドリブル試行回数",
        DribblesOppHalfPct: "敵陣での合計ドリブル数に対するドリブル成功率",
        DribblesWonFinalThird: "ファイナルサードでのドリブル成功数",
        DribblesFinalThird: "ファイナルサードでのドリブル試行回数",
        DribblesFinalThirdPct: "ファイナルサードでの合計ドリブル数に対するドリブル成功率",
        ShotEndingHighRecoveries: "シュートで終わるハイリカバリー（相手ゴールから40メートル以内でのボール奪取）",
        PassingFinalThirdAgainst: "相手のファイナルサードへの成功したパス",
        OpenPlayPassesIntoOpponentBoxAgainst: "オープンプレー中に相手が自陣ボックス内に試みたパスの総数",
        EntriesOppBoxAgainst: "相手による自陣ボックスへのパスとドリブルの回数",
        DeepProgressionAgainst: "相手がボールを運んで最終5分の1に到達した回数＋自陣5分の1でのボール保持回数",
        TouchesInOpponentBoxAgainst: "相手が自陣ボックス内でボールを保持した回数",
        Score: "さまざまな指標に基づくプレーヤーのパフォーマンス",
        PDScore: 'さまざまな身体的指標に基づく選手の身体的パフォーマンス',
        OrlegiScore: "さまざまな指標に基づくプレーヤーのパフォーマンス",
        SirScore: "さまざまな指標に基づくプレーヤーのパフォーマンス",
        xTOPInTeam: "90分間のチームの合計に対して、インプレーで生まれた脅威期待値 (xT)",
        YellowCards: "受けたイエローカード",
        RedCards: "受けたレッドカード",
        xTOpenPlayAgainst: "90分間のセットプレーではなく、インプレーから与えられる脅威期待値",
        xTSetPieceAgainst: "90分間のインプレーではなく、セットプレーから与えられる脅威期待値",
        NPGOpenPlayAgainst: "90分間のインプレーで与えたゴール、PKは除く",
        NPGSetPieceAgainst: "90分間のセットプレーで与えたゴール、PKは除く",
        PassesOppHalfPerPossession: "ポゼッション毎の敵陣でのパス",
        AverageTimeRecovery: "ボールを奪うまでの平均時間",
        ExpectedPassing: "合格見込み",
        NumPossession10Passes: "ポゼッション 10パス",
        PassesReceived: "パス獲得数",
        PassesReceivedFinalThird: "最終パス数 ⅓ 最終パス数 ⅓ 最終パス数 ⅓ 最終パス数",
        ProgressivePassesTotalPct: "プログレッシブ・パス",
        ShortPassesPct: 'ショートパス',
        TouchesOppBoxOppTeam: "選手が出場している間に自陣ペナルティエリア内で許した相手のアクション数",
        ShotsOnTargetOppTeam: "選手が出場している間に被シュート（枠内）数",
        NPGOppTeam: "選手が出場している間に被ゴール（PK除く）数",
        //Physical Stats
        TotalDistance: "総走行距離",
        HsrDistance: "速度 19.8 km/h 以上の距離",
        HsrNumber: "速度 19.8 km/h 以上のスプリント回数",
        HsrDistancePct: "合計距離に対する速度 19.8 km/h 以上の距離の %",
        SprintsNumber: "速度 25.2 km/h 以上のスプリント回数",
        SprintsDistance: "速度 25.2 km/h 以上の距離",
        SprintNumberDeclinePct: "前後半でのスプリント数の % の差",
        SprintDistanceDeclinePct: "前後半でのスプリント距離の % の差",
        SprintDistancePct: "総距離に対するスプリントした距離の割合",
        Accelerations: "加速量",
        MaxSpeed: "試合のある時点で到達した最大速度",
        AvgMaxSpeed: "選手が記録した平均最高速度",
        MaxAccelerations: "選手が記録した最大加速度（メートル/秒²）",
        BypassedDefendersByPasses: "タッチイベントの開始時にボール保持者よりゴール側にいる守備選手の数から、終了時の守備選手の数を引いた数",
        PassesBypassingPlayers: "選手を突破したパスの数",
        PassesBypassingDefenders: "守備選手を突破したパスの数",
        BypassedPlayersPerPass: "パスごとに突破された選手の合計数",
        BypassedDefendersPerPass: "パスごとに突破された守備選手の合計数",
        LineBreakingPasses: "ボールを相手ゴールに少なくとも10%近づけ、近接する守備選手のペアを交差する、または守備ラインを超えるパスの数",
        LineBreakingPassesMD: "中盤ラインと最終ラインを突破した成功パス",  
        LineBreakingPassesM: "中盤ラインを突破した成功パス",  
        LineBreakingThroughBalls: "最終ラインを突破した成功パス",
        LineBreakingPassesPerPass: "パスごとに突破したラインの数",
        TotalPassesUnderStrongPressure: "強いプレッシャー下で行われたパスの合計数（相手選手から0～2メートル以内）",
        TotalPassesUnderLightPressure: "軽いプレッシャー下で行われたパスの合計数（相手選手から2～5メートル以内）",
        SuccessfulPassesUnderStrongPressure: "強いプレッシャー下で成功したパスの数（相手選手から0～2メートル以内）",
        SuccessfulPassesUnderLightPressure: "軽いプレッシャー下で成功したパスの数（相手選手から2～5メートル以内）",
        PassingUnderStrongPressure: "強いプレッシャー下での成功パスの割合（相手選手から0～2メートル以内）",
        PassingUnderLightPressure: "軽いプレッシャー下での成功パスの割合（相手選手から2～5メートル以内）",
        PassReceiptsInSpaceCompleted: "受け手が攻撃側ハーフ内でゴール方向に5メートル以内に守備選手がいない場合のパス",
        PassReceiptsInSpace: "攻撃側ハーフ内でゴール方向に5メートル以内に守備選手がいない場合に受け取ったパス",
        TotalStrongOnBallPressures: "強いプレッシャー（ボール保持者から0～2メートル以内）の数",
        TotalLightOnBallPressures: "プレッシャー（ボール保持者から2～5メートル以内）の数",
        SuccessfulStrongOnBallPressures: "成功した強いプレッシャー（ボール保持者から0～2メートル以内）の数",
        SuccessfulLightOnBallPressures: "成功したプレッシャー（ボール保持者から2～5メートル以内）の数",
        StrongOnBallPressuresPct: "成功した強いプレッシャーの割合（ボール保持者から0～2メートル以内）",
        LightOnBallPressuresPct: "成功したプレッシャーの割合（ボール保持者から2～5メートル以内）",
        TimesBypassedByPasses: "パスによって突破された合計回数",
        TimesBypassedByCarries: "ドリブルによって突破された合計回数",
        TimesBypassedByActions: "パスとドリブルの合計で突破された合計回数",
        BypassedPlayersByCarries: "ドリブルで突破された相手（DFとMF）の合計人数",
        BypassedDefendersByCarries: "ドリブルで突破された相手（DF）の合計人数",
        BypassedPlayersByActions: "パスとドリブルの合計で突破された相手（DFとMF）の合計人数",
        BypassedDefendersByActions: "パスとドリブルの合計で突破された相手（DF）の合計人数",
        CarriesBypassingPlayers: "相手選手を突破したドリブルの回数",
        CarriesBypassingDefenders: "DFを突破したドリブルの回数",
        BypassedPlayersPerCarry: "1回のドリブルで突破した相手選手の平均数",
        BypassedDefendersPerCarry: "1回のドリブルで突破したDFの平均数",
        LineBreakingCarries: "守備ラインを突破したドリブルの回数",
        LineBreakingCarriesMD: "MFラインとDFラインを突破したドリブルの回数",
        LineBreakingCarriesM: "MFラインを突破したドリブルの回数",
        LineBreakingCarriesD: "DFラインを突破したドリブルの回数",
        LineBreakingCarriesPerCarry: "ドリブルごとのライン間突破率",
        LineBreakingActions: "守備ラインを突破したパスとドリブルの合計回数",
        LineBreakingActionsMD: "MFラインとDFラインを突破したパスとドリブルの合計回数",
        LineBreakingActionsM: "MFラインを突破したパスとドリブルの合計回数",
        LineBreakingActionsD: "DFラインを突破したパスとドリブルの合計回数",
        PassesPerLineBreakingPass: "ライン間突破パス1本あたりの全パス数の比率",
        CarriesPerLineBreakingCarry: "ライン間突破ドリブル1本あたりの全ドリブル数の比率",
        LinesBrokenByPasses: "パスで突破したラインの合計数",
        LinesBrokenByCarries: "ドリブルで突破したラインの合計数",
        LinesBrokenByActions: "パスとドリブルの合計で突破したラインの合計数",
        LinesBrokenPerPass: "1本のパスで突破したラインの平均数",
        LinesBrokenPerCarry: "1本のドリブルで突破したラインの平均数",
        AvgLastDefenderDistanceIP: "最後のディフェンダー（自陣ゴールに最も近い選手）とゴールラインの距離（ボール保持時）",
        AvgLastDefenderDistanceOOP: "最後のディフェンダー（自陣ゴールに最も近い選手）とゴールラインの距離（非保持時）",
        AvgDefensiveLineDistanceIP: "最も深いディフェンスラインとゴールの距離（ボール保持時）",
        AvgDefensiveLineDistanceOOP: "最も深いディフェンスラインとゴールの距離（非保持時）",
        AvgRBDistanceIP: "右サイドバックと自陣ゴールの距離（ボール保持時）",
        AvgRBDistanceOOP: "右サイドバックと自陣ゴールの距離（非保持時）",
        AvgLBDistanceIP: "左サイドバックと自陣ゴールの距離（ボール保持時）",
        AvgLBDistanceOOP: "左サイドバックと自陣ゴールの距離（非保持時）",
        AvgBlockDistanceIP: "最も後方と最も前方のフィールドプレーヤー間の距離（ボール保持時）",
        AvgBlockDistanceOOP: "最も後方と最も前方のフィールドプレーヤー間の距離（非保持時）",
        AvgBlockAreaIP: "全フィールドプレーヤーを囲むバウンディングボックスの面積（チームの占有スペース）ボール保持時",
        AvgBlockAreaOOP: "全フィールドプレーヤーを囲むバウンディングボックスの面積（チームの占有スペース）非保持時",
        AvgDefensiveLineWidthOOP: "最も後方の選手ラインの横幅（非保持時）",
        AvgOffensiveLineLastThirdWidthIP: "最終サードにおけるオフェンスラインの横幅（ボール保持時）",
        AvgLByIP: "左サイドバックの位置（ボール保持時）",
        AvgRByIP: "右サイドバックの位置（ボール保持時）",
        AvgOffensiveLineDistanceIP: "自陣ゴールとオフェンスライン間の距離（ボール保持時）",
        AvgOffensiveLineLastThirdDistanceIP: "自陣ゴールと最終サードのオフェンスラインの距離（ボール保持時）",
        AvgOffensiveLineWidthIP: "オフェンスラインの横幅（ボール保持時）",
        OffBallRuns: "攻撃をサポートする意図的なオフザボールの動き（ラン）",
        OffBallRunsOverlap: "味方がボールを持っている際に、サイドライン側（外側）を回って走る動き",
        OffBallRunsUnderlap: "味方の内側（ピッチ中央側）を通って走る動き",
        OffBallRunsRunAhead: "ボール保持者を追い越して前に出るが、最終ラインより手前で止まる動き",
        OffBallRunsRunBehind: "最終ディフェンスラインを突破し、ディフェンダーとゴールキーパーの間に入る動き",
        OffBallRunsCrossReceiver: "クロスを受けるためにエリア内に走り込む動き",
        OffBallRunsSupport: "ボール保持者に並ぶ位置へ走り、近くでパスの選択肢となる動き",
        OffBallRunsComingShort: "ボール保持者に近づいてサポートやパスの受け手となる動き",
      },
      abbr:{
        Possession: "POS%",
        TimePossession: "TP",
        PassesPerShots: "PPS",
        PPDA: "PPDA",
        ExpectedPoints: "xP",
        Points: "P",
        Directness: "DIR",
        PassesPerLongBall: "PPLB",
        CrossingPerXG: "CPxG",
        PenaltySavedPenaltyFaced: "PSPF",
        Goals: "GOA",
        NonPenaltyGoals: "NPG",
        NPGOpenPlay: "NPGOP",
        NPGSetPiece: "NPGSP",
        Shooting: "SHO%",
        Finishing: "FIN%",
        xGEfficiency: "xGE",
        HeaderPerShot: "HPS",
        HeaderPerCross: "HPC",
        Assists: "ASS",
        ThroughBalls: "TB",
        CrossEfficiency: "CE",
        ScoringContribution: "SC",
        xAssistsOpenPlay: "xAOP",
        xAssistsSetPiece: "xASP",
        xAssistsOpenPlayInTeam: "xAOPiT",
        xAssistsSetPieceInTeam: "xASPiT",
        xGBuildupFinalThird: "xGBUPFT",
        xGChainFinalThird: "xGCFT",
        BallProgressionPassing: "BPP",
        BallProgressionDribbling: "BPD",
        TacklesWasDribbled: "TWD%",
        TacklesSuccessful: "STA",
        Interceptions: "INT",
        Clearances: "CLE",
        Fouls: "FOU",
        Recoveries: "REC",
        Shots: "SHO",
        ShotsPerGoal: "SPG",
        ShortPassesSuccessful: "SPS",
        PassingSuccessForwardPct: "PSF%",
        PassingSuccessBackwardPct: "PSB%",
        PassingForwardBackwardPct: "PFB%",
        LongBallPerPassesPct: "LBP%",
        LongBallReceived: "LBR",
        LongBallReceivedOppHalf: "LBROH",
        OffensiveActions: "OA",
        DribblesAttempted: "DAT",
        SuccessfulDribblesPct: "SD%",
        OffensiveTouchesOutBoxPct: "OTOB%",
        BallRetention: "BR",
        PassingPct: "PA%",
        PassingOwnHalfPct: "POH%",
        PassingOppHalfPct: "POPH%",
        PassingFinalThird: "PFT",
        PassingFinalThirdPct: "PT%",
        LongBallSuccessful: "LBS",
        LongBallPct: "LB%",
        SavesPct: "S%",
        SavesInBoxPct: "SIB%",
        SavesOutOfBoxPct: "SOOB%",
        xGSavedPerXGFacedOnTarget: "xGSPFOT",
        xGFacedOnTargetPerGoalReceived: "xGFOTPGR",
        xGFacedOnTargetEfficiency: "xGFOTE",
        xGFacedOnTarget: "xGFOT",
        IndividualPressure: "IP",
        AerialEfficiency: "AE",
        AerialWins: "AEW",
        AerialWinsPct: "AE%",
        xG: "xG",
        xGDiff: "xGD",
        xGOpenPlay: "xGOP",
        xGSetPiece: "xGSP",
        xGPerShot: "xGPS",
        ChancesCreated: "CC",
        CompletedCrosses:"SCR",
        Crossing: "CR%",
        OpenPlayKeyPasses: "OPKP",
        OpenPlayKeyPassesInTeam: "OPKPiT%",
        OpenPlayPassesIntoOpponentBox: "OPPOPPB",
        OpenPlayPassesIntoOpponentBoxSuccessful: "OPPOPPBS",
        xAssists: "xA",
        xGChain: "xGC",
        xGBuildup: "xGBUP",
        xGBuildupInTeam: "xGBUPiT",
        BallProgression: "BP",
        SuccessfulDribbles: "SDR",
        Dispossessed: "TOV",
        TouchesInOpponentBox: "TOB",
        xGSavedPerShot: "xGSS",
        BallRetentionOppHalf: "BROPPH",
        DeepProgression: "DP",
        DeepProgressionFinalThird: "DPFT",
        FoulsTaken: "FOUR",
        PenaltiesTaken: "PT",
        BlockedCrosses: "BC",
        BlockedShots: "BS",
        Blocks: "BLO",
        NonPenaltyGoalsAgainst: "NPGC",
        Headers: "HEA",
        AveragePassDistance: "APD",
        ProgressiveRuns: "PRC",
        xT: "xT",
        xTOpenPlay: "xTOP",
        xTSetPiece: "xTSP",
        xGOT: "xGOT",
        BadActions: "BA",
        BadActionsOwnHalf: "BAOH",
        AerialsWonOwnBox: "AWOB",
        AerialsWonOppBox: "AWOPPB",
        AerialsTotalOppBox: "ATOPPB",
        AerialsTotalOwnBox: "ATOB",
        FoulsOwnHalfPct: "FOH%",
        RecoveriesOppHalf: "ROH",
        DuelsPct: "D%",
        TacklesUnsuccessful: "UTA",
        LongBallSuccessful: "SLB",
        TacklesWasDribbledFirstThird: "TWDFT",
        TacklesWasDribbledSecondThird: "TWDST",
        TacklesWasDribbledFinalThird: "TWDFT",
        BallProgressionFinalThird: "BPFT",
        DuelsTotal: "DT",
        QuickRecoveries: "QR",
        ShotsPerNPG: "SPNPG",
        ShotsOutBox: "SOB",
        GoalsOutBox: "GOB",
        ShootingOutBox: "SOB%",
        HandPassing: "HP",
        Catching: "CAT",
        ClaimAccuracy: "CA",
        HighTurnovers: "HTOV",
        ShotEndingHighTurnovers: "SEHT",
        GoalEndingHighTurnovers: "GEHT",
        AverageCarriesProgress: "ACP",
        ChanceEndingCarries: "CEC",
        AssistEndingCarries: "AEC",
        ShotEndingCarries: "SEC",
        GoalEndingCarries: "GEC",
        ShotEndingSequence: "SES",
        GoalEndingSequence: "GES",
        xGPerNPG: "xGPNPG",
        AerialWonOffensive: "AWO",
        AerialWonDefensive: "AWD",
        xGAgainst: "xGC",
        xGDiffAgainst: "xGDC",
        xGPerNPGAgainst: "xGPNPGA",
        xGOpenPlayAgainst: "xGOPC",
        xGSetPieceAgainst: "xGSPC",
        xGPerShotAgainst: "xGSC",
        ShotsAgainst: "STC",
        ShotsOnTargetAgainst: "SOTC",
        RivalPossession: "RP",
        AerialDefensivePct: "AD%",
        HighRecoveries: "HR",
        HighDefensiveActionPct: "HDA%",
        HighDefensiveDistance: "HDD",
        PassesPerPossession: "PPP",
        LengthPerPossession: "LPP",
        xTNet: "xTN",
        AvgCarriesDistance: "ACD",
        PassesForwardPct: "PF%",
        TacklesAttempted: "ATA",
        DuelsLost: "DL",
        Carries: "CARR",
        CarriesPct: "CARR%",
        Aerials: "AER",
        ProgressivePassesReceivedIntoBox: "PPRIB",
        PassesOppHalf: "POPH",
        ShotsOnTarget: "SOT",
        AggressiveActions: "AA",
        Crosses: "CRO",
        xGBuildup5pass: "xGBUP5",
        DefensiveDistance: "DD",
        SpeedSequence: "SS",
        Touches: "TOU",
        AerialsTotalOppHalf: "ATOPPH",
        AerialsOppHalf: "AOPPH",
        AerialsWonOppHalfPct: "AWOH%",
        AerialsPctOppBox: "AOPPB%",
        AerialsPctOwnBox: "AOB%",
        AerialDefensive: "AD",
        AerialOffensive: "AO",
        AerialOffensivePct: "AO%",
        IndividualPressureOppHalf: "IPOPPH",
        ChancesCreatedOP: "CCOP",
        TouchesPerShot: "TPS",
        PassesFinalThirdTotalPct: "PFT%",
        xACrosses: "xAC",
        Passes: "PAS",
        PassesSuccessful: "SPA",
        TacklesWasDribbledFouls: "TWDF",
        OffsidesCaught: "OC",
        ProgressivePassesReceivedFinalThird: "PPRFT",
        ProgressivePassesReceived: "PPR",
        Breadth: "BRD",
        DuelsDefTotal: "DDT",
        DefensiveActions: "DA",
        ProgressivePassesReceivedOppHalf: "PPROH",
        CompletedCrossesOP: "CCOP",
        CrossingOP: "COP",
        PassingContribution: "PC",
        BallProgressionOppHalfInTeam: "BPOPPHiT",
        PassesOPIntoBoxInTeam: "POBIT",
        TouchesOppBoxInTeam: "TOBIT",
        xGOPInTeam: "xGOPiT",
        DeepPasses: "DP",
        DefensiveDuelsPct: "DD%",
        DefensiveDistance: "DD",
        QuickRecoveriesPct: "QR%",
        DiffDefensiveDistanceTeam: "DDDT",
        xTPassing: "xTP",
        xTPassing100Passes: "xTP100",
        ProgressivePassesAccurate: "APP",
        xP: "xP",
        PassAbility: "PA",
        OPPassesIntoOppBoxPct: "OPPIOB%",
        EntriesOppBox: "EOPPB",
        Crosses6yardBox: "C6YB",
        Cutbacks: "CUT",
        xTDribbling: "xTD",
        AvgShotDistance: "ASD",
        xGOnTarget: "xGOT",
        FinishingxGOT: "FxGOT",
        DribblesWonOwnHalf: "DWOH",
        DribblesOwnHalf: "DOH",
        DribblesOwnHalfPct: "DOH%",
        DribblesWonOppHalf: "DWOPH",
        DribblesOppHalf: "DOPH",
        DribblesOppHalfPct: "DOPH%",
        DribblesWonFinalThird: "DWFT",
        DribblesFinalThird: "DFT",
        DribblesFinalThirdPct: "DFT%",
        ShotEndingHighRecoveries: "SEHR",
        PassingFinalThirdAgainst: "PFTC",
        OpenPlayPassesIntoOpponentBoxAgainst: "OPPOBC",
        EntriesOppBoxAgainst: "EOBC",
        DeepProgressionAgainst: "DPC",
        TouchesInOpponentBoxAgainst: "TOBC",
        Score: "SCO",
        PDScore: "SCO",
        OrlegiScore: "SCO",
        SirScore: "SCO",
        xTOPInTeam: "xTOPiT",
        YellowCards: "YC",
        RedCards: "RC",
        xTOpenPlayAgainst: "xTOPC",
        xTSetPieceAgainst: "xTSPC",
        NPGOpenPlayAgainst: "NPG OPC",
        NPGSetPieceAgainst: "NPG SPC",
        PassesOppHalfPerPossession: "POHP",
        AverageTimeRecovery: "ATR",
        ExpectedPassing: "xP%",
        NumPossession10Passes: "P10P",
        PassesReceived: "PR",
        PassesReceivedFinalThird: "PRLFT",
        ProgressivePassesTotalPct: "PP%",
        ShortPassesPct: "SP%",
        TouchesOppBoxOppTeam: "TOBOT",
        ShotsOnTargetOppTeam: "SOTOT",
        NPGOppTeam: "NPGOT",
        //Physical Stats
        TotalDistance: "DST",
        WalkingDistance: "WLKD",
        JoggingDistance: "JOGD",
        RunningDistance: "RUND",
        ExtremeAccelerations: "XACC",
        NumberOfRuns: "RUNQ",
        HsrDistance: "HSRD",
        HsrNumber: "HSRQ",
        HsrDistancePct: "HSRD%",
        SprintsNumber: "SPRQ",
        SprintsDistance: "SPRD",
        SprintNumberDeclinePct: "SQD%",
        SprintDistanceDeclinePct: "SDD%",
        SprintDistancePct: "SPRD%",
        Accelerations: "ACC",
        MaxSpeed: "MS",
        AvgMaxSpeed: "AvgMS",
        MaxAccelerations: "MACC",
        BypassedPlayersByPasses: "ByPP",
        BypassedDefendersByPasses: "ByPD",
        PassesBypassingPlayers: "PByPP",
        PassesBypassingDefenders: "PByPD",
        BypassedPlayersPerPass: "ByPPPP",
        BypassedDefendersPerPass: "ByPDPP",
        LineBreakingPasses: "LBP",
        LineBreakingPassesMD: "LBPMD",
        LineBreakingPassesM: "LBPM",
        LineBreakingThroughBalls: "LBTB",
        LineBreakingPassesPerPass: "LBPP",
        TotalPassesUnderStrongPressure: "TPUSP",
        TotalPassesUnderLightPressure: "TPUP",
        SuccessfulPassesUnderStrongPressure: "SPUSP",
        SuccessfulPassesUnderLightPressure: "SPULP",
        PassingUnderStrongPressure: "PUSP%",
        PassingUnderLightPressure: "PULP%",
        PassReceiptsInSpaceCompleted: "PRMS",
        PassReceiptsInSpace: "PRS",
        TotalStrongOnBallPressures: "TSBP",
        TotalLightOnBallPressures: "TBP",
        SuccessfulStrongOnBallPressures: "SSBP",
        SuccessfulLightOnBallPressures: "SLBP",
        StrongOnBallPressuresPct: "SBP%",
        LightOnBallPressuresPct: "BP%",
        TimesBypassedByPasses: "ByPPAS",
        TimesBypassedByCarries: "ByPC",
        TimesBypassedByActions: "ByPA",
        BypassedPlayersByCarries: "ByPPC",
        BypassedDefendersByCarries: "ByPDC",
        BypassedPlayersByActions: "ByPPA",
        BypassedDefendersByActions: "ByPDA",
        CarriesBypassingPlayers: "CByPP",
        CarriesBypassingDefenders: "CByPD",
        BypassedPlayersPerCarry: "ByPPPC",
        BypassedDefendersPerCarry: "ByPDPC",
        LineBreakingCarries: "LBC",
        LineBreakingCarriesMD: "LBCMD",
        LineBreakingCarriesM: "LBCM",
        LineBreakingCarriesD: "LBCD",
        LineBreakingCarriesPerCarry: "LBCC%",
        LineBreakingActions: "LBA",
        LineBreakingActionsMD: "LBAMD",
        LineBreakingActionsM: "LBAM",
        LineBreakingActionsD: "LBAD",
        PassesPerLineBreakingPass: "PPLBP",
        CarriesPerLineBreakingCarry: "CPLBC",
        LinesBrokenByPasses: "LBByP",
        LinesBrokenByCarries: "LBByC",
        LinesBrokenByActions: "LBByA",
        LinesBrokenPerPass: "LBPP",
        LinesBrokenPerCarry: "LBPC",
        AvgLastDefenderDistanceIP: "ALDDIP",
        AvgLastDefenderDistanceOOP: "ALDDIP",
        AvgDefensiveLineDistanceIP: "ALDDIP",
        AvgDefensiveLineDistanceOOP: "ALDDIP",
        AvgRBDistanceIP: "ARBDIP",
        AvgRBDistanceOOP: "ARBDOOP",
        AvgLBDistanceIP: "ALBDIP",
        AvgLBDistanceOOP: "ALBDOOP",
        AvgBlockDistanceIP: "ABDIP",
        AvgBlockDistanceOOP: "ABDOOP",
        AvgBlockAreaIP: "ABAIP",
        AvgBlockAreaOOP: "ABAOOP",
        AvgDefensiveLineWidthOOP: "ADLWOOP",
        AvgOffensiveLineLastThirdWidthIP: "AOLLTWIP",
        AvgLByIP: "ALBIP",
        AvgRByIP: "ARBIP",
        AvgOffensiveLineDistanceIP: "AOLDIP",
        AvgOffensiveLineLastThirdDistanceIP: "AOLTDIP",
        AvgOffensiveLineWidthIP: "AOLWIP",
        OffBallRuns: "OBR",
        OffBallRunsOverlap: "OBRO",
        OffBallRunsUnderlap: "OBRU",
        OffBallRunsRunAhead: "OBRA",
        OffBallRunsRunBehind: "OBRB",
        OffBallRunsCrossReceiver: "OBRCR",
        OffBallRunsSupport: "OBRS",
        OffBallRunsComingShort: "OBRCS",
      }
    },
    team: {
      title: "チームシート",
      subtitle: "チームの特徴や統計をより深く知る",
      averageAge: "平均年齢",
      transferBalance: "移籍収支",
      roster: "登録選手",
      transfers: "移籍",
      trends: "トレンド",
      loans: "レンタル移籍",
      loanFrom: "レンタル",
      loanTo: "レンタル",
      latestGames: "最近の試合",
      latestXGames: "最近の {0} 試合",
      playingFor: "Juega para",
      overview:"概要",
      visualization:"視覚化",
      location:"位置",
      outcome:"結果",
      beeswarm:"グラフ",
      parentTeam: "最初のチーム",
      childTeam: "下年代のチーム",
      preferredFormation: "よく使うフォーメーション",
      mostFrecuentFormations: "最も多いフォーメーション",
      viewType:"ビュータイプ",
      overviewTab: {
        axisXTotal: "トータル",
        axisXper90: "90で'",
        dataPerGameText: "試合毎のデータ",
        season: "シーズン",
        last: "最後の",
        current: "現在",
        TeamStyle: "スタイル",
        TeamDefensive: "守備",
        TeamOffensive: "攻撃",
        TeamCustom1: "カスタム 1",
        TeamCustom2: "カスタム 2",
        TeamCustom3: "カスタム 3",
        TeamCustom4: "カスタム 4",
        groups: {
          Goals: {
            name: "ゴール",
            desc: 'すべてのゴールが表示されます。(インプレーとセットプレーの両方、PK含む)'
          },
          Assists: {
            name: "アシスト",
            desc: "今シーズン最も多くのアシストをした選手。(インプレーとセットプレー) "
          },
          xG: {
            name: "ゴール期待値",
            desc: "インプレーとセットプレーでのゴール期待値。合計 xG の降順で表示します。"
          },
          xA: {
            name: "アシスト期待値",
            desc: "インプレーとセットプレーでのアシスト期待値。"
          },
          Finishing: {
            name: "フィニッシング",
            desc: "シュートがゴールに入った割合"
          },
          ScoringContribution: {
            name: "ゴールへの貢献",
            desc: "チームのアシスト数とゴール数"
          },
          xT: {
            name: "脅威期待値",
            desc: "インプレーとセットプレー、ネガティブで生まれた脅威期待値"
          },
        },
        stats: {
          openPlay: "インプレー",
          setPiece: "セットプレー",
          negative: "ネガティブ",
          npg: "PK抜きのゴール",
          goalsPenalty: "PKでのゴール",
          npgOpenPlay: "インプレーでのゴール（PK抜き）",
          npgSetPiece: "セットプレーでのゴール（PK抜き）",
          assists: "アシスト",
          assistsOpenPlay: "インプレーでのアシスト",
          assistsSetPiece: "セットプレーでのアシスト",
          xGOpenPlay:	"インプレー xG ",
          xGSetPiece:	"セットプレー xG ",
          xAOpenPlay:	"インプレー xA ",
          xASetPiece:	"セットプレー xA ",
          nonPenaltyShots: "PKを除くシュート数",
          penaltyShots: "PKでのシュート",
          xT: "脅威期待値",
          xTOpenPlay: "インプレー xT ",
          xTSetPiece: "セットプレー xT ",
          xTNeg: "ネガティブ xT ",
          totalFinishing: "フィニッシング",
          nonPenaltyFinishing: "PK抜きのフィニッシング",
          goalsPenaltyFinishing: "PKでのフィニッシング",
          walkingDistance: "歩行",
          joggingDistance: "ジョギング",
          runningDistance: "ランニング",
          hsrDistance: "HSR",
          sprintsDistance: "スプリント",
          runningNumber: "走行回数",
          hsrNumber: "HSRスプリント回数",
          sprintsNumber: "スプリント回数",
          maxSpeed: "最高速度",
          accelerations: "加速",
          extremeAccelerations: "極端な加速",
          maxAcceleration: "最大加速度"
        },
      },
      teamAnalysis: "チーム分析",
      agentView:{
        positions:{
          "gk": "ゴールキーパー",
          "leftFullback": "左サイドバック",
          "centralDefender": "センターバック",
          "rightFullback": "右サイドバック",
          "midfielder": "ミッドフィールダー",
          "attackingMidfielder": "トップ下",
          "leftWinger": "左ウインガー",
          "rightWinger": "右ウインガー",
          "fw": "フォワード"
        },
        groups: {
          "contractEnd":"月",
          "age":"年",
          "availability":"使用可能"
        },
        placer: {
          legend:"年齢、契約、プレー時間、パフォーマンスに基づく強さ"
        }
      },
      transfersTab:{
        valueMovements:"価値変動",
        valueTransfers:"移籍の価値",
        valueLoans:"レンタル移籍の価値",
        avgAgeMovements:"平均年齢変動",
        avgAgeTransfers:"移籍の平均年齢",
        avgAgeLoans:"レンタル移籍の平均年齢",
        operations:{
          buys:{
            "buy": "購入",
            "loan": "レンタル",
            "end of loan": "レンタル終了",
            "free transfer":"フリー移籍",
            "free":"フリー",
            "loan transfer":"レンタル移籍",
            "other":"その他"
          },
          sells:{
            "buy": "売却",
            "loan": "レンタル",
            "end of loan": "レンタル終了",
            "free transfer":"フリー移籍",
            "free":"フリー",
            "loan transfer":"レンタル移籍",
            "other":"その他",
            "retired": "撤退"
          }
        },
      },
      trendsTab: {
        streaks: "最近の結果",
        wins: "勝利",
        cleanSheets: "クリーンシート",
        goalPeriods: "時間帯あたりのゴール数",
        goalPeriods: "得点した期間",
        concededGoalPeriods: "失点した期間",
        comebacks: "逆転",
        avgTime: "平均時間",
        kindOfGoals: "ゴールの種類",
        percentWinning: "勝っている %",
        percentDrawing: "引き分けている %",
        percentLosing: "負けている %",
        totalOf: "の合計",
        minutes: "時間",
        before: "前",
        after: "後",
        playedOn: "日付",
        scored: "スコア",
        conceded: "与えた",
        ownGoals: "オウンゴール",
        phasesOfGame: "プレーの局面",
        buildup: "ビルドアップ",
        midfieldProgression: "中盤の前進",
        attackOpposition: "相手への攻撃",
        attackingTransition: "攻撃への切り替え",
        highPress: "ハイプレス",
        midBlock: "ミッドブロック",
        lowBlock: "ローブロック",
        defensiveTransition: "守備への切り替え"
      },
      onOff: "On/Off",
      dragUpTo5Players: "最大5人のプレイヤーをドラッグ",
      selectUpTo5Players: "最大5人のプレイヤーを選択",
      onOffTab:{
        G90:"ゴール 90",
        GA90:"被ゴール 90",
        diffG90:"ゴール差 90",
        XG90:"xG 90",
        XGA90:"被 xG 90",
        diffXG90:"差 xG 90",
        playersOn:"コンビネーション ON",
        playersOff:"コンビネーション OFF",
        ground:"グラウンド",
        playersOnThePitch:"フィールド上の選手",
        playersOffThePitch:"フィールド外の選手",
        attackTitle:"攻撃",
        attackSubTitle:"攻撃的戦術",
        defenseTitle:"ディフェンス",
        defenseSubTitle:"守備的戦術",
        associationTitle:"連携",
        associationSubTitle:"連携的戦術",
        comboOn: "コンビネーションON",
        comboOff: "コンビネーションOFF",
        "diffGoals90": "ゴール差 90",
        "goals90": "PK除くゴール 90",
        "goalsAgainst90": "PK除く被ゴール 90",
        "xgAgainstPer90": "被 xG 90",
        "xgDiffPer90": "xG 差 90",
        "xgPer90": "xG 90",
        "xt90": "xT 90",
        "shotsOnTarget90": "90分での枠内シュート",
        "touchesOppBox90":"ペナルティーエリア内タッチ 90",
        "shotsOnTargetAgainst90":"90分での被枠内シュート",
        "ppda90":"PPDA 90",
        "xa90":"xA 90",
        "directness90":"縦性 90",
        "possession":"ポゼッション %",
        "pctPasses":"パス %",
        "pctPassesFinalThird":"ファイナルサードパス %",
        placeholder: "チームを選択して開始",
        subtitle: "ラインアップから選手を追加または削除してチームの指標を最適化"
      },
      terms:{
        short:"短期間",
        mid:"中期間",
        long:"長期間",
      },
      report: {
        title: 'チームレポート',
        selectedPeriod: '選択期間',
        stackedCharts: '積み上げグラフ',
        generalData: '一般データ',
        scoringChances: '得点チャンス',
        areasReport: 'エリアレポート',
        setPieceReport: 'セットプレーレポート',
        corners: 'コーナー',
        cornersAgainst: '被コーナー',
        indirectFreeKicks: '間接フリーキック',
        indirectFreeKicksAgainst: '被間接フリーキック',
        freeKicks: 'フリーキック',
        freeKicksAgainst: '被フリーキック',
        penaltys: 'ペナルティ',
        freeKicksContribution: 'フリーキック貢献',
        shotsContribution: 'シュート貢献',
        topXPlayersByStats: 'トップ {x} 選手の統計',
        lastShotZone: '最後のシュートゾーン',
        throwSide: 'スローイン側',
        kindOfThrow: 'スローインの種類',
        scored: '得点',
        against: '被得点',
        perGame: '1試合あたり',
        total: '合計',
        efficiency: '効率',
        organizedAttack: '組織的攻撃',
        offTransition: '攻撃の切り替え',
        chances: 'チャンス',
        chancesScored: '得点チャンス成功',
        chancesAgainst: '被チャンス',
        goalsScored: '得点数',
        goalsAgainst: '被得点数',
        goalsOrganizedAttack: '組織的攻撃の得点',
        goalsOffTransition: '切り替え攻撃の得点',
        goalsSetPiece: 'セットプレーの得点',
        goalsOrganizedAttackScored: '組織的攻撃の得点成功',
        goalsOrganizedAttackAgainst: '組織的攻撃の被得点',
        goalsOffTransitionScored: '切り替え攻撃の得点成功',
        goalsOffTransitionAgainst: '切り替え攻撃の被得点',
        goalsSetPieceScored: 'セットプレーの得点成功',
        goalsSetPieceAgainst: 'セットプレーの被得点',
        crossSide: 'クロスの側',
        externalShot: 'ミドルシュート',
        innerPlay: 'インナープレー',
        throwIn: 'スローイン',
        box: 'ペナルティエリア',
        zone2: 'ゾーン2',
        goalsPerPhases: 'フェーズごとの得点'
      },      
      minutesAlert:"*450分以上プレーしたプレイヤーのみを表示",
      minutesException:"450分以上プレーした選手はいません。すべての選手が表示されます。",
      analysis: "分析",
      substitutions:"交代",
      attackZones:"アタッキングゾーン",
      formations:"フォーメーション",
      shotZones:"シュートゾーン",
      crossings:"センタリング",
      byTime:"時間で",
      byPosition:"ポジションで",
      byPlayer:"選手で",
      W:"勝っている",
      D:"引き分けている",
      L:"負けている",
      substitutionsByGame:"試合ごとの交代",
      substitutionsShort:"交代",
      avgSeasonShort:"シーズン平均",
      startingAt:"で始まる",
      endingAt:"で終わる",
      startingAtInfo: "最初のイベントの位置に基づいた所有権の割合を示します",
      endingAtInfo: "最後のイベントの位置に基づいた所有権の割合を示します",
      endingWithShot:"シュートで終える",
      endingInBox:"ペナルティーエリアで終わる",
      pfX:"基本フォーメーション {x}",
      bySide: "サイドで",
      cornerKicks:"コーナーキック",
      included: "含む",
      excluded:"除く",
      onlyCorner:"コーナーのみ",
      sizeByMarketValue:"市場価値によるサイズ",
      timeInTeam:"チームでの季節",
      newSignings:"新しい補強選手",
      sizeBy:"大きさで",
      connections:"コネクション",
      assistant:"アシストした選手",
      finisher:"シュートした選手",
      playersMinutesAlert: "選択したシーズンで出場時間がある選手のみを表示"
    },
    leagueTable: {
      subtitle: "リーグがどのように発展するかを分析する"
    },
    leagueMatchdays: {
      byRound: "ラウンド別",
      byDate: "日付別",
      byTeam: "チーム別"
    },    
    teamStats: {
      subtitle: "チームのパフォーマンスを比較する",
      xGDiffPerGame: "xG 差",
      xGDiffPerGameExplicit: "ゴール期待値とゴールの差",
      expectedPointsDiff: "xP 差",
      expectedPointsDiffExplicit: "ポイント期待値とポイントの差",
      games: "試合",
      gamesExplicit: "行われた試合",
      pointsPerGame: "試合毎のポイント",
      pointsPerGameExplicit: "試合毎のポイント",
    },
    roles: {
      "ROLE_USER": "ユーザー",
      "ROLE_ADMIN": "管理者",
      "ROLE_REPORTS": "レポート",
      "ROLE_API": "Driblab API",
      "ROLE_PHYSICAL_DATA": "物理データ",
      "ROLE_VIDEO": "Capture",
      "ROLE_EVENTING_DATA": "Driblab XY",
      "ROLE_DRIBLAB_HUB": "Driblab Hub",
      "ROLE_TRACKING": "トラッキング ",
      "ROLE_ARRIGO": "Arrigo",
      "ROLE_API_description": "選手、チーム、試合、リーグ情報をJSON形式で簡単に抽出。",
      "ROLE_EVENTING_DATA_description": "レーダーチャート、選手ランキング、マップなど、+100のパフォーマンス指標に基づいた統計に深く入り込もう。",
      "ROLE_PHYSICAL_DATA_description": "フィットネスデータにアクセスし、さまざまなパフォーマンス指標（距離、スピード、スプリント、加速度など）で選手をフィルタリング。",
      "ROLE_VIDEO_description": "ビデオやラインアップを提供し、詳細な分析のためにイベントや統計でタグ付けされたゲームを取得します。",
      "ROLE_DRIBLAB_HUB_description": "カレンダー、メモ、アラート、ドキュメント共有により、スカウティングタスクを効率的に追跡・管理。",
      "ROLE_TRACKING_description": "APIを通じて試合中の全選手のポジションデータを受け取り、包括的な分析を行う。",
      "ROLE_ARRIGO_description": "イベントデータとトラッキングデータを組み合わせ、従来を超えた革新的な指標を作成し、あらゆるアクションに価値を加えます。",
      "ROLE_REPORTS_description": "私たちのアナリストチームから詳細なスカウティングレポートをリクエストして、完璧なチームや選手を見つけましょう。"
    },
    administration: {
      pageSubtitle: "アプリケーションの運用管理",
      newClient: "Nuevo cliente",
      newUser: "Nuevo usuario",
      editClient: "Editar cliente",
      editUser: "Editar usuario",
      clientName: "Nombre",
      permissions: "Permisos",
      releaseUser: "Liberar usuario",
      connectAsUser: "Conectarse como",
      releaseModalTitle: "Confirmación para liberar usuario",
      releaseModalMessage: "El usuario recibirá un correo infomandole sobre su nueva cuenta. ¿Está seguro de notificarle?",
      clientType: {
        Driblab: "Driblab",
        Team: "Equipo",
        Brand: "Marca",
        Federation: "Federación",
        Media: "Medio de comunicación",
        Agency: "Agencia",
        Individual: "Persona física"
      },
      userType: {
        Ownership: "Propietario",
        SportingDirector: "Director deportivo",
        Brand: "Marca",
        Federation: "Federación",
        Media: "Medio",
        Agency: "Agente",
        Individual: "Persona física",
        Scout: "Ojeador",
        Coach: "Entrenador"
      },
      visibleYears: "Años visibles",
      areaModalTitle:"Confirmar Activar/Desactivar Ligas",
      areaModalMessage:"¿Está seguro de activar/desactivar todas las ligas del área seleccionada?",
      countStats:"Contar estadísticas",
      userClientModalTitle:"User already exists in another client",
      eventing: "Eventing",
      hub: "Hub"
    },
    dashboards: {
      lastGame: "最後の試合の分析",
      lastGameSimple: "最後の試合",
      seeAllGameInfo: "すべての情報を見る",
      nextGame: "次の試合",
      myTeam: "自分のチーム",
      lastMatchdayGames: "前節の試合",
      lastAdded: "最新の追加",
      myFavorites: "私のお気に入り",
      seeAllFavorites: "すべてのお気に入りを見る",
      placeholderFavorites: "プレーヤーの詳細から、お気に入りに追加できます",
      placeholderTeamFavorites: "You can add favorites from team detail",
      myCollections: "私のコレクション",
      placeholderCollections: "コレクションが作成されていません",
      lastCreated: "最新の作成",
      seeAllCollections: "すべてのコレクションを見る",
      seeRival: "ライバルチームをみる",
      seeMyTeam: "自分のチームをみる",
      title: "スコア表",
      subtitle: "ようこそ",
      recentPlayers: "最近のプレーヤー",
      lastScouted: "最近の検索",
      scout: "検索",
      reportsRequested: "レポート",
      lastRequested: "最近のリクエスト",
      goInbox: "受信箱へ行く",
      placeholderLastScouted: "左のバーまたは検索ツールでプレイヤーを検索できます",
      placeholderReports: "プレイヤーの詳細からレポートをリクエストできます",
      nationalPlayers: "他国で最も価値のある自国の選手",
      lastGames: "最近の試合",
      nationalPlayersShort: "他のリーグでプレーしている自国の選手",
      nextMatchdayGames: "次節の試合",
      injuredPlayers: "負傷中の選手",
      atPresent:"現時点では",
      seeAllPlayers:"全て見る",
      suspendedPlayers: "出場停止選手",
      placeholderInjured:"負傷中の選手はいません",
      teamValueImpacted: "チーム価値への影響",
      placeholderSuspended:"出場停止の選手はいません",
      placeholderNextGame:"試合がありません",
      placeholderNoGames:"まだ試合がありません",
      placeholderLastMatchDayNotFound:"前節は見つかりません。",
      placeholderNextMatchDayNotFound:"次節は見つかりません。",
      usersMostSearch:"最も検索数の多いユーザー",
      lastTwoDays:"最後の2日間",
      searchesHistory:"検索履歴",
      dayByDay:"一日ずつ",
      activeUsersTitle:"アクティブユーザー",
      activeUsersSubtitle: "過去 1 か月以内に接続したことがある",
      onlineUsersTitle:"オンラインユーザー",
      onlineUsersSubtitle: "過去1時間以内に検索しました",
      searchesPerformed:"実行された検索",
      onlyClients:"顧客のみ",
      activeClientsTitle:"活動中の顧客",
      activeClientsSubtitle: "少なくとも1人のユーザーはアクティブです",
      onlineUsersTitle:"オンラインのユーザー",
      onlineUsersSubtitle: "過去1時間以内に検索しました",
      searchesPerformed:"実行された検索",
      onlyClients:"顧客のみ",
      activeClientsTitle:"活動中の顧客",
      activeClientsSubtitle: "少なくとも1人のユーザーはアクティブです",
      last24Hours:"過去24時間",
      activityHistory:"活動履歴",
      loginHistory:"アクセス履歴",
      failLogins:"アクセスの失敗",
      successLogins:"アクセス成功",
      clientStats:"顧客スタッツ",
      playersMostSearch: "最も検索されている選手",
      toolsMoreUsed: "最も使用されているツール",
      hotPlayers:"傑出した選手",
      last_month:"前の月",
      last_week:"前週",
      last_day:"過去24時間",
      nClients:"顧客ナンバー",
      userDashboard: "ユーザー・ダッシュボード",
      userDashboardSubtitle: "口座活動の概要",
      offlineDaysOfClient: "各クライアントのオフライン日数",
      hideNoConnected: "未接続を非表示",
      onlyTrial: "試用クライアントのみ",
      daysWithoutLogin: "ログインしていない日数",
      trialDays: "試用日数"
    },
    faq: {
      subtitle: "Driblab PROとは？",
      categories: {
        playerMetrics: "プレーヤーの指標",
        teamMetrics: "チームの指標",
        positions: "チームポジション",
        tools: "ツール",
        api: "API",
        videos:"チュートリアル",
        playerPositions: "ポジション名の設定"
      },
      positions:{
        "GK":"ゴールキーパー",
        "DR":"右サイドバック",
        "DC":"センターバック",
        "DL":"左サイドバック",
        "DMR":"右ウイングバック",
        "DMC":"守備的ミッドフィールダー",
        "DML":"左ウイングバック",
        "MR":"右ミッドフィールダー",
        "MC":"ミッドフィールダー",
        "ML":"左ミッドフィールダー",
        "AMR":"右インサイドハーフ",
        "AMC":"トップ下",
        "AML":"左インサイドハーフ",
        "FWR":"右ウインガー",
        "FW":"フォワード",
        "FWL":"左ウインガー"
      },
      metrics: {
        categories: {
          Association: "協力",
          Saving: "セーブ",
          Shooting: "シュート",
          Defending: "ディフェンシング",
          Passing: "パス",
          BallHandling: "ボールコントロール",
          Aerial: "空中",
          Physical: "フィジカル",
          Predictive: "予測",
          Arrigo: "アリゴ",
          Score: "スコア",
          Turnovers: "ボールロスト",
          Carries: "ドリブル",
          SequenceInvolvement: "ポゼッションへの参加",
          Crosses: "センタリング",
          Distance: "距離",
          Sprint: "スプリント",
          Acceleration: "加速",
          MaxAcceleration: "最大加速度",
          Speed: "スピード",
          OutPlay: "アウトプレイ",
          LineBreakingPasses: "ラインブレイクパス",
          LineBreakingCarries: "ラインブレイクキャリー",
          LineBreakingActions: "ライン間アクション",
          PassUnderPressure: "プレッシャー下のパス",
          BallReceived: "ボールを受けた",
          OnBallPressureReceived: "ボール保持中のプレッシャー",
          OnBallPressure: "ボール保持者へのプレッシャー",
          SpatialCoverage: "スペースカバレッジ",
          OffBallPressure: "オフボール時のプレッシャー",
          OffBallRuns: "オフ・ザ・ボールラン",
          NoCategory: "その他",
          subcategories: {
            Quality: "クオリティ",
            Quantity: "クオンティティ",
            TeamComparison: "チーム比較",
            Receptions: "レシーブ",
            LongBalls: "ロングボール",
            Efficiency: "効率",
            Ratio: "比率",
            Defensive: "ディフェンス",
            Offensive: "オフェンス",
            Foot: "足",
            Progression: "進行",
            TopValue: "最高値",
            Predictive: "予測",
            Distance: "距離",
            Aerial: "空中",
            Crosses: "センタリング",
            NoCategory: "その他",
          },
          desc: {
            Association: "協力",
            Saving: "セーブ",
            Shooting: "シュート",
            Defending: "ディフェンシング",
            Passing: "パス",
            BallHandling: "ボールコントロール",
            Aerial: "空中",
            Physical: "フィジカル",
            Predictive: "予測",
            Arrigo: "アリゴ",
            Score: "スコア",
            Turnovers: "ボールロスト",
            Carries: "ドリブル",
            SequenceInvolvement: "ポゼッションへの参加",
            Crosses: "センタリング",
            Distance: "異なる速度での走行距離",
            Sprint: "異なる速度での走行",
            Acceleration: "加速",
            Speed: "スピード",
            OutPlay: "パッキング",
            LineBreakingPasses: "ラインブレイクパス",
            LineBreakingCarries: "ラインブレイクキャリー",
            LineBreakingActions: "ライン間アクション",
            PassUnderPressure: "プレッシャー下のパス",
            BallReceived: "ボールを受けた",
            OnBallPressureReceived: "ボール保持中のプレッシャー",
            OnBallPressure: "ボール保持者へのプレッシャー",
            SpatialCoverage: "ピッチコントロール",
            OffBallPressure: "オフボール時のプレッシャー",
            OffBallRuns: "オフ・ザ・ボールラン",
          },
          abbr: {
            Association: "協力",
            Saving: "セーブ",
            Shooting: "シュート",
            Defending: "ディフェンシング",
            Passing: "パス",
            BallHandling: "ボールコントロール",
            Aerial: "空中",
            Physical: "フィジカル",
            Predictive: "予測",
            Arrigo: "アリゴ",
            Score: "スコア",
            Turnovers: "売上高",
            Carries: "ドリブル",
            SequenceInvolvement: "ポゼッションへの参加",
            Crosses: "センタリング",
            Distance: "距離",
            Sprint: "走行",
            Acceleration: "加速",
            MaxAcceleration: "最大加速度",
            Speed: "スピード",
            OutPlay: "パッキング",
            LineBreakingPasses: "ラインブレイクパス",
            LineBreakingCarries: "ラインブレイクキャリー",
            LineBreakingActions: "ライン間アクション",
            PassUnderPressure: "プレッシャー下のパス",
            BallReceived: "ボールを受けた",
            OnBallPressureReceived: "ボール保持中のプレッシャー",
            OnBallPressure: "ボール保持者へのプレッシャー",
            SpatialCoverage: "ピッチコントロール",
            OffBallPressure: "オフボール時のプレッシャー",
            OffBallRuns: "オフ・ザ・ボールラン",
          },
        },
        types: {
          1: "90分ごと",
          2: "割合",
          3: "比",
          4: "有効性",
          5: "平均",
          6: "試合ごと",
          7: "差",
          8: "Max",
        }
      },
      api:{
        subtitle:"さまざまなリクエストからデータを収集する",
        resourcesTitle: "リソース",
        authentication: "認証",
        authText: "API を呼び出すには、各リクエストのヘッダー`Authorization` と値 `Bearer {API_TOKEN}`を含める必要があります。",
        generate:"生成する",
        tokenPlaceholder:"トークンを持っていないか、有効期限が切れている場合は、[生成する] をクリックします。'",
        pathParameters:"パスパラメータ",
        queryParameters:"クエリパラメータ",
        responseModel:"応答モデル",
        tokenWarning:"* API をテストできるようにするためのトークンを生成します",
        pathParamsWarning:"* 未入力のパスパラメータがあります",
        genericDescription: "API (アプリケーション・プログラミング・インターフェイス) は、開発者がデータや機能を自分のアプリケーションにアクセスして統合できるようにするものです。私たちのサッカー統計APIは、国、大会、チーム、選手、試合などに関するさまざまなデータへの包括的なアクセスを提供します。このAPIを使用することで、分析、ビジュアライゼーション、またはその他の革新的なソリューションのために、豊富なサッカードデータを活用するアプリケーションを構築できます。",
        methods:{
          getAllCountries: "このメソッドは、APIで利用可能なすべての国の完全なリストを取得し、各国のユニークな識別子や名前などの重要な詳細を提供します。このエンドポイントは、地理的なサッカーデータを必要とするアプリケーションに最適で、国の選択、フィルタリング、分析といった機能を可能にします。また、`countryId`パラメータに依存する他のエンドポイントと連携するための基盤的なリソースとしても機能し、APIデータセットとのスムーズな統合を保証します。",
          getCountryDetail: "このメソッドは、APIで利用可能な特定の国に関する詳細情報を提供します。このエンドポイントを使用することで、その国の名前、コード、関連するメタデータなどのデータを取得できます。これは、地理データに基づいてコンテキスト情報を表示したり、カスタマイズされたインサイトを生成したりするなど、国固有の詳細が必要なアプリケーションに特に役立ちます。他のエンドポイントを補完し、選択した国を深く掘り下げて探索することを可能にします。",
          getCountryCompetitions: "このメソッドは、特定の国で利用可能なすべての大会のリストを取得します。地域別に大会を探索できる機能を提供するための貴重なリソースであり、国のデータをその関連トーナメントとシームレスに結び付けます。このエンドポイントは、地域限定のサッカーコンテンツや地域分析に重点を置いたアプリケーションにとって不可欠です。",
          getAllCompetitionTypes: "このメソッドは、APIで利用可能なすべての大会タイプ（リーグ、カップ、国際トーナメントなど）のリストを返します。このエンドポイントは、大会を分類し、異なる種類のイベントを整理された形でユーザーに提供するのに最適です。大会の性質に基づいてサッカーデータを探索するためのフィルターやドロップダウンメニューといった機能を構築する際に特に役立ちます。",
          getAllCompetitions: "このメソッドは、タイプや場所に関係なく、APIで利用可能なすべての大会の包括的なリストを取得します。このエンドポイントは、幅広いサッカー大会を表示または分析する必要があるアプリケーションにとって便利で、ユーザーが興味のあるイベントを探索し選択することを可能にします。",
          getCompetitionAvailable: "このメソッドは、現在APIで利用可能とマークされている大会のリストを取得します。これにより、返されるデータが最新かつアプリケーションで使用可能であることが保証されます。特に、アクティブまたはアクセス可能な大会に依存する機能を構築する開発者にとって有用であり、ユーザーが関連するイベントを探索する際に古いデータや不完全なデータに遭遇しないようにします。",
          getCompetitionDetail: "このメソッドは、APIで利用可能な特定の大会に関する詳細情報を提供します。これは、大会に関する詳細ビュー、コンテキストに基づく洞察、または大会の特徴に基づくフィルタリングオプションを可能にするアプリケーションに特に役立ちます。",
          getCompetitionSeasons: "このメソッドは、特定の大会に関連付けられているすべてのシーズンのリストを取得します。このエンドポイントは、ある大会の歴史や現在の状況を包括的にカバーすることを目指すアプリケーションにとって重要で、ユーザーがシーズンごとにデータを探索することを可能にします。",
          getSeasonAvailable: "このメソッドは、APIで現在利用可能とされているすべてのシーズンのリストを提供します。ライブや進行中のサッカーイベントに焦点を当てたアプリケーションに特に有用で、ユーザーが関連する最新のシーズンデータと連携できるようにします。",
          getSeasonDetail: "このメソッドは、特定のシーズンに関する詳細情報を取得します。タイムライン、関連する大会、主要なメタデータを含みます。このエンドポイントは、特定のシーズンに関する詳細なインサイトを必要とするアプリケーションに不可欠で、シーズン概要、大会ごとのフィルタリング、または詳細なタイムライン表示などの機能を可能にします。",
          getSeasonTeams: "このメソッドは、特定のシーズンに参加しているすべてのチームのリストを提供します。ロスター管理、チームパフォーマンスの分析、またはシーズンごとのフィルター作成などの機能に最適です。",
          getSeasonPlayer: "このメソッドは、特定のシーズンに登録されたすべての選手のリストを取得します。選手ロスター、パフォーマンス追跡、または選択したシーズンに基づく選手のフィルタリング機能を構築するのに理想的です。",
          getSeasonPlayerStats: "このメソッドは、特定のシーズンにおけるすべての選手の詳細な統計を提供します。分析、選手の比較、またはシーズンを通じた選手の成果の動的なビジュアライゼーションを重視したアプリケーションに特に有用です。",
          getSeasonArrigoMetrics:"この手法は、特定のシーズンにおける全選手の総合的な統計情報を提供します。特に、分析、選手比較、シーズンを通しての選手の成績を動的に視覚化するアプリケーションに有効です。",
          getGameTeamPhysicalStats: "このメソッドは、特定の試合におけるチームのフィジカルパフォーマンスの統計を取得します。チームのフィットネスレベルやフィジカルパフォーマンスの傾向を分析したり、試合中のチームの取り組みを詳細に分析したりするアプリケーションに最適です。",
          getSeasonTeamStats: "このメソッドは、特定のシーズンに参加するすべてのチームの包括的な統計を提供します。チーム分析、シーズンのまとめ、またはシーズンを通じたチームパフォーマンスの比較に焦点を当てたアプリケーションに特に有用です。",
          getSeasonCoaches: "このメソッドは、特定のシーズン中にチームを指導したすべてのコーチのリストを取得します。シーズンインサイト、コーチング分析、またはシーズンを通じたチーム管理の変更を追跡するアプリケーションに特に有用です。",
          getSeasonGames: "このメソッドは、特定のシーズンに行われたすべての試合のリストを提供します。シーズン全体のスケジュールを表示したり、試合結果を分析したり、シーズン試合データに総合的にアクセスする機能を提供したりするアプリケーションに最適です。",
          getSeasonGamesMatchday: "このメソッドは、特定のシーズン内の特定のマッチデーに行われたすべての試合を取得します。マッチデーのスケジュールを表示したり、特定のラウンドを分析したり、シーズン中の特定の試合セットに焦点を当てたインサイトを提供するアプリケーションに特に有用です。",
          getSeasonLeagueTable: "このメソッドは、特定のシーズンのリーグテーブルを提供します。ランキング、ポイント、勝利、引き分け、敗北、および各チームに関連するその他の統計を含みます。このエンドポイントは、チーム順位の追跡、リーグの進行状況の分析、またはシーズンを通じてユーザーに最新の順位を提示することを目的としたアプリケーションに不可欠です。",
          getTeamDetail: "このメソッドは、特定のチームに関する詳細情報を提供します。チーム名、設立年、スタジアム、その他のメタデータが含まれます。このエンドポイントは、チームプロファイルの詳細表示、歴史的背景の提供、または豊富なチームデータを活用したユーザー体験の向上を目的とするアプリケーションに最適です。",
          getTeamLoans: "このメソッドは、特定のチームが関与するレンタル取引に関する情報を取得します。移籍分析、チームのロスター管理、またはシーズン中の選手の動きを追跡するアプリケーションに特に有用です。",
          getTeamRoster: "このメソッドは、特定のチームのロスターに含まれるすべての選手の完全なリストを提供します。チームのラインアップ表示、選手の役割分析、またはチームのロスター関連機能を管理するアプリケーションに理想的です。",
          getTeamGames: "このメソッドは、特定のチームがプレーしたすべての試合のリストを取得します。チームのパフォーマンス、スケジュールの追跡、またはチームの完全な試合履歴へのアクセスを提供するアプリケーションに特に適しています。",
          getTeamGameStats: "このメソッドは、特定の試合における特定のチームの詳細な統計を提供します。試合分析、パフォーマンス評価、または個々の試合でのチームのパフォーマンスの詳細な内訳に焦点を当てたアプリケーションに特に有用です。",
          getTeamTransfers: "このメソッドは、特定のチームが関与する移籍取引に関する情報を取得します。移籍市場分析、チームロスターの変更、または長期的な選手移動の追跡に重点を置いたアプリケーションに最適です。",
          getGameStatus: "このメソッドは、APIで利用可能なすべての試合ステータスのリストを提供します。例として、予定済み、進行中、完了、延期、またはキャンセルがあります。リアルタイムの試合追跡、ステータス別の試合フィルタリング、または試合の進行状況や状態に関する明確な更新をユーザーに提供するアプリケーションに特に有用です。",
          getPlayerPositions: "このメソッドは、ゴールキーパー、ディフェンダー、ミッドフィルダー、フォワードなど、すべての可能な選手のポジションのリストを返します。選手を分類したり、ポジションデータを分析したり、フィールド上での役割に基づいて選手をフィルタリングする機能を提供するアプリケーションに特に役立ちます。",
          getGameDetail: "このメソッドは、特定の試合に関する包括的な情報を提供します。参加チーム、日付と時間、会場、スコア、その他の重要なメタデータなどの詳細が含まれます。試合の詳細なプレビュー、レポート、または分析機能を提供するアプリケーションに最適です。",
          getGameStats: "このメソッドは、特定の試合に関する詳細な統計情報を提供します。ゴール数、シュート数、ボール支配率、パス、ディフェンスアクションなどの指標が含まれます。試合分析、試合後のレポート、または試合中のチームパフォーマンスの視覚化に焦点を当てたアプリケーションに特に有用です。",
          getGamePlayerStats: "このメソッドは、特定の試合に参加したすべての選手の詳細なパフォーマンス統計を取得します。個々の選手のパフォーマンスを分析したり、試合レポートを作成したり、単一試合の文脈で選手を比較するアプリケーションに特に適しています。",
          getGamePlayerPhysicalStats: "このメソッドは、特定の試合における選手の詳細なフィジカルパフォーマンス指標を提供します。選手のコンディション分析、フィジカルパフォーマンスの追跡、または選手個人の試合インサイトを生成するアプリケーションに特に有用です。",
          getGameTeamPhysicalStats: "このメソッドは、特定の試合におけるチームの詳細なフィジカルパフォーマンス指標を提供します。これには、総走行距離、スプリント回数、高強度ランニング、その他の身体的属性が含まれます。チームのフィットネス分析、チーム間のフィジカル努力の比較、または試合全体のパフォーマンス評価に特に有用です。",
          getGamePlayerArrigoMetrics: "このメソッドは、特定の試合におけるプレイヤーの詳細なArrigoメトリックを提供します。これは、分析に重点を置き、試合におけるプレイヤーに関する詳細な洞察を生成するアプリケーションに特に役立ちます。",
          getGameTeamArrigoMetrics: "このメソッドは、特定の試合におけるチームArrigoの詳細な指標を提供します。これには、敗北した選手やその他の属性などのデータが含まれます。特に、試合全体のパフォーマンス評価を分析することに重点を置いたアプリケーションに役立ちます。",
          getGameLineup: "このメソッドは、特定の試合のスタメンや控え選手、そのポジションを含むラインナップを取得します。試合前情報の表示、チームのフォーメーション分析、または特定の試合における戦術的決定の洞察を提供するアプリケーションに特に役立ちます。",
          getGameTimeline: "このメソッドは、特定の試合中に発生したイベントの時系列リストを提供します。リアルタイム試合更新、試合後の要約、または試合イベントの詳細な分析を提供するアプリケーションに特に有用です。",
          getGameTracking: "このメソッドは、特定の試合におけるトラッキングデータファイルをダウンロードするリンクを提供します。このファイルには、試合中の選手やボールの動きと位置に関する詳細なデータが含まれています。高度な分析、戦術分析、または試合中の選手やボールの動きの可視化に焦点を当てたアプリケーションに特に適しています。",
          getTrackingStatus: "このメソッドは、追跡で利用可能なすべての状態の完全なリストを返し、各状態の一意の識別子や名前などの重要な詳細を提供します。このエンドポイントは、状態の選択、フィルタリング、分析などの機能を有効にし、一致追跡を必要とするアプリケーションに最適です。また、「statusId」パラメータに依存する他のエンドポイントと対話するための重要なリソースとしても機能し、シームレスなナビゲーションと API の広範なデータセットとの統合を保証します",
          getPlayerTransfersTypes: "このメソッドは、選手の移籍タイプ（完全移籍、レンタル移籍、フリー移籍、交換移籍など）のリストを取得します。このエンドポイントは、移籍市場の傾向を分析したり、選手の動きを分類したり、移籍取引の種類に関する詳細な洞察を提供するアプリケーションに特に有用です。",
          getPlayerDetail: "このメソッドは、特定の選手に関する詳細情報を提供します。個人情報、キャリア統計、所属チームなどが含まれます。選手プロフィール、歴史的なインサイト、個々の選手のパフォーマンスやキャリア軌跡を分析するアプリケーションに最適です。",
          getPlayerGames: "このメソッドは、特定の選手が出場したすべての試合のリストを取得します。選手のパフォーマンス追跡、試合履歴分析、個々の選手の試合ログを提供するアプリケーションに特に有用です。",
          getPlayerInjuries: "このメソッドは、特定の選手が経験した怪我の詳細な記録を提供します。選手の健康状態分析、キャリアへの影響評価、またはリハビリ期間の追跡に焦点を当てたアプリケーションに特に有用です。",
          getPlayerNationalTeam: "このメソッドは、選手の代表チームでの試合参加に関する詳細情報を取得します。代表レベルでの選手のパフォーマンスを分析したり、国際キャリアを追跡したり、トーナメントや親善試合での貢献を提供するアプリケーションに特に適しています。",
          getPlayerSeasons: "このメソッドは、特定の選手が参加したすべてのシーズンのリストを提供します。選手のキャリアの進行状況を追跡したり、シーズンごとのパフォーマンスを分析したり、成果に関する歴史的な文脈を提供するアプリケーションに特に有用です。",
          getPlayerTransfers: "このメソッドは、特定の選手に関わる移籍履歴を詳細に取得します。選手キャリアの分析、移籍市場の洞察、またはチーム間での選手の動きを追跡するアプリケーションに特に適しています。",
          getPlayerSeasonTeamStats: "このメソッドは、特定の選手が特定のシーズンで所属チームと共に達成した詳細なパフォーマンス統計を提供します。シーズンを通じた選手分析、チームやシーズン間の比較、チームの成功に対する個々の貢献を追跡するアプリケーションに特に有用です。",
          getPlayerSeasonPhysicalStats: "このメソッドは、特定の選手のシーズン全体にわたる詳細な身体パフォーマンス指標を提供します。選手のフィットネス追跡、身体的パフォーマンス分析、またはシーズン中の選手の負荷を評価するアプリケーションに最適です。",
          getPlayerSeasonGamePhysicalStats: "このメソッドは、特定の選手のシーズン中の各試合ごとの身体パフォーマンス指標を詳細に提供します。試合ごとのフィットネス分析、選手の負荷追跡、または異なる試合間での身体パフォーマンスを比較するアプリケーションに特に有用です。",
          getPlayerSeasonGameStats: "このメソッドは、特定の選手のシーズン中の各試合ごとの詳細なパフォーマンス統計を取得します。試合ごとの選手分析、パフォーマンストレンド、またはシーズン内の試合間での詳細な比較に焦点を当てたアプリケーションに最適です。",
          getCoachDetail: "このメソッドは、特定の監督に関する詳細情報を提供します。名前、キャリア履歴、指導したチーム、主な実績が含まれます。このエンドポイントは、監督のプロフィールを紹介したり、キャリアを追跡したり、チームパフォーマンスにおける監督の影響を分析するアプリケーションに特に有用です。",
          getCoachHistory: "このメソッドは、特定の監督のキャリア履歴を包括的に取得します。指導したチーム、参加した大会、任期期間が含まれます。このエンドポイントは、監督のキャリアを分析したり、マネジメントの変遷を追跡したり、監督のプロフェッショナルな軌跡や実績に関するインサイトを提供するアプリケーションに最適です。",          
        },
        responseCodes: "レスポンスコード",
        furtherInformation:"詳細については、次のリンクのガイドを参照してください。",
        clipboard: "クリップボードにコピーしました！"
      }
    },
    globalSearch: {
      subtitle: "より詳しいフィルター"
    },
    iso:{
      AF:"アフガニスタン",
      DZ:"アルジェリア",
      AO:"アンゴラ",
      AR:"アルゼンチン",
      AU:"オーストラリア",
      AZ:"アゼルバイジャン",
      BH:"バーレーン",
      BB:"バーレーン",
      BE:"ベルギー",
      BJ:"ベナン",
      BO:"ボリビア",
      BW:"ボツワナ",
      BN:"ブルネイ",
      BF:"ブルキナファソ",
      KH:"カンボジア",
      CA:"カナダ",
      CF:"中央アフリカ共和国",
      CL:"チリ",
      CO:"コロンビア",
      CD:"コンゴ民主共和国",
      CG:"コンゴ",
      CI:"コートジボアール",
      CU:"キューバ",
      CZ:"チェコ",
      DJ:"ジブチ",
      DO:"ドミニカ共和国",
      EC:"エクアドル",
      SV:"エルサルバドル",
      ER:"エリトリア",
      ET:"エチオピア",
      FI:"フィンランド",
      PF:"フランス領ポリネシア",
      GM:"ガンビア",
      DE:"ドイツ",
      GI:"ジブラルタル",
      GL:"グリーンランド",
      GP:"グアドループ",
      GN:"ギニア",
      GY:"ガイアナ",
      HN:"ホンジュラス",
      HU:"ハンガリ-",
      IN:"インド",
      IR:"イラン",
      IE:"アイルランド",
      IT:"イタリア",
      JP:"日本",
      KZ:"カザフスタン",
      KI:"キリバス",
      KR:"韓国",
      KG:"キルギスタン",
      LV:"ラトビア",
      LS:"レソト",
      LY:"リビア",
      LT:"リトアニア",
      MO:"マカオ",
      MG:"マダガスカル",
      MY:"マレーシア",
      ML:"マリ",
      MH:"マーシャル諸島",
      MR:"モーリタニア",
      MX:"メキシコ",
      MD:"モルドバ",
      MN:"モンゴル",
      MA:"モロッコ",
      MM:"ミャンマー",
      NR:"ナウル",
      NL:"オランダ",
      NZ:"ニュージーランド",
      NE:"ナイジェリア",
      MP:"マリアナ諸島",
      OM:"オマーン",
      PW:"パラオ",
      PA:"パナマ",
      PY:"パラグアイ",
      PH:"フィリピン",
      PT:"ポルトガル",
      QA:"カタール",
      RO:"ルーマニア",
      RW:"ルワンダ",
      LC:"セントルシア",
      SM:"サンマリノ",
      SA:"サウジアラビア",
      RS:"セルビア",
      SL:"シエラレオネ",
      SK:"スロバキア",
      SB:"ソロモン諸島",
      ZA:"南アフリカ",
      LK:"スリランカ",
      SD:"スーダン",
      SZ:"エスワティニ",
      CH:"スイス",
      TW:"台湾",
      TZ:"タンザニア",
      TG:"トーゴ",
      TT:"トリニダード・トバゴ",
      TR:"トルコ",
      TV:"ツバル",
      UA:"ウクライナ",
      GB:"英国",
      UY:"ウルグアイ",
      VU:"バヌアツ",
      VE:"ベネズエラ",
      VG:"イギリス領ヴァージン諸島",
      EH:"西サハラ",
      ZM:"ザンビア",
      AL:"アルバニア",
      AD:"アンドラ",
      AG:"アンティグア・バーブーダ",
      AM:"アルメニア",
      AT:"オーストリア",
      BS:"バハマ",
      BD:"バングラデシュ",
      BY:"ベラルーシ",
      BZ:"ベリーズ",
      BT:"ブータン王国",
      BA:"ボスニア・ヘルツェゴビナ",
      BR:"ブラジル",
      BG:"ブルガリア",
      BI:"ブルンジ",
      CM:"カメルーン",
      CV:"カーボベルデ",
      TD:"チャド",
      CN:"中国",
      KM:"コモロ",
      CR:"コスタリカ",
      HR:"クロアチア",
      CY:"キプロス",
      DK:"デンマーク",
      DM:"ドミニカ",
      TL:"東ティモール",
      EG:"エジプト",
      GQ:"赤道ギニア",
      EE:"エストニア",
      FJ:"フィジ-",
      FR:"フランス",
      GA:"ガボン",
      GE:"ジョージア",
      GH:"ガーナ",
      GR:"ギリシャ",
      GD:"グレナダ",
      GT:"グアテマラ",
      GW:"ギニアビサウ",
      HT:"ハイチ",
      HK:"香港",
      IS:"アイスランド",
      ID:"インドネシア",
      IQ:"イラク",
      IL:"イスラエル",
      JM:"ジャマイカ",
      JO:"ヨルダン",
      KE:"ケニア",
      KP:"北朝鮮",
      KW:"クウェート",
      LA:"ラオス人民民主共和国",
      LB:"レバノン",
      LR:"リベリア",
      LI:"リヒテンシュタイン",
      LU:"ルクセンブルク",
      MK:"北マケドニア",
      MW:"マラウィ",
      MV:"モルディブ",
      MT:"マルタ",
      MQ:"マルティニーク",
      MU:"モーリシャス共和国",
      FM:"ミクロネシア連邦",
      MC:"モナコ",
      ME:"モンテネグロ",
      MZ:"モザンビーク",
      NA:"ナミビア",
      NP:"ネパール",
      NC:"ニューカレドニア",
      NI:"ニカラグア",
      NG:"ナイジェリア",
      NO:"ノルウェー",
      PK:"パキスタン",
      PS:"パレスチナ領域",
      PG:"パプア・ニューギニア",
      PE:"ペルー",
      PL:"ポーランド",
      PR:"プエルトリコ",
      RE:"レユニオン",
      RU:"ロシア",
      KN:"セントクリストファー・ネイビス",
      WS:"サモア",
      ST:"サントメ・プリンシペ",
      SN:"セネガル",
      SC:"セイシェル",
      SG:"シンガポール",
      SI:"スロベニア",
      SO:"ソマリア",
      ES:"スペイン",
      VC:"セントビンセントおよびグレナディーン諸島",
      SR:"スリナム",
      SE:"スウェーデン",
      SY:"シリア",
      TJ:"タジキスタン",
      TH:"タイ",
      TO:"トンガ",
      TN:"チュニジア",
      TM:"トルクメニスタン",
      UG:"ウガンダ",
      AE:"アラブ首長国連邦",
      US:"米国",
      UZ:"ウズベキスタン",
      VA:"バチカン市国",
      VN:"ベトナム",
      VI:"アメリカ領ヴァージン諸島",
      YE:"イエメン",
      ZW:"ジンバブエ",
      EU:"ヨーロッパ",
      INT:"インターナショナル",
      CW: "キュラソー",
      AFC:"AFC",
      CONCACAF:"CONCACAF",
      "GB-ENG":"イングランド",
      "GB-WLS":"ウェールズ",
      "GB-SCT":"スコットランド",
      "LATAM":"南アメリカ",
      "CAF":"シーエーエフ",
      "XK":"コソボ",
      "XK":"コソボ",
      AI:"アンギラ",
      AN:"オランダ領アンティル",
      AS:"アメリカ領サモア",
      AW:"アルバ",
      BM:"バミューダ",
      BQ:"ボネール",
      CK:"クック諸島",
      FO:"フェロー諸島",
      GF:"ガイアナ",
      GG:"ガーンジー邦領",
      GU:"グアム準州",
      IM:"マン島",
      JE:"ジャージー島",
      KY:"ケイマン諸島",
      MF:"セント・マーチン島",
      MS:"モンセラット",
      NU:"ニウエ",
      OC:"オセアニア",
      RI:"インドネシア",
      SS:"南スーダン共和国",
      TC:"タークス・カイコス諸島",
      YT:"マヨット県」「マヨット県",
      SX: "シント・マールテン",
    },
    loadingMessages:{
      players:"選手の準備中",
      teams:"チームを整理中",
      games:"試合を回収中",
      stats:"指標の計算中",
      graphs:"グラフの描画中",
      gettingReady:"準備中",
      placeholder: "ダウンロード中"
    },
    requestReport:{
      subtitle:"必要なものが記載された詳細なレポートを受け取る",
      categories:{
        "scouting":{
          title:"スカウティング",
          subtitle:"リーグで最高の選手は誰ですか? 他のリーグでは？ フィルター (年齢、身長、契約終了) を使用してカスタムリクエストし、最適なプレーヤーを見つけます。"
        },
        "coaches":{
          title:"監督",
          subtitle:"コーチはどのように動き、彼のスタイルとゲームをどのようにクラブに適応させるでしょうか? 詳細情報を取得するか、プロフィールを指定して、ニーズに合った監督を見つけてください。"
        },
        "team analysis":{
          title:"チーム分析",
          subtitle:"チームに関する詳細な情報を取得します。スタイル、守備と攻撃のパフォーマンス、弱点、最高の選手など..."
        },
        "game analysis":{
          title:"試合の分析",
          subtitle: "試合が与えられると、詳細な情報と共に試合前後の分析を取得します。"
        },
        "special projects":{
          title:"スペシャルプロジェクト",
          subtitle:"選手はアウェイでどのようにパフォーマンスしますか? 選手は今のリーグから違うリーグへとどのように変化しますか? レンタルで獲得できる選手は？ 質問があれば聞いてください。"
        },
        "conversation":{
          title:"会話",
          subtitle:"私たちのチームと会話を始めます。"
        }
      },
      notesPlaceholder: "情報が必要なリーグ、プロフィール、監督、チーム、または試合を指定してください。",
      chooseType: "レポートの種類を選択",
      requestSummary: "リクエストの概要",
      reportType:"レポートの種類",
      reportLanguage:"レポートの言語",
      detailTitle: "レポートのフォローアップ",
      detailSubtitle: "ご要望のレポートに関するすべての情報"
    },
    bugReport: {
      modalSubtitle:"私たちが改善するのを手伝ってください。",
      about:"について",
      sendSuccess:"正常に送信されました。 受信トレイから確認してください。",
      bugs:"エラー"
    },
    gbe:{
      autopass:"Auto Pass",
      bandX: "Band {0}",
      bandXCont:"Band {0} Continental Competition",
      points:"ポイント",
      titleWinner: "Title Winner",
      qualifiedGroupsBandX:"Qualified for group stage of a Band {0} Continental Competition",
      qualifiedQualifiersBandX:"Qualified for qualifiers of a Band {0} Continental Competition",
      midTable:"Mid-Table",
      relegation:"降格",
      promotion:"昇格",
      final:"決勝",
      semifinal:"準決勝",
      quarterfinal:"準々決勝",
      round16:"ベスト16",
      round32: "ベスト32",
      groupstage:"グループステージ",
      firstRound: "1回戦",
      secondRound: "2回戦",
      thirdRound: "3回戦",
      fourthRound: "4回戦",
      preliminaryRound: "予選ラウンド",
      other:"その他",
      score:"スコア",
      totalSummary:"Total Summary",
      currentlyPlayingInUK:"The player is a citizen of the United Kingdom or Ireland, or the player is a permanent resident in the United Kingdom",
      bandsAlert: "There are minutes played in more than one band, total is the max value",
      bandsAlertMax: "There are minutes played in more than one band, total is the max value",
      bandsAlertAvg: "There are minutes played in more than one band, total is the average value",
      generate: "GBEApplicationForm",
      debutYouthPlayer:"Debut for Youth Player",
      table1:{
        name:"Player´s International Appearances",
        title1: "Aggregated FIFA World Ranking of the Player’s National Association",
        title2: "Player’s International Appearances"
      },
      table2:{
        name:"Player’s Domestic Minutes",
        title1: "Player’s Domestic Minutes"
      },
      table3:{
        name:"Player’s Continental Minutes",
        title1: "Player’s Continental Minutes"
      },
      table4:{
        name:"Final League Position of Player´s Last Club",
        title1: "Last Club’s Final League Position"
      },
      table5:{
        name:"Continental Progression of Player´s Last Club",
        title1: "Continental Progression"
      },
      table6:{
        name:"League Quality of Player´s Current Club",
        title1: "Band of Player’s Current Club"
      },
      table7:{
        name:"Youth - Debut",
        title1: "Band"
      },
      table8:{
        name:"Youth - Final League Position",
        title1: "Last Club’s Final League Position"
      },
      table9:{
        name:"Youth - Continental Progression",
        title1: "Continental Progression"
      },
      table10:{
        name:"Youth - League Quality of Player´s Current",
        title1: "Band of Player’s Current Club"
      },
      table11:{
        name:"Youth - League Quality of Player´s Current",
        title1: "Band of Player’s Current Club"
      },
      table12:{
        name:"Youth - International Appearances",
        title1: "Player's International Appearances"
      }
    },
    mediaMode:{
      borderColor: "縁の色",
      fillColor:"塗りつぶしの色",
      bgColor:"背景色",
      upperText:"上部テキスト",
      lowerText:"下部テキスト",
      socialMedia:"ソーシャルメディア",
      textColor:"テキストの色",
      axisColor:"目の色",
      logo:"ロゴ",
      comparisonBorderColor: "縁の色比較",
      comparisonFillColor:"塗りつぶしの色比較",
      comparisonUpperText:"上部テキスト比較n",
      comparisonLowerText:"下部テキスト比較",
      homeFillColor:"塗りつぶしの色 (ホーム)",
      homeBorderColor:"縁の色 (ホーム)",
      awayFillColor:"塗りつぶしの色 (アウェイ)",
      awayBorderColor:"縁の色 (アウェイ)",
      face:"顔",
      nationalTeam:"代表チーム",
      comparisonFace:"顔比較",
      upperTextX:"上部テキスト {0}",
      lowerTextX:"下部テキスト {0}",
      borderColorX: "縁の色 {0}",
      fillColorX: "塗りつぶしの色 {0}",
      homeFillColorX:"塗りつぶしの色 (ホーム) {0}",
      homeBorderColorX:"縁の色 (ホーム) {0}",
      awayFillColorX:"塗りつぶしの色 (アウェイ) {0}",
      awayBorderColorX:"縁の色 (アウェイ) {0}",
      faceX:"顔 {0}",
      selectField:"プロパティを選択",
      orientationX:"オリエンテーション {0}",
      searchBarPlaceholder:"選手や試合を検索...",
      title:"メディア - スコア表",
      pageSubtitle: "地図と画像の閲覧およびダウンロード",
      chooseChart:"グラフを選択...",
      headerTextX:"Tヘッダーテキスト{0}",
      avatarLineLength:"アバターラインの長さ",
      avatarLineWeight:"アバターラインの太さ",
      avatarSize:"アバターの大きさ",
      chartX:"クラフ {0}",
      chartHeaderFontSize:"グラフタイトルのサイズ",
      chartHeaderFontWeight:"グラフタイトルの太さ",
      upperTextFontSize: "上部のテキストのサイズ",
      upperTextFontWeight: "上部のテキストの太さ",
      lowerTextFontSize: "下部のテキストのサイズ",
      lowerTextFontWeight: "下部のテキストの太さ",
      socialMediaFontSize:"ソーシャルメディアのテキストのサイズ",
      socialMediaFontWeight:"ソーシャルメディアのテキストの太さ",
      subtitle:"サブタイトル",
      subtitleFontSize:"サブタイトルの大きさ",
      subtitleFontWeight:"サブタイトルの太さ",
      subtitleX:"サブタイトル {0}",
      subtitleFontSizeX:"サブタイトルの大きさ {0}",
      subtitleFontWeightX:"サブタイトルの太さ {0}",
      titleX:"タイトル {0}",
      titleFontSize:"タイトルの大きさ",
      titleFontWeight:"タイトルの太さ",
      sponsor:"スポンサー",
      fontFamily:"Font family"
    },
    documents:{
      types:{
        "SCOUTING_REPORT": "スカウトレポート",
        "GAME_REPORT": "試合のレポート",
        "MEDICAL_REPORT": "医療レポート",
        "PHYSICAL_REPORT": "フィジカルレポート",
        "PSYCHOLOGICAL_REPORT": "心理レポート",
        "OTHER": "その他",
        "QUICK_NOTES": "メモ",
        "PLAYER_REPORT": "プレイヤーレポート",
        "GENERAL_COMMENTS": "総評",
        "PLAYER_ANALYSIS": "選手分析"
      },
      uploadDocument:"書類をアップロード",
      notesPlaceholder:"ドキュメントに関連する記述、注意事項を示します。",
      notesPlaceholderAlt:"選手に関連する記述、注意事項を示します。",
      uploadedBy:"によってアップロードされました",
      updatedBy:"によってアップデートされました",
      seeNotes:"メモをみる",
      addNote:"メモを追加",
      rating: "レーティング",
      position: "ベストポジション",
      physical: "フィジカル",
      onBall: "オンボール",
      offBall: "オフボール",
      mental: "メンタル",
      potential: "ポテンシャル",
      conclusion: "結論",
      recommendation: {
        label: "推薦",
        1: "契約する",
        2: "モニターする",
        3: "放棄する",
        4: "興味深い"
      },      
      match: "試合",
      deleteQuickNote: "メモを削除",
      deleteQuickNoteMessage: "メモが完全に削除されます。よろしいですか？",
      noQuickNotes: "データがありません。メモの追加から始めてください！",
      deleteDocument: "ドキュメントを削除",
      deleteDocumentMessage: "ドキュメントは完全に削除されます。よろしいですか？",
      noDocuments: "データがありません。ドキュメントの追加から始めてください！"
    },
    notifications:{
      newReportMessage: "レポートに1件の新しいメッセージがあります"
    },
    blog:{
      subtitle:"最新の記事、予告、ニュース",
      newEntry:"新しい投稿",
      title:"タイトル",
      text:"テキスト",
      link:"リンク",
      image:"イメージ",
      author:"作成者",
      date:"発行日",
      deleteEntry:"投稿を削除",
      deleteEntryMessage:"この投稿を削除してもよろしいですか?"
    },
    positionsOrlegi: {
      "GK":"ゴールキーパー",
      "DC":"センターバック",
      "DR":"サイドバック",
      "MC":"ミッドフィールダー",
      "AMC":"トップ下",
      "FW":"フォワード",
      "FWR":"ウインガー"
    },
    library:{
      subtitle: "更新されたドキュメントの表示と共有",
      mediaSubtitle: "エクスポートしたグラフの表示と共有",
      charts:"グラフ",
      goToLibrary: "図書館に行く"
    },
    scatterPlot:{
      bubbleSize: "バブルチャート",
      byMinutes: "時間ごと",
      byAge:"年齢ごと",
      byMarketValue:"価値ごと"
    },
    eventChart:{
      successfulEvent:"成功したイベント",
      unsuccessfulEvent:"失敗したイベント",
      successfulPass:"成功したパス",
      unsuccessfulPass:"失敗したパス",
      successfulCarry:"成功したドリブル",
      unsuccessfulCarry:"失敗したドリブル",
      carryAndKeyPass:"ボールを運んでパス",
      carryAndAssist:"ボールを運んでアシスト",
      carryAndShot:"ボールを運んでシュート",
      ballProgressionAndPass:"ボールを前進させてからパス",
      ballProgression:"ボールを前進させる",
      ballProgressionAndKeyPass:"ボールを前進させてからキーパス",
      ballProgressionAndAssist:"ボールを前進させてからアシスト",
      ballProgressionAndShot:"ボールを前進させてからシュート",
      ballProgressionAndGoal:"ボールを前進させてからゴール",
      pass:"パス",
      carryAndPass:"ボールを運んでパス",
      carryAndAssist:"ボールを運んでアシストa",
      carryAndShot:"ボールを運んでシュート",
      carryAndGoal:"ボールを運んでゴール",
      totalTouches:"合計タッチ数",
      successful:"成功",
      unsuccessful:"失敗"
    },
    event:{
      Pass: "パス",
      TakeOn: "ドリブル",
      Takeon: "ドリブル",
      Foul: "ファール",
      Tackle: "タックル",
      Interception: "インターセプト",
      Clearance: "クリア",
      MissedShot: "外したシュート",
      ShotOnPost: "バー、ポストに当たったシュート",
      SavedShot: "止められたシュート",
      Goal: "ゴール",
      Error: "エラー",
      Aerial: "空中戦",
      BallRecovery: "ボール奪取",
      Dispossessed: "ボールロスト",
      ChanceMissed: "逃したチャンス",
      BallTouch: "ボールタッチ",
      BlockedPass: "ブロックされたパス",
      Challenge: "チャレンジ",
      lossPossession: "ポゼッションを失う",
      "Ball touch": "ボールタッチ",
      "Smother": "カバー",
      "Keeper pickup": "地面からボールを拾う",
      "Good skill": "巧みな動き",
      "Punch": "パンチング",
      "Saved shot":"止められたシュート",
      "Shot on post":"バー、ポストに当たったシュート",
      "Missed shot":"外したシュート",
      "Save":"セーブ",
      "Take on":"ドリブル",
      "Offside pass":"オフサイドパス",
      "Claim": "センタリングのボールをキャッチ",
      "Blocked pass": "ブロックされたパス",
    },
    leagueTab:{
      leagueTable:"順位表",
      matchdays:"節",
      playerInsights:"キープレーヤー",
      teamInsights:"キーチーム",
      head2head:"1対1",
      addNewChart:"グラフを追加",
      rounds: {
        "W": "優勝",
        "F": "決勝",
        "SF": "準決勝",
        "QF": "準々決勝",
        "16": "ベスト16",
        "32": "ベスト32",
        "GR": "グループリーグ",
        "4R": "4回線",
        "3R": "3回線",
        "2R": "2回線",
        "1R": "1回線",
        "PR": "予選ラウンド",
        "QPO1": "ベスト16　下のレベル",
        "QPO2": "プレベスト32",
      },
      prediction:"予測",
      predicted:"予測",
      groups:"グループ",
      ranking:"順位表",
      positions:"ポジション",
      numberOfTeams: "チーム数",
      statsWithMinimum: {
        message: "選択したシーズンで{0}{1}を超える選手のみを表示",
        dribblesTotal90: "90分あたりのドリブル数",
        crosses90: "90分あたりのクロス数",
        tacklesAttempted90: "90分あたりのタックル試行数",
        aerialsTotal90: "90分あたりの空中戦数"
      }      
    },
    similarity:{
      subtitle:"似た選手を探す",
      searchBarPlaceholder:"似た選手を見つけるために、プレーヤーを検索します",
      radarFilters:"レーダーフィルター",
      similarityFilters:"類似のフィルター",
      playersFilters:"選手のフィルター",
      similarPlayers:"似た選手",
      seasonWarning: "450分以上プレーしたシーズンのみが利用可能です"
    },
    squadBuilder:{
      subtitle:"独自のテンプレートを作成してモデル化する",
      playerSelector:"選手カタログ",
      loadSquad:"チームをロード",
      yearsOld:"歳",
      playersPerPosition:"ポジション毎の選手",
      custom: 'カスタム',
      removeSquad: 'スクワッドを削除する',
      removeSquadMessage: '本当にスクワッドを削除しますか?',
      deleteSquadSuccess: 'スクワッドは正常に削除されました',
      playerDetails: "詳細の可視性",
      ageFormat: "年齢の形式",
      mainPlayer: "主要な選手",
      showDetails: "詳細を表示",
      all: "すべて",
      squadPosition: "チーム内のポジション",
      noData: "データがありません。まずはピッチに選手を追加してください！",
    },
    tours:{
      buttons: {
        dontShowAgain: "ドント・ショウ・アゲイン",
        skipTour: "ガイドツアーをスキップする",
        previous: "前へ",
        next: "次へ",
        finish: "終了"
      },
      playerRadar:{
        step1:{
          title: "パーソナル・ファイル",
          message: "選手の基本データ（年齢、身長、契約日）の確認"
        },
        step2:{
          title: "GBEフィルター",
          message: "英国でプレーするのに十分なGBEポイントを保有しているかどうかを知ることができる機能"
        },
        step3:{
          title: "アベイラビリティ",
          message: "出場可能な時間の割合と出場した時間の割合"
        },
        step4:{
          title: "ポジション",
          message: "どのポジションで何分プレーしたかを調べる"
        },
        step5:{
          title: "表示形式",
          message: "レーダー、ポーラー、ロリポップ、テキストの4種類のビジュアライゼーションでパフォーマンスを測定し、同じポジションの選手と比較することができます。"
        },
        step6:{
          title: "パフォーマンスレーダー",
          message: "ここでは、パフォーマンスが視覚的に反映されます。パネルはインタラクティブで、各指標にカーソルを合わせると、その定義を知ることができます。"
        },
        step7:{
          title: "シーズンセレクション",
          message: "パフォーマンスを測定するためにシーズンを選択または追加する"
        },
        step8:{
          title: "カスタムテンプレート選択",
          message: "作成したカスタムテンプレートを使って、標準のレーダーとは異なる指標で選手を計測します"
        },
        step9:{
          title: "選曲",
          message: "さまざまなポジションのチェックを外して、測定したいポジションで彼を測定します"
        },
        step10:{
          title: "選り抜き",
          message: "自分のシーズン、トップ5リーグ、ユーザーアカウントの自シーズンとデフォルトシーズンの高低差でプレイヤーを測定します。"
        },
        step11:{
          title: "比較対象",
          message: "過去の成績、同じポジションの他の選手、ポジションの平均と比較する。"
        },
        step12:{
          title: "イメージダウンロードフォーマット",
          message: "ダウンロード形式は、png、svg、embedの3種類です。"
        }
      },
      playerRanking:{
        step1:{
          title: "シーズン、チーム、ポジション",
          message: "選手を比較するシーズン、チーム、ポジションを選択する"
        },
        step2:{
          title: "基本的なフィルター",
          message: "年齢、プレイ時間、身長で選手をフィルタリングする"
        },
        step3:{
          title: "ハイライトと除外",
          message: "必要な選手をハイライトし、表示中のチームを除外する"
        },
        step4:{
          title: "カテゴリーで絞り込む",
          message: "カテゴリーで統計をフィルタリングする アソシエーション、ディフェンス、パス、ボールハンドリング、その他"
        },
        step5:{
          title: "イメージダウンロードフォーマット",
          message: "ダウンロード形式は、png、svg、embedの3種類です。"
        }
      },
      playerFinishing:{
        step1:{
          title: "ディスプレイを選択する",
          message: "フィニッシングマップをメインビュー、ゴールビュー、分布表で見ることができます"
        },
        step2:{
          title: "シーズン選択",
          message: "シーズンを追加して、シュート効率を測定する"
        },
        step3:{
          title: "シュート位置",
          message: "シュートの正確な位置（円）またはボックスとピッチのエリア（エリア）を表示する可能性を選択します。"
        },
        step4:{
          title: "xG ON TARGET",
          message: "xG to GoalとxG Completionのボックスにチェックを入れると、シュート後に選手がどのような付加価値をつけたかを確認することができます。"
        },
        step5:{
          title: "シュートタイプ",
          message: "シュートタイプ、戦略、エリア、体の部位でフィルタリングします。"
        },
        step6:{
          title: "分数フィルター",
          message: "特定のゲームピリオドで獲得したショットとゴールを選択するためのミニッツバー"
        },
        step7:{
          title: "イメージダウンロードフォーマット",
          message: "ダウンロード形式は、png、svg、embedの3種類です。"
        },
        step8:{
          title: "シュートマップ",
          message: "地図はインタラクティブに表示されます。マウスで各サークルをチェックすると、各ショットのXGがわかります。"
        }
      },
      playerKeyPass:{
        step1:{
          title: "シーズン選択",
          message: "シーズンを追加して、シュート効率を測定する"
        },
        step2:{
          title: "キーパス位置",
          message: "キーパスの正確な位置（円）またはエリアとフィールドのエリア別（エリア）で表示する可能性を選択する"
        },
        step3:{
          title: "キーパス後のフィニッシュのタイプ",
          message: "キーパス後のシュート、戦略、エリア、ボディパーツの種類でフィルタリングします。"
        },
        step4:{
          title: "議事録のフィルタリング",
          message: "特定のゲームピリオドで獲得したショットとゴールを選択するためのミニッツバーです。"
        },
        step5:{
          title: "イメージダウンロードフォーマット",
          message: "ダウンロード形式は、png、svg、embedの3種類です。"
        },
        step6:{
          title: "キーパス・マップ",
          message: "この地図はインタラクティブに表示されます。各パスのxAを知るには、マウスで各円を参照してください。"
        }
      },
      playerThreat:{
        step1:{
          title: "シーズン選択",
          message: "シーズンを追加して、シュート効率を測定します。"
        },
        step2:{
          title: "脅威の位置",
          message: "キーパスの正確な位置を表示する可能性を選択する（円）またはエリアとフィールドゾーンで表示する（エリア）。"
        },
        step3:{
          title: "アクションとコンプリート",
          message: "地図上に表示したいアクションと完了の種類に応じて、チェックを入れたり外したりします。"
        },
        step4:{
          title: "分と脅威",
          message: "期間別、分単位、アクションの脅威値でフィルタリングします。"
        },
        step5:{
          title: "イメージダウンロードフォーマット",
          message: "ダウンロード形式は、png、svg、embedの3種類です。"
        },
        step6:{
          title: "脅威マップ",
          message: "このマップはインタラクティブです。各パスのxTプレイで発生する脅威を知るには、マウスで各円を参照してください。"
        }
      },
      playerTouches:{
        step1:{
          title: "ゲームとイベントの選択",
          message: "マップに表示したいゲームとイベントを選択します。"
        },
        step2:{
          title: "イベントタイプ",
          message: "ゲーム中のプレイヤーのイベントの防御的、攻撃的な性質に応じて、チェックを入れたり外したりする"
        },
        step3:{
          title: "表示フィルター",
          message: "基本動作、ヒートマップ、サークル、ボックスでマップをフィルタリングします。"
        },
        step4:{
          title: "イメージダウンロードフォーマット",
          message: "ダウンロード形式は、png、svg、embedの3種類です。"
        },
        step5:{
          title: "タッチマップ",
          message: "地図はインタラクティブに表示されます。各イベントをクリックすることで、各イベントを見ることができます"
        }
      },
      playerAllGames:{
        step1:{
          title: "アベイラビリティー",
          message: "試合ごとに空き状況やプレイ時間を確認できます。"
        },
        step2:{
          title: "ポジション",
          message: "各試合での出場ポジションを確認する。"
        }
      },
      playerInjuries:{
        step1:{
          title: "履歴と損失日数",
          message: "過去1年間、または全履歴、日数による負傷の範囲を参照する。"
        },
        step2:{
          title: "クラブ別怪我",
          message: "シーズンやクラブごとに分けられた怪我の履歴を参照することができます。"
        }
      },
      playerInfo:{
        step1:{
          title: "キャリアと移籍",
          message: "所属クラブ、代表チームでの出場時間、ポジション、出場機会の履歴や、キャリアを通じた選手の移籍を参照することができます"
        }
      },
      teamOverview:{
        step1:{
          title: "チームシート",
          message: "チームの基本データ（平均年齢、基本フォーメーション、ELO、移籍のバランス）を参照する"
        },
        step2:{
          title: "基本統計",
          message: "ポゼッション、xG、シュート数、PPDA、垂直性について相談する"
        },
        step3:{
          title: "レーダーとシーズン",
          message: "レーダー、シーズン、ホームゲームまたはアウェイゲームを選択し、チームのパフォーマンスを測定する"
        },
        step4:{
          title: "監督と試合で絞り込む",
          message: "各コーチのステージ別パフォーマンスを選択"
        },
        step5:{
          title: "パーフォマンス・レーダー",
          message: "パネルはインタラクティブで、各メトリクスの上にカーソルを置くと、その定義が表示されます"
        },
        step6:{
          title: "画像ダウンロード形式",
          message: "ダウンロード形式はpngとsvgの2種類。"
        },
        step7:{
          title: "カレンダー",
          message: "チームの試合スケジュールを見る"
        },
        step8:{
          title: "メトリックス別ベストプレーヤー",
          message: "このパネルでは、さまざまな指標を選択し、どの選手が最も重要な選手であるかを確認することができる"
        },
        step9:{
          title: "次の試合と負傷者",
          message: "次の対戦相手とチームの負傷者、出場停止選手をチェックする"
        },
        step10:{
          title: "グラフとトレンド",
          message: "過去10試合または20試合のさまざまなグラフを見る"
        }
      },
      teamRoster:{
        step1:{
          title: "ビュータイプ",
          message: "ポジション別、契約満了別、年齢別、アベイラビリティ別、年齢プロフィール別、ピッチ別の6つのカテゴリーから代表選手を見ることができます"
        }
      },
      teamLoans:{
        step1:{
          title: "ローン・プレーヤー",
          message: "他チームにレンタル移籍した選手とそのポジションを相談する"
        }
      },
      teamBeeswarm:{
        step1:{
          title: "シーズンとメンバー",
          message: "シーズン、レーダーチーム、お好みのリーグで比較できます"
        },
        step2:{
          title: "メトリクス別パフォーマンス",
          message: "事前に選択したリーグの全チームと比較して、各指標におけるチームの位置を確認する"
        },
        step3:{
          title: "画像ダウンロード形式",
          message: "ダウンロード形式はpng、svg、embedの3種類です"
        }
      },
      teamFinishingMap:{
        step1:{
          title: "シーズン選択",
          message: "シーズンを追加してシュート効率を測定"
        },
        step2:{
          title: "自陣または相手陣でのフィニッシュ",
          message: "チームの完成マップを表示するか、対戦相手全員の完成マップを表示するかを選択する"
        },
        step3:{
          title: "ショット・プレイスメント",
          message: "チームのシュートをどのように表示するか、サークルかゾーン（ボックス）かを選択します"
        },
        step4:{
          title: "ショットタイプ",
          message: "ショットの種類、戦略、エリア、体の部位で絞り込む"
        },
        step5:{
          title: "フィルター・ミニッツ",
          message: "特定の試合時間帯のシュートとゴールを選択するミニッツバー"
        },
        step6:{
          title: "画像ダウンロード形式",
          message: "ダウンロード形式はpng、svg、embedの3種類です"
        },
        step7:{
          title: "ショットマップ",
          message: "地図はインタラクティブです。各ショットのXGを知るには、マウスで各サークルをチェックする"
        },
      },
      teamKeyPassMap:{
        step1:{
          title: "シーズン選択",
          message: "シーズンを追加してシュート効率を測定"
        },
        step2:{
          title: "自社またはライバルのキーパス",
          message: "チームの主要なパスのマップを表示するか、すべてのライバルのマップを表示するかを選択します"
        },
        step3:{
          title: "キーパスの場所",
          message: "キーパスの正確な位置を表示するか（丸印）、エリアやフィールドごとに表示するか（ボックス）を選択します"
        },
        step4:{
          title: "パス後の仕上げのタイプ",
          message: "キーパス後に行われたシュートの種類、戦略、エリア、体の部位によるフィルタリング"
        },
        step5:{
          title: "フィルター・ミニッツ",
          message: "特定の試合時間帯のシュートとゴールを選択するミニッツバー"
        },
        step6:{
          title: "画像ダウンロード形式",
          message: "ダウンロード形式はpng、svg、embedの3種類です"
        },
        step7:{
          title: "ショットマップ",
          message: "地図はインタラクティブです。各パスのxAを知るために、マウスで各円を参照する"
        },
      },
      teamLatestGames:{
        step1:{
          title: "最新のゲーム",
          message: "全チームの試合結果、ポゼッション、xG、勝率を参照する"
        }
      },
      teamTransfers:{
        step1:{
          title: "到着",
          message: "暦年の全入荷（購入＋移籍）について相談する"
        },
        step2:{
          title: "出発",
          message: "すべての出国者（販売＋移籍）を暦年で参照する"
        }
      },
      teamAnalysis:{
        step1:{
          title: "トレンド",
          message: "連勝、勝利、クリーンシート、逆転劇、ゴールのあった期間、ゴールの種類などを通じて、チームのフォームを確認する"
        },
        step2:{
          title: "セットプレー",
          message: "セットプレーとオープンプレーの間でチームのパフォーマンスを比較し、セットプレーの詳細な概要を取得します"
        },
        step3:{
          title: "サブスティテュート",
          message: "チームがいつ交代を行い、どの選手が最も多く交代したかを確認する"
        },
        step4:{
          title: "コネクション",
          message: "選手間の最も一般的な接続をご相談ください。シーズンとプレータイプで絞り込む"
        },
        step5:{
          title: "攻撃ゾーン",
          message: "チームの攻撃ゾーンを発見し、シーズンや攻撃のタイプでフィルタリングする"
        },
        step6:{
          title: "フォーメーション",
          message: "最もよく使われたフォーメーションと、それぞれのフォーメーションでの勝率、引き分け率、敗戦率をチェックする"
        },
        step7:{
          title: "ショットゾーン",
          message: "シーズン、チーム、対戦相手、マップの視覚化方法、シュートタイプ、分数によるフィルタリング"
        },
        step8:{
          title: "交差点",
          message: "シーズン、表示の種類、成功または失敗、スタート地点とゴール地点、コーナーキックなどによる検索とフィルタリング"
        },
        step9:{
          title: "プレーヤーズ",
          message: "シーズン、ディスプレイの種類、成功したか失敗したか、スタート地点とゴール地点、コーナーキックを含むかどうかでフィルタリングする"
        }
      },
      teamOnOff:{
        step1:{
          title: "Sシーズンと試合",
          message: "シーズン、試合、ホームまたはアウェイゲームで絞り込む"
        },
        step2:{
          title: "プレーヤーズ",
          message: "数え切れないほどの指標を通して、チーム内の全選手のパフォーマンスを見ることができます"
        }
      }
    },
    alerts:{
      numPlayers:"プレイヤー数",
      newPlayersLastWeek:"先週の新規プレイヤー",
      subtitle:"検索で新しい選手が見つかったときに通知を受け取る",
      generalSubtitle: "あなたの条件に基づいた新しい選手やお気に入りの選手のニュースに関するアラートを受け取る",
      subtitlePlayer: "お気に入りの選手に関するニュースがある時にアラートを受け取る",
      subtitleSearch: "検索基準に合う新しい選手がいる場合にアラートを受け取る",
      favorite: "お気に入り",
      newEventCalendar: "新しいイベント",
      updatedEventCalendar: "更新されたイベント",
      newShareFrom: "からの新しい共有",
      injuryAlert: "負傷アラート",
      contractAlert: "契約アラート",
      teamAlert: "サインアラート",
      marketValueAlert: "市場価値アラート",
      gameAlert: "試合出場アラート",
    },
    videoEvents:{
      highlights:"ハイライト",
      fullGame:"フルゲーム",
      autoplay:"オートプレー",
      searchBarPlaceholder:"選手、チーム、試合を探す",
      subtitle:"ビデオでイベントを分析する",
      successful:"成功",
      unsuccessful:"失敗",
      playing:"再生する",
      games:"試合",
      moreFilters:"More filters...",
      startArea:"Start area",
      endArea:"End area",
      select:"Select",
      selectLastXGames: "Select last {0} games",
      advancedFilters: "Advanced Filters",
      freeKicks:"Free Kicks",
      cornerKicks:"Corner Kicks",
      allShots:"All Shots",
      generateZip:"Generate ZIP",
      zippedModalMessage:"ZIP process has been started, could take some minutes. You would receive an email when is finished",
      clickToSeeVideo:"Click to see video"
    },
    videoUpload:{
      subtitle: "Upload video and create new game",
      uploadVideo: "Upload video",
      selectPeriod: "Select period",
      gameData: "Game Data",
      venue:"Venue",
      matchType: "Match type",
      matchGroup: "Match group",
      roundType: "Round type",
      roundNumber: "Round number",
      offsetFh:"Offset First Half",
      offsetSh:"Offset Second Half",
      offsetFhOT:"Offset Overtime First Half",
      offsetShOT:"Offset Overtime Second Half",
      homeLineup: "Home Lineup",
      awayLineup: "Away Lineup",
      existingPlayer: "Existing player",
      newPlayer: "New player",
      startingTeam:"Starting",
      saveAndUpload:"Save and upload",
      existingGame: "Game exists already",
      sendToKora:"Send",
      invalidForm:"Invalid form",
      warningModalTitle:"Anomalies have been detected",
      noScoreSheetWarning:"No scoresheet attached",
      onlyOnePartUploadedWarning: "Only one half time attached",
      continueQuestion: "continue?",
      slaLimit: "{1} を使用して {0} ゲームをアップロードしました。あなたの制限は {2} です",
      requestedGames: "リクエストされた試合",
      limitClose: "リクエスト可能な試合はあと{0}試合です",
      limitReached: "動画のアップロード上限に達しました。追加で試合をアップロードすると追加料金が発生する可能性があります。",
      seasonFinishedWarning: "これにより、すでに終了したシーズンに試合が作成されます。正しいことを確認してください。",
      teamCountryWarning: "このチームは、選択されたリーグの国とは異なる国のチームです。正しいことを確認してください。",
    },
    videoPlaylists:{
      subtitle: "Collections of video highlights filters",
      savePlaylist: "Save Playlist",
      seeAllPlaylists: "すべてのリストを見る"
    },
    videoHighlights: {
      recap:"要約",
      homeCondensed:"ホーム凝縮ゲーム",
      awayCondensed:"アウェイでの凝縮された試合",
      selectedActions: "選択されたアクション",
      noActions: "指定されたフィルター条件に一致するアクションはありません",
      noGames: "まだ試合がアップロードされていません",
      attackingActions: "攻撃アクション",
      defensiveActions: "守備アクション",
      groundDuels: "グラウンドデュエル",
      penaltiesProvoked: "誘発されたペナルティ",
      goalkeeperActions: "ゴールキーパーのアクション",
      addSomeGames: "試合を追加して始めましょう！",
      goToVideoUploadTool: "ビデオをアップロードする",
      ballInPlay:"ボールがプレー中",
      qualifiers: {
        "Pass": "パス",
        "Save": "セーブ",
        "Saved Shot": "セーブされたシュート",
        "Shot": "シュート",
        "Goal": "ゴール",
        "Missed Shot": "枠外シュート",
        "Shot on Post": "ポスト直撃シュート",
        "Error": "エラー",
        "Clearance": "クリア",
        "Aerial": "エアリアルデュエル",
        "Challenge": "デュエル敗北",
        "Dispossessed": "ボールロスト",
        "Foul": "ファウル",
        "Card": "カード",
        "Offside Pass": "オフサイドパス",
        "Claim": "キャッチ",
        "Keeper Pickup": "キーパーピックアップ",
        "Ball Touch": "ボールタッチ",
        "Dribble": "ドリブル",
        "Interception": "インターセプト",
        "Tackle": "タックル",
        "Ball Recovery": "ボールリカバリー"
      },
      qualifierIds: {
        "1": "ロングパス",
        "2": "クロス",
        "5": "直接フリーキック",
        "6": "コーナーキック",
        "9": "ペナルティキック",
        "15": "ヘディング",
        "20": "右足",
        "21": "体の他の部分",
        "22": "オープンプレー",
        "23": "カウンターアタック",
        "24": "セットプレー",
        "25": "コーナーから",
        "26": "フリーキック",
        "28": "オウンゴール",
        "29": "アシスト",
        "31": "イエローカード",
        "32": "2枚目のイエローカード",
        "33": "レッドカード",
        "72": "左足",
        "73": "左",
        "82": "セーブされたシュート(GKなし)",
        "94": "ディフェンスブロック",
        "123": "ゴールキーパーのスロー",
        "124": "ゴールキック",
        "160": "スローイン",
        "170": "ゴールにつながる",
        "173": "安全なクリア",
        "174": "危険なクリア",
        "177": "キャッチ",
        "178": "立って",
        "179": "ダイビングして",
        "182": "手",
        "183": "足",
        "185": "クロスブロック",
        "210": "アシスト",
        "215": "個人プレー",
        "279": "キックオフ",
        "285": "ディフェンシブ",
        "286": "オフェンシブ"
      },
      areas: {
        "goalArea": "ゴールエリア",
        "boxLeft": "ペナルティエリア左",
        "boxCenter": "ペナルティエリア中央",
        "boxRight": "ペナルティエリア右",
        "outBoxDeepLeft": "ペナルティエリア外左",
        "outBoxDeepRight": "ペナルティエリア外右",
        "outBoxLeft": "ペナルティエリア外左",
        "outBoxCentreLeft": "ペナルティエリア外中央左",
        "outBoxCentre": "ペナルティエリア外中央",
        "outBoxCentreRight": "ペナルティエリア外中央右",
        "outBoxRight": "ペナルティエリア外右",
        "midfieldLeft35": "ミッドフィールド左",
        "midfieldCentreLeft35": "ミッドフィールド中央左",
        "midfieldCentre35": "ミッドフィールド中央",
        "midfieldCentreRight35": "ミッドフィールド中央右",
        "midfieldRight35": "ミッドフィールド右",
        "ownGoalArea": "自陣ゴールエリア",
        "ownBoxLeft": "自陣ペナルティエリア左",
        "ownBoxCenter": "自陣ペナルティエリア中央",
        "ownBoxRight": "自陣ペナルティエリア右",
        "ownFieldOutOfBoxDeepLeft": "自陣エリア外左深部",
        "ownFieldOutOfBoxDeepRight": "自陣エリア外右深部",
        "ownFieldOutOfBoxLeft": "自陣エリア外左",
        "ownFieldOutOfBoxCentreLeft": "自陣エリア外中央左",
        "ownFieldOutOfBoxCentre": "自陣エリア外中央",
        "ownFieldOutOfBoxCentreRight": "自陣エリア外中央右",
        "ownFieldOutOfBoxRight": "自陣エリア外右"
      },
      outcomes: {
        "success": "成功",
        "fail": "失敗",
        "possessionWon": "ボール奪取",
        "possessionNotWon": "ボール奪取失敗",
        "received": "受け取り",
        "provoked": "誘発"
      }
    },    
    share:{
      shareTo:"Send to",
      viaApp: "App (Driblab Message)",
      viaEmail: "Email",
      description: "Description",
      titleTab: "Shares",
      toMe:"受領",
      fromMe:"送信済み",
      typeInternal:"Internal",
      typeExternal:"External",
      title: "共有された",
      subtitle: "共有リストのアイテムの概要",
      selectUser: "ユーザーを選択",
      expired:"期限切れ",
      limitReached:"リンクが使用制限に達しました"
    },
    homeStats: {
      data: "利用可能なデータ",
      players: "選手",
      totalPlayers: "全選手",
      teams: "チーム",
      totalTeams: "全チーム",
      leagues: "リーグ",
      totalLeagues: "全リーグ",
      seasons: "シーズン",
      totalSeasons: "全シーズン",
      games: "ゲーム",
      totalGames: "全ゲーム"
    },
    scoutingCalendar: {
      subtitle: "スカウトタスクを作成し、整理する",
      myCalendars: "プライベートカレンダー",
      publicCalendars: "公開カレンダー",
      otherCalendars: "その他のカレンダー",
      calendarSettings: "カレンダー設定",
      moreInfo: "詳細情報",
      individualScouting: "個別スカウティング",
      matchScouting: "試合スカウティング",
      calendarView: {
        type: "カレンダータイプ",
        month: "月",
        week: "週",
        day: "日"
      },
      weekView: {
        type: "週の種類",
        monSun: "月曜日 - 日曜日",
        sunSat: "日曜日 - 土曜日",
        monFri: "月曜日 - 金曜日"
      },
      tasks: {
        addNew: "新しいタスクを追加",
        myTasks: "私のタスク",
        filterTasks: "タスクをフィルターする",
        sharedWithMe: "私と共有されている",
        createTask: "タスクを作成",
        newTask: "新しいタスク",
        taskName: "タスク名",
        allDay: "終日",
        startDate: "開始日",
        endDate: "終了日",
        startHour: "開始時間",
        endHour: "終了時間",
        assignedTo: "割り当て先",
        assignedToMe: "私に割り当てられた",
        color: "色",
        scoutingType: "スカウトの種類",
        taskLocation: "タスクの場所",
        selectLeague: "リーグを選択",
        selectMatch: "試合を選択",
        useMatchdate: "試合日を使用する",
        stadium: "スタジアム",
        travel: "移動",
        hotel: "ホテル",
        tickets: "チケット",
        taskNotes: "タスクに関連する説明的なノートまたはコメントを入力してください",
        states: {
          toDo: "未着手",
          inProgress: "進行中",
          done: "完了"
        },
        type: {
          player: "選手評価",
          team: "チーム評価",
          other: "その他"
        },
        location: {
          stadium: "スタジアム内",
          video: "ビデオ"
        },
        accommodation: {
          accommodationDetails: "宿泊詳細",
          ownArrangement: "自分で手配",
          required: "必要",
          notRequired: "不要",
          booked: "予約済み"
        },
        assignToMe: "私に割り当てる",
        addOther: "他を追加",
        deleteTask: "タスクを削除",
        deleteTaskMessage: "タスクは削除されます、よろしいですか？",
        cancelUpdate: "更新をキャンセル",
        cancelUpdateMessage: "変更は保存されません、よろしいですか？",
        selectGame: "ファイルを追加する試合を選んでください",
        noData: "データがありません。タスクを追加して始めましょう！",
        widgetSubtitle: "次のタスクを確認してください",
        scoutingDetails: "スカウティングの詳細",
        taskDetails: "タスクの詳細",
        playerDocuments: "選手の書類",
        teamDocuments: "チームの書類",
        gameDocuments: "試合の書類",
        taskDocuments: "タスクの書類",
        task: "タスク"
      },
      nextGames: "次の試合",
    },
    scoutingTasksBoard: {
      period: {
        week: "今週",
        month: "今月",
        year: "今年",
      },
      noTasks: "新しいタスクを作成するか、ここにドラッグしてください！",
      goToBoard: "ボードに行く"
    },
    profile: {
      title: "プロフィール",
      subtitle: "アカウントとサブスクリプションの詳細をカスタマイズする"
    },
    hub: {
      onlyHub: "Driblab Hubでのみ利用可能"
    },
    uploadedGames: {
      subtitle: "アップロードされた試合映像",
      timeRequested:"更新日時",
      timeReceived:"When it was received",
      diffHours:"Difference in hours",
      collectionCompleted: "Collection completed",
      dateFrom:"Date from",
      dateTo:"Date to",
      goToUploadedGames: "アップロードされた試合に移動",
      sla: "サービスレベル合意",
      matchDate: "試合日",
      rejectedGame: "却下"
    },
    gameMap: {
      title: "ゲームマップ",
      subtitle: "翌日の試合を探る",
      warning: "時間と場所が正しくない可能性があります。この情報を確認してください。",
      taskAdded: "タスクが正常に作成されました。Scouting Calendarを確認してください。"
    },
    leagueRequestAccess: {
      sendSuccess: "正常に通知されました",
      notPermissions: "閲覧する権限がありません",
      notPermissionsLeague: "このリーグを閲覧する権限がありません",
      notPermissionsGame: "この試合を閲覧する権限がありません",
      requestAccessTo: "アクセスをリクエストする",
      sendRequest: "リクエストを送信",
    },
    videoTeams: {
      subtitle: "チーム別にタグ付けされた最新の試合を見つける",
      noGamesUploaded: "まだ試合はアップロードされていません"
    },
    scoutingAnalysis: {
      scoutingAnalysis: "スカウティング分析",
      scoutingAnalyses: "スカウティング分析",
      analyses: "分析",
      addReport: "分析を追加",
      technical: "技術的",
      tactical: "戦術的",
      physical: "身体的",
      mental: "心理的",
      technicalNotes: "技術的なメモ",
      tacticalNotes: "戦術的なメモ",
      physicalNotes: "身体的なメモ",
      mentalNotes: "心理的プロファイルのメモ",
      conclusion: "結論",
      charactersMax: "最大1000文字",
      globalRating: "総合評価",
      noData: "データなし。スカウティング分析の追加から始めましょう！",
      deleteAnalysis: "スカウティング分析を削除",
      deleteAnalysisMessage: "分析は完全に削除されます。よろしいですか？",
      avgTooltip: "あなたに表示される分析の最終評価に基づく平均",
      avgOverallScoreTooltip: "平均はあなたが見ることができる選手の全体的なスコアに基づいています",
      scouter: "スカウター",
      lastEdited: "最終編集",
      analysisFilters: "分析フィルター",
      generalFilters: "一般フィルター",
      widgetSubtitle: "追加された最新の分析",
      addPlayerReport: "選手のスカウティング分析を追加",
      seeReports: "レポートを見る"
    },
    addPlayerForm: {
      noLeague: "リーグなしでチームを作成すると、そのインデックス作成とアプリケーション内での後の検索に悪影響を及ぼす可能性があります。"
    },
    expenses: {
      expense: "費用",
      expenses: "経費",
      addExpense: "費用を追加",
      transportation: "交通",
      accommodation: "宿泊",
      dietary: "食事",
      eventTicket: "イベントチケット",
      expenseType: "費用の種類",
      amount: "金額",
      expenseDate: "費用の日付",
      expenseFilters: "経費フィルター",
      noData: "データがありません。経費を追加して始めましょう！",
      deleteExpense: "経費を削除",
      deleteExpenseMessage: "経費は永久に削除されます。本当によろしいですか？"      
    },
    disabledTooltips: {
      general: "この機能は現在無効です",
      youth: "年齢を設定するにはユースである必要があります",
      unit: "統計はRuns、HSR、またはSPRでなければなりません",
      seasonsWithout60MinsGames: "選択されたシーズンで、選手は1試合で60分以上プレーしていません",
      notEditable: "これは編集できません",
      noMatchdate: "試合日が利用できません",
      selectGame: "まず試合を選択してください",
      selectPlayer: "まず選手を選択してください",
      selectTeam: "まずチームを選択してください",
      selectBoxes: "ボックスの可視化を選択する必要があります",
      selectYear: "まず年を選択してください",
      pdScoreNotAvailable: "スコアは利用できません。選手が試合で60分間プレーしていないためです。",
      pdSeasonNotAvailable: "今シーズンのフィジカルデータは利用できません",
      pdGameNotAvailable: "この試合のフィジカルデータは利用できません",
    },
    leagueTypes: {
      regular: "レギュラー",
      continental: "大陸",
      nationalTeam: "ナショナルチーム",
      countryCup: "国内カップ",
      qualifier: "予選",
      playOff: "プレーオフ",
      regionalLeague: "地域リーグ",
      friendly: "親善試合",
      nationalFriendly: "国内親善試合",
      nationaQualifier: "国内予選",
    },
    playerSides:{
      "Left/Right":"左/右",
      "Left/Centre/Right":"左/中央/右",
      "Right":"右",
      "Centre":"中央",
      "Centre/Right":"中央/右",
      "Left":"左",
      "Left/Centre":"左/中央"
    },
    areaSelector: {
      selectAreas: "エリアを選択",
      filterAreas: "エリアを絞り込む",
    },
    spatialCoverage:{
      lastDefenderDist: "最後のディフェンダーの距離",
      defensiveLineDist: "ディフェンスラインの距離",
      fullBackAvgDist: "平均横方向距離",
      offensiveLineDist: "オフェンスラインの距離",
      distanceToGoal: "ゴールまでの距離",
      avgLineWidth: "平均線幅",
      leagueAvgDistanceToGoal: "リーグ平均ゴール距離",
      leagueAvgLineWidth:"リーグ内の平均ライン幅",
      meters:"メートル",
      leagueAvgDist: "リーグ平均距離",
      distance: "距離",
      avgPositionYAxis: "Y軸上の平均位置",
      leagueAvgPositionYAxis: "Y軸上のリーグ平均順位"
    }

  }



// WEBPACK FOOTER //
// ./src/utils/translations/jp.js